var _path, _path2, _g, _path3, _path4, _g2, _circle, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _path10, _path11, _path12, _line, _line2, _g5, _g6, _path13, _line3, _path14, _path15, _g7, _g8, _path16, _line4, _path17, _g9, _g10, _circle2, _g11, _g12, _path18, _g13, _g14, _g15, _g16, _g17, _path19, _path20, _path21, _g18, _path22, _g19, _ellipse, _path23, _g20, _path24, _g21, _g22, _g23, _g24, _g25, _g26, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g27, _path33, _g28, _g29, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g30, _path41, _path42, _path43, _polygon, _polygon2, _path44, _path45, _line5, _polygon3, _path46, _polygon4, _path47, _path48, _g31, _path49, _path50, _g32, _path51, _g33, _path52, _g34, _ellipse2, _path53, _g35, _g36, _g37, _g38, _g39, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _g40, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path61, _path62, _path63, _g41, _g42, _g43, _path64, _g44, _g45, _path65, _path66, _path67, _path68, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _g46, _path69, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _path70, _g47, _circle35, _circle36, _circle37, _circle38, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _g48, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _circle95;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmblemOfTheUsDepartmentOfTheArmy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 500,
    viewBox: "-1 -1 501 501",
    width: 500,
    zoomAndPan: "magnify",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {}
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m250 499.99c138.07 0 250-111.93 250-249.99 0-138.07-111.93-250-250-250s-250 109.84-250 249.99c0 138.07 111.93 250 250 250z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m250.46 66.312a183.95 183.95 0 0 0 -183.95 183.96 183.95 183.95 0 0 0 183.95 183.95 183.95 183.95 0 0 0 183.96 -183.95 183.95 183.95 0 0 0 -183.96 -183.96z",
    fill: "#9ebbd9",
    transform: "matrix(1.002,0,0,1.002,-1,-1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.6785
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.749,
    cy: 81.554,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.244,
    cy: 90.743,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.632,
    cy: 99.639,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.403,
    cy: 108.99,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.798,
    cy: 118.45,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.437,
    cy: 128.61,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.766,
    cy: 138.76,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.75,
    cy: 148.84,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.998,
    cy: 159.68,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.768,
    cy: 170.83,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.186,
    cy: 181.88,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.123,
    cy: 193.2,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.484,
    cy: 205.39,
    r: 5.2971
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.537,
    cy: 217.34,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.196,
    cy: 229.48,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.91,
    cy: 242.48,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.22,
    cy: 11.662,
    r: 5.2968
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230.97,
    cy: 12.33,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 218.66,
    cy: 14.144,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.26,
    cy: 15.932,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.52,
    cy: 18.376,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.28,
    cy: 21.31,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.53,
    cy: 24.673,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 162.41,
    cy: 28.751,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.44,
    cy: 33.416,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.99,
    cy: 38.48,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.7,
    cy: 44.113,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.08,
    cy: 50.646,
    r: 5.296
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.11,
    cy: 57.515,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.42,
    cy: 64.951,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.94,
    cy: 73.04,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 417.54,
    cy: 81.323,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.34,
    cy: 72.828,
    r: 5.2958
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.08 69.319c2.2602 1.855 5.5981 1.5288 7.4531-0.73145 1.856-2.2607 1.5298-5.5981-0.7295-7.4546-2.2627-1.856-5.6001-1.5283-7.4551 0.73193-1.8564 2.2603-1.5288 5.5981 0.73145 7.4541z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390.08,
    cy: 58.006,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 380.61,
    cy: 51.412,
    r: 5.2959
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.44,
    cy: 45.061,
    r: 5.297
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.29,
    cy: 39.399,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.2,
    cy: 34.395,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.36,
    cy: 29.654,
    r: 5.2971
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 328.21,
    cy: 25.435,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 317.15,
    cy: 21.865,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.82,
    cy: 18.813,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293.63,
    cy: 16.187,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.68,
    cy: 14.252,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 269.54,
    cy: 12.923,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.54,
    cy: 11.651,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.16,
    cy: 243.28,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 486.92,
    cy: 230.47,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.09,
    cy: 218.16,
    r: 5.2956
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.29,
    cy: 206.76,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.83,
    cy: 195.03,
    r: 5.2971
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.89,
    cy: 183.79,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 474.51,
    cy: 173.04,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470.43,
    cy: 161.93,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 465.75,
    cy: 150.97,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.67,
    cy: 140.52,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 455.03,
    cy: 130.23,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.49,
    cy: 119.62,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.61,
    cy: 109.66,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.03 103.29c1.8291 2.2808 5.1631 2.6475 7.4448 0.81738 2.2808-1.8301 2.6489-5.1636 0.81884-7.4453-1.8325-2.2817-5.1646-2.6475-7.4453-0.81738-2.2832 1.8301-2.6489 5.1631-0.81836 7.4453z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.06,
    cy: 90.506,
    r: 5.297
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418.01,
    cy: 417.21,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 426.51,
    cy: 408.01,
    r: 5.296
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.1,
    cy: 399.1,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 441.32,
    cy: 389.74,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 447.91,
    cy: 380.27,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.26,
    cy: 370.1,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 459.91,
    cy: 359.94,
    r: 5.296
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 464.91,
    cy: 349.85,
    r: 5.2958
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 469.65,
    cy: 339,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 473.87,
    cy: 327.85,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.43,
    cy: 316.8,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.48,
    cy: 305.47,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.1,
    cy: 293.28,
    r: 5.2957
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 485.03,
    cy: 281.32,
    r: 5.2968
  }), /*#__PURE__*/React.createElement("path", {
    d: "m481.08 268.72c-0.25831 2.9131 1.896 5.4849 4.81 5.7436 2.9106 0.25733 5.4854-1.8945 5.7437-4.8091 0.25634-2.9141-1.8955-5.4849-4.8101-5.7422-2.9126-0.25879-5.4849 1.8945-5.7436 4.8076z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 487.62,
    cy: 256.18,
    r: 5.2957
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.08,
    cy: 487.89,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.89,
    cy: 486.65,
    r: 5.2975
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.2,
    cy: 484.81,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 292.6,
    cy: 483.01,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.33,
    cy: 480.55,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.57,
    cy: 477.6,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 326.32,
    cy: 474.22,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.43,
    cy: 470.13,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.39,
    cy: 465.45,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 358.83,
    cy: 460.37,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.12,
    cy: 454.72,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 379.73,
    cy: 448.17,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.69,
    cy: 441.29,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 399.37,
    cy: 433.84,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408.84,
    cy: 425.73,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.859,
    cy: 416.56,
    r: 5.2956
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 425.11,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.853,
    cy: 432.77,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.16,
    cy: 440.06,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 117.59,
    cy: 446.71,
    r: 5.2968
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.71,
    cy: 453.13,
    r: 5.2962
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.83,
    cy: 458.86,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.88,
    cy: 463.93,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.7,
    cy: 468.75,
    r: 5.2967
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.82,
    cy: 473.04,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.85,
    cy: 476.68,
    r: 5.297
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192.15,
    cy: 479.81,
    r: 5.2968
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.33,
    cy: 482.52,
    r: 5.296
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.27,
    cy: 484.53,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 228.96,
    cy: 487.06,
    r: 5.2964
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.74,
    cy: 488.16,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.434,
    cy: 255.82,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.035,
    cy: 267.51,
    r: 5.2961
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.224,
    cy: 279.27,
    r: 5.297
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.947,
    cy: 290.68,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.325,
    cy: 302.43,
    r: 5.297
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.195,
    cy: 313.69,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.497,
    cy: 324.46,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.513,
    cy: 335.6,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.115,
    cy: 346.59,
    r: 5.2966
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.121,
    cy: 357.07,
    r: 5.2971
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.695,
    cy: 367.4,
    r: 5.2963
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.168,
    cy: 378.06,
    r: 5.2969
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.981,
    cy: 388.06,
    r: 5.2971
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.361,
    cy: 397.79,
    r: 5.2965
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.397,
    cy: 407.32,
    r: 5.2968
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3285
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.84,
    cy: 116.67,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.11,
    cy: 123.94,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.08,
    cy: 130.98,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.362,
    cy: 138.38,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.135,
    cy: 145.87,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.1,
    cy: 153.91,
    r: 4.1925
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.611,
    cy: 161.94,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.642,
    cy: 169.92,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.881,
    cy: 178.5,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.533,
    cy: 187.33,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.698,
    cy: 196.07,
    r: 4.1924
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.274,
    cy: 205.03,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.185,
    cy: 214.68,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.644,
    cy: 224.14,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.583,
    cy: 233.74,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.566,
    cy: 244.03,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.63,
    cy: 61.354,
    r: 4.1927
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 234.94,
    cy: 61.881,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 225.2,
    cy: 63.317,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.17,
    cy: 64.733,
    r: 4.1928
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.89,
    cy: 66.668,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.98,
    cy: 68.99,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 189.48,
    cy: 71.651,
    r: 4.1913
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.68,
    cy: 74.878,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 172,
    cy: 78.57,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.73,
    cy: 82.579,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.58,
    cy: 87.036,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 147.17,
    cy: 92.207,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.73 101.05c1.8784-1.353 2.3057-3.9712 0.95508-5.8501-1.3516-1.8799-3.9722-2.3076-5.8511-0.95752-1.8799 1.354-2.3076 3.9722-0.95508 5.8511 1.3516 1.8799 3.9712 2.3081 5.8511 0.95654z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.62,
    cy: 103.53,
    r: 4.1913
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.11,
    cy: 109.93,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.6,
    cy: 116.49,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.32,
    cy: 109.76,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.27,
    cy: 103.75,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.87,
    cy: 98.032,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.37,
    cy: 92.813,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.32,
    cy: 87.787,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 337.29,
    cy: 83.306,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 329.3,
    cy: 79.345,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320.72,
    cy: 75.593,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 311.89,
    cy: 72.253,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 303.15,
    cy: 69.429,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 294.18,
    cy: 67.013,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 284.53,
    cy: 64.935,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.07,
    cy: 63.403,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 265.47,
    cy: 62.352,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.18,
    cy: 61.344,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.49,
    cy: 244.67,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.51,
    cy: 234.53,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.06,
    cy: 224.79,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.64,
    cy: 215.77,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.69,
    cy: 206.48,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.36,
    cy: 197.58,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.69,
    cy: 189.08,
    r: 4.1905
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.45,
    cy: 180.28,
    r: 4.1911
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.75,
    cy: 171.6,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.74,
    cy: 163.34,
    r: 4.193
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 412.27,
    cy: 155.2,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 407.09,
    cy: 146.79,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.65,
    cy: 138.91,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.75,
    cy: 131.25,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.34,
    cy: 123.75,
    r: 4.1924
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.97,
    cy: 382.32,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.69,
    cy: 375.04,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 395.71,
    cy: 367.99,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 401.42,
    cy: 360.58,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 406.63,
    cy: 353.08,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.06 342.89c-1.1846 1.9873-0.53516 4.5615 1.4497 5.748 1.9902 1.1856 4.565 0.5376 5.7505-1.4507 1.1856-1.9883 0.53614-4.5615-1.4512-5.7471-1.9883-1.1865-4.5606-0.5376-5.749 1.4497z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.13,
    cy: 337,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.09,
    cy: 329.01,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.84,
    cy: 320.43,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 427.18,
    cy: 311.6,
    r: 4.1927
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 302.85,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432.41,
    cy: 293.88,
    r: 4.1911
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 434.49,
    cy: 284.24,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.01,
    cy: 274.78,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 437.06,
    cy: 265.17,
    r: 4.1922
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 438.06,
    cy: 254.88,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.81,
    cy: 438.26,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.95,
    cy: 437.28,
    r: 4.1926
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 274.69,
    cy: 435.83,
    r: 4.1925
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.71,
    cy: 434.4,
    r: 4.191
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 293,
    cy: 432.45,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.9,
    cy: 430.12,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 310.4,
    cy: 427.44,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 319.19,
    cy: 424.2,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 327.87,
    cy: 420.5,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.14,
    cy: 416.48,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 344.28,
    cy: 412.01,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.67,
    cy: 406.83,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.56,
    cy: 401.38,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.22,
    cy: 395.48,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.71,
    cy: 389.07,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.13,
    cy: 381.8,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123.37,
    cy: 388.58,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.38,
    cy: 394.64,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.74,
    cy: 400.4,
    r: 4.1917
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.2,
    cy: 405.67,
    r: 4.1915
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 153.21,
    cy: 410.75,
    r: 4.1916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.22,
    cy: 415.29,
    r: 4.1924
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.18,
    cy: 419.3,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.74,
    cy: 423.11,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186.54,
    cy: 426.51,
    r: 4.1919
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 195.27,
    cy: 429.39,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 204.22,
    cy: 431.87,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.85,
    cy: 434.01,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 223.3,
    cy: 435.61,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.34,
    cy: 437.61,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.25,
    cy: 438.48,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.98,
    cy: 254.59,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.456,
    cy: 263.84,
    r: 4.192
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.396,
    cy: 273.15,
    r: 4.1914
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.76,
    cy: 282.18,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.642,
    cy: 291.48,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.914,
    cy: 300.39,
    r: 4.1923
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.528,
    cy: 308.92,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.705,
    cy: 317.73,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.347,
    cy: 326.43,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.309,
    cy: 334.73,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.72,
    cy: 342.9,
    r: 4.1918
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.844,
    cy: 351.33,
    r: 4.1924
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.235,
    cy: 359.25,
    r: 4.1921
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.08,
    cy: 366.95,
    r: 4.1924
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.44,
    cy: 374.49,
    r: 4.1923
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m293.48 390.29l-12.7 2.99s2.8 9.34 2.8 10.84c0 0 4.68-1.16 5.6-1.32 6.7-1.11 5.61 4.31 0.94 4.86-0.05 0.01-5.42 0.75-5.42 0.75 0.37 2.43 0.56 2.9 0.75 4.49 0.46-0.05 7.19-1.52 7.47-1.68 7.67-2.06 7.66-13.09-2.43-12.34-0.93 0.19-3.17 0.75-3.17 0.75-0.75-2.24-0.75-3.36-0.75-3.36l8.03-1.87-1.12-4.11zm-74.75 2.61l-5.24 20.93 4.86 1.5 5.61-21.31-5.23-1.12zm52.97 0.77l-15.97 1.85 0.52 4.45 9.84-1.13c-2.55 2.36-5.26 11.51-4.49 18.2 2.6-0.3 3.36-0.13 5.2-0.47-0.15-6.19-0.06-10.47 5.39-18.63l-0.49-4.27zm-40.16 0.93l-0.22 4.48 9.89 0.5c-2.9 1.91-7.08 10.49-7.42 17.21 2.62 0.13 3.36 0.43 5.23 0.4 0.87-6.13 1.64-10.34 8.36-17.49l0.22-4.29-16.06-0.81z",
    fill: "#c50025",
    transform: "matrix(1.002,0,0,1.002,-1,-1)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m194.3 158.36c23.342-4.1235 43.9-26.177 2.5166-35.333-45.187-9.9946-8.6396-63.321 108.99-26.965 28.915 8.937 25.088 38.809-9.7368 27.527-2.8091-1.7041-42.533-19.446-61.509-18.575-10.303-0.59375-12.71-0.72364-17.462-0.37256-5.9775 1.2847-16.917 6.5644-14.661 13.143 2.9263 4.0625 18.566-1.7876 21.689-3.7974 3.3638-2.1611 8.1274-1.916 13.515-1.4146 3.0103 0.28125 6.4609 1.0083 10.488 2.2153 11.236 3.3701 27.275 8.7456 40.075 14.98 23.19 11.299 56.041 1.4272 48.937-17.691-2.2817-6.1392-5.9409-13.232-20.847-20.885-12.51-6.4224-37.885-13.278-64.267-14.734-25.078-1.3833-50.518 1.1504-64.57 9.8657-29.587 18.351-19.101 37.453 5.6186 42.695 24.578 5.2139 29.888 15.235 1.2285 29.34z",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 0.83916,
    fill: "#b9a400"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.83916,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248.15 106.57c5.666 1.2578 3.707 9.3013 8.3228 10.839 4.6157 1.5386 10.491-5.7349 14.477-4.1958 3.9868 1.5391 2.728 10.352 6.3647 11.679 3.6367 1.3291 12.519-4.3354 14.967-3.2168 2.4746 1.1314 4.1265 11.049 9.0225 12.168 4.8955 1.1186 8.3926-7.3428 12.239-7.9717 3.8467-0.62989 10.91 6.3638 14.058 4.9648 7.8316-3.48-3.8467-10.141-2.7978-13.218 1.0488-3.0767 13.078-3.4268 11.26-8.2524-1.8179-4.8272-13.219-2.0991-15.247-4.2671-2.0278-2.1675 3.148-9.5112 0.23292-11.249-4.2466-2.5303-9.8843 4.0454-15.243 2.2119-5.3584-1.8345-1.146-9.8442-6.3916-11.384-5.2446-1.5381-10.91 6.5742-15.456 5.4556-4.5454-1.1191-4.8257-10.282-9.5815-11.19-4.7568-0.91016-7.6235 7.6235-12.17 6.9233-4.8867-0.75195-5.1045-9.1611-10.49-9.4414-5.3848-0.27881-5.6646 7.4849-10.281 7.3438-4.6157-0.13867-5.5259-7.6226-9.3018-7.4834-3.7764 0.13965-5.1753 7.2734-9.1621 7.6245-3.9858 0.34766-8.1826-6.2959-11.681-5.667-3.4966 0.63037-4.3354 7.8335-7.4824 8.6729-3.148 0.83984-8.2534-4.5459-11.26-3.2168-3.0078 1.3286-1.5391 7.9722-3.917 9.4424-2.3789 1.4678-6.7144-3.2881-8.9526-1.1899-2.2378 2.0986 2.6582 6.2944 1.1191 8.1133-1.5391 1.8193-9.2324 0.76904-10.211 3.2871-0.97901 2.5176 7.2046 4.4058 7.6934 6.5747 0.49023 2.1665-7.4121 5.2446-5.5244 8.2515 1.8877 3.0078 9.1616-2.0268 10.98-0.69922 1.8179 1.3291-1.3989 8.2539 2.5166 9.5816 3.918 1.3301 5.666-5.315 8.3237-4.6157 2.6577 0.7002 2.7978 7.5537 4.6157 8.1123 1.8188 0.56006 5.2466-5.3843 7.2036-4.7554 1.959 0.62988 0.56006 7.5532 2.2388 8.6035 1.6777 1.0488 8.0434-3.2168 9.1626-1.8892 2.7119 3.2212-3.9878 6.5737-3.9878 8.8125 0 2.5283 4.6157 4.1968 2.7988 6.1548-1.2124 1.3042-5.9795 0.24853-7.0644 1.189-1.0503 0.90869-0.21045 4.3354-1.3291 4.8955-0.57032 0.28467-3.124-0.89648-4.794-0.15674-1.6035 0.70899-2.3193 3.3423-3.0396 3.5137-1.4692 0.3501-1.959-0.6289-0.34912-1.5391 1.0127-0.57226 2.7978 0.7002 4.1968 0.14014 1.3979-0.55908 1.7471-3.917 2.727-4.6157 0.979-0.70019 3.8467 1.189 5.1758 0.34913 1.3286-0.83936-0.56006-4.895 0.48877-6.2949 1.0498-1.398 6.8545-0.83886 7.6948-3.6357 0.8374-2.7964-6.9248-2.4487-8.0439-3.9165-1.1187-1.4692 2.3081-7.8325 0-9.0928-2.3076-1.2588-6.0156 4.687-7.9736 3.917-1.959-0.76905-0.979-7.5537-3.2866-8.1826-2.3076-0.62988-5.3857 5.4546-7.9351 4.9658-2.5508-0.48877-2.2764-7.6938-4.3042-8.5327-2.0278-0.83984-7.0649 4.8247-9.5127 3.2871-2.4478-1.5391 2.2393-7.9028 0.91016-9.9307-1.3301-2.0288-10.002 0-10.421-2.4478-0.41992-2.4487 8.3237-3.7778 8.5322-5.8755 0.21044-2.0982-4.4067-7.6938-3.1465-9.1616 1.2588-1.4688 6.9936 2.0278 8.7412 0.34912 1.75-1.6782-1.1875-7.1338 0.84033-8.6016 2.0288-1.4688 8.7422 2.4478 11.19 1.4678 2.4478-0.979 3.0064-8.2524 5.6655-9.0215 2.6577-0.77002 8.1826 4.9648 11.19 4.4756 3.0068-0.48877 6.4336-7.832 9.4404-8.1123 3.0078-0.28027 6.6445 6.6436 10.002 6.6436 3.3564 0 5.5947-7.4126 9.1611-7.4126 3.5684 0 6.3648 8.0425 9.5816 8.3228 3.2178 0.27978 8.1138-7.4839 12.17-6.9937 4.0566 0.48877 5.8047 9.4404 9.3716 10.14 3.5669 0.69922 10.7-6.9932 14.617-6.1543 3.9165 0.83984 5.1758 10.77 8.5322 11.68 3.3579 0.90869 11.19-6.1558 14.967-4.5469 3.7768 1.6089 1.749 10.142 4.0566 11.47 2.3091 1.3291 11.821-2.8677 14.128-0.55957 2.3081 2.3076-5.3857 8.7422-4.4058 11.54 0.97802 2.7978 15.036 4.126 13.148 10.07-1.3188 4.1528-13.778-0.20898-16.156 1.6792-2.3789 1.8877-1.6787 10.98-6.3647 11.469-6.0146 0.62744-8.8125-8.2524-11.75-8.8115-2.9365-0.56006-12.099 5.6646-15.666 3.9858-3.5664-1.6782-2.2378-10.63-5.6646-12.029-3.4268-1.3989-11.122 4.9668-15.107 3.5679-3.9868-1.3989-2.6582-10.071-6.2949-11.26s-12.1 5.2446-14.757 4.4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.43 117.79c4.2383 0.18262 6.3374-3.5928 10.673-3.1738",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.16 109.72c-1.8193-0.28028-3.917 2.6567-5.0356 2.7978-1.1201 0.13867-2.7983 0.55859-3.2183-0.28028-0.39942-0.80029 0.70019-2.2378 2.5181-2.6577 1.8188-0.41992 4.0566 0.14014 6.9937 0.14014",
    strokeLinecap: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cy: 110.7,
    cx: 211.43,
    r: 1.0879,
    fill: "#7f7100"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m310.68 112.16c-0.88037-3.562-6.1455-6.876-16.383-8.811-2.4863-0.46973-7.669-0.90332-7.1768-1.0469 4.6567-1.3525 8.624-2.8687 8.624-2.8687s-6.8555-4.1709-11.662-6.6685c13.863 0.39258 30.377 5.5322 36.891 13.035 4.1392 4.7661 2.0459 5.3374-0.96973 6.3423-3.0137 1.0049-7.4658 0.42432-10.597-0.17529-8.8384-1.6924-21.373-8.1655-35.354-13.736-24.945-9.9395-54.772-19.294-75.362-12.28-11.22 3.8208-16.199 9.8848-16.919 15.721-1.1167 9.0361 7.9736 17.526 19.915 16.301-7.6548-3.8291-5.1177-11.299 1.1528-14.979 8.8286-5.1816 29.03-4.0264 61.02 7.6743l33.215 13.058s12.141 4.6992 19.974 1.5674c7.8335-3.1343 8.6172-7.4419 8.2251-10.185-0.3916-2.7412-2.3496-6.6567-2.3496-6.6567 0.89991 1.8232 0.0283 2.4126-0.91894 2.9434-4.127 2.3066-11.324 0.76416-11.324 0.76416z",
    stroke: "#e6e6e6",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    stroke: "#e6e6e6",
    strokeWidth: 1.3988
  }, /*#__PURE__*/React.createElement("path", {
    d: "m284.08 92.769c13.863 0.39258 30.49 5.4351 36.891 13.035 0.47168 0.56006 1.3965 1.6641 2.0186 2.8599 1.1245 2.1655-0.72802 2.729-2.9883 3.4824-3.0137 1.0049-7.4658 0.42431-10.597-0.17529-8.8384-1.6924-21.373-8.1655-35.354-13.736-24.945-9.9395-54.772-19.294-75.362-12.28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.69 117.98c-7.6548-3.8291-5.1177-11.299 1.1528-14.979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.08 92.769c13.863 0.39258 30.49 5.4351 36.891 13.035 0.47168 0.56006 1.3965 1.6641 2.0186 2.8599 1.1245 2.1655-0.72802 2.729-2.9883 3.4824-3.0137 1.0049-7.4658 0.42431-10.597-0.17529-8.8384-1.6924-21.373-8.1655-35.354-13.736-24.945-9.9395-54.772-19.294-75.362-12.28"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m209.71 108.58c1.6089-0.70019 7.4834-0.90918 9.7222-0.14111",
    stroke: "#7f7100",
    strokeWidth: 0.83916
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m242.72 125.55c6.0161 1.2578 3.6382 9.3984-2.3516 9.3984-9.5376 0-12.131-19.469 8.6318-14.979 13.856 2.9966 15.962 16.352 12.77 18.726 3.1919 0.28222 12.843 6.8569 9.7012 14.98l-46.193 0.375c1.1245-8.6138 8.4184-14.067 12.785-17.604 1.0205-0.82666 1.3008-1.5254 2.2808-1.5254 6.7134 0 8.1123-8.2524 2.3765-9.3716z",
    stroke: "#820018",
    strokeLinecap: "round",
    strokeWidth: 0.74828,
    fill: "#c50025"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m221.07 162.79c-0.37354-7.5073 2.4663-8.2466 6.5874-10.619 8.3135-4.7861 30.711-4.8672 39.325-1.4971 6.9644 2.7256 7.2422 5.8677 6.6196 13.055-0.84327 9.7769-19.825 9.7935-26.539 9.7935-17.904 0-25.737-5.5947-25.993-10.732z",
    stroke: "#820018",
    strokeWidth: 0.74828,
    fill: "#c50025"
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m254.44 246.86 34.245-55.424c1.2021-1.9492 3.9731-3.3662 5.791-4.3438l8.2061-15.817-9.9878-1.4985 19.477-29.961-10.12 26.257 11.527 1.6372-43.285 83.337-11.571 15.705h-17.625s-67.901-103.12-68.647-105c-2.8096 0.18311-4.6792-2.0659-4.2998-4.874-5.0581 0.36816-6.7451 1.4868-6.5361-14.616 15.34 4.9106 13.742 6.1548 11.789 10.833 2.7847 0.53174 4.3247 3.019 3.2598 5.6265 1.54 1.3018 68.682 89.115 68.682 89.115"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.18 256.19-68.165-97.509c-0.23925 0.11963-0.3706 0.11719-0.65625 0.11719-0.9834 0-1.7803-0.79687-1.7803-1.7803 0-0.35108 0.10156-0.67871 0.27783-0.95557-1.2954-1.5615-2.2383-1.3862-3.8818-3.0303-0.67334-0.67285-3.0396-6.6943-3.2881-7.2734-0.20996-0.49023-0.0698-0.83887 0.49023-0.28027 0.49414 0.49463 4.8164 5.0132 5.1753 5.5249 0.979 1.3989 0.90918 2.5879 2.2773 4.3906 0.25781-0.14307 0.41358-0.15674 0.72949-0.15674 0.9834 0 1.7808 0.79834 1.7808 1.7808 0 0.34863-0.0996 0.67383-0.27343 0.94824l69.482 96.616c0.83887 1.5391-0.83887 2.8672-2.168 1.6079z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.33 241.69 28.666-47.739c0.83887-1.1191 1.3989-2.2378 2.7979-3.0781l-29.654 50.915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m297.91 168.34 7.626 1.0903c0.9043 0.1084 1.0757 0.50244 0.67481 1.25l-50.057 92.786c-0.84033 1.6777 1.1177 2.5176 2.2368 0.83886l49.856-94.32c0.40869-0.88184 0.15234-1.2163-0.47559-1.3765l-7.7036-1.1167c-0.49805-0.0205-0.76123-0.33106-0.45068-0.97657l6.333-14.251-8.4761 15.099c-0.26611 0.49707-0.19629 0.91699 0.29346 0.98682"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m248.88 137.3c2.7964-0.7002 9.5361 0.55664 12.894 1.3955",
    stroke: "#820018",
    strokeLinecap: "round",
    strokeWidth: 0.74828,
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f84462",
    d: "m245.94 126.53c2.3765 1.959 0.57666 7.1255-1.6777 8.2534-2.5181 1.2588-10.213 10.63-8.814 14.127 1.959-1.1187 10.632-1.3989 12.169-1.3989 5.0356 0-2.02-4.0464-1.8188-6.0146 0.56103-5.4546 6.1558-6.8545 4.3369-11.05-3.5073-8.0933-6.5322-5.8408-4.1958-3.9165z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f84462",
    d: "m232.37 157.16c0.68213 0.854 14.692-1.6255 20.842-1.3975 3.7768 0.13964 3.7485-0.21338 0.70019-1.5391-3.2183-1.3999-7.2749-1.6792-12.031-1.3999-4.2261 0.25049-11.19 2.2388-9.5112 4.3364z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "m269.1 164.16c-2.2251-3.7588-10.363-4.8687-12.983-4.8687h-10.113c-6.2837 0-14.417 0.44287-18.85 5.3691-1.773 1.9688 13.333 5.1856 22.286 5.1856 8.9526 0 21.122-3.2168 19.661-5.686z",
    stroke: "#820018",
    strokeWidth: 1.119,
    fill: "#820018"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.72053,
    d: "m255.04 159.29 0.10059 81.276h-10.284l0.0713-81.206c0.66259-0.10401 6.832-0.0703 10.112-0.0703z",
    stroke: "#000"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.74828,
    y2: 161,
    x2: 249.61,
    stroke: "#404040",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    y1: 237.51,
    x1: 249.61,
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.74828,
    y2: 160.44,
    x2: 250.17,
    stroke: "#bfbfbf",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    y1: 236.95,
    x1: 250.17,
    fill: "none"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeLinecap: "round",
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    strokeWidth: 1.119
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254.34 253.17c0 2.4746-8.9707 3.7339-8.9707 6.1016-0.53516 0.83105-0.44239 6.9346 0 7.4844 0-2.3686 8.9707-3.6274 8.9707-6.1035 0.51709-1.0908 0.3916-8.2109 0-7.4824z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.34 245.68c0 2.4761-8.9707 3.7354-8.9707 6.103-0.53516 0.82959-0.44239 6.9336 0 7.4824 0-2.3677 8.9707-3.627 8.9707-6.1016 0.51709-1.0918 0.3916-8.2109 0-7.4839z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.37 266.75c0-2.3686 8.9707-3.6274 8.9707-6.1035 0.30908-0.57276 0.45264 3.7236 0.24609 6.1069l-9.2168-0.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.34 245.68c0 2.4761-8.9707 3.7354-8.9707 6.103-0.44239-0.54981-0.53516-6.6528 0-7.4839l8.9707 1.3809z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "237.06 244.05 233.81 239.1 248.15 240.02 251.85 240.02 266.19 239.1 262.94 244.05 266.19 249 251.92 248.09 248.08 248.09 233.81 249",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.119,
    y2: 242.46,
    x2: 240.24,
    y1: 242.46,
    x1: 259.76,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.119,
    y2: 245.64,
    x2: 259.76,
    y1: 245.64,
    x1: 240.24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 244.05,
    r: 4.897,
    strokeWidth: 0.74828,
    fill: "#b9a400"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m360.52 144.88-72.461 107.9 5.0112 3.21 22.674-22.784 31.987 18.296 7.7456 2.957 6.1455 4.2114 3.7349 4.2964 1.1201 3.8853h18.351l9.7383 9.3623c18.727-24.719 2.3228-109.18-17.905-125.07l-8.3081-18.403-7.8335 12.141z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 1.9977,
    y2: 133.89,
    x2: 368.35,
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    y1: 252.38,
    x1: 288.45,
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m331.39 212.62c0.18408 0.54297-0.33155 7.8901-1.165 8.6826-0.83204 0.79151-4.0513 6.457-4.104 7.7886 0.13623 0.51709 0.20215 0.82177 0.3125 1.0791 0.52637-1.9395 3.5532-7.6143 4.2261-8.6216 1.2739-1.9033 1.5718-8.5098 1.3325-8.977-0.42579-0.82471-0.95996-1.002-0.60205 0.0483z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m378.95 223.74c1.5117 7.9668-2.7632 22.304-7.3921 30.156l-0.65283-0.56592c4.9624-8.6284 8.2378-20.9 7.3062-27.231 0.0215-0.42139-0.35547-1.6748 0.16504-2.8062l0.57373 0.44726z",
    stroke: "#081b55",
    strokeLinecap: "round",
    strokeWidth: 0.2798,
    fill: "#fff"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "#081b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m371.26 253.49c0.70313 0.54638 0.104 1.6904-0.0225 2.1372-0.19336 0.68652-0.67871 1.4512-0.83936 0.89208-0.0786-0.27978-0.96386-0.93505-1.1211-0.85107-0.29346 0.15576-0.25977-0.47803 0.19336-1.0513 0.24365-0.31055 1.1382-1.6318 1.7896-1.127z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.32 253.9c0.28223 0.40527-0.66162 2.4297-0.92627 2.6206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.24 253.85c0.005 0.11523-0.38867 1.7456-1.0073 2.4072"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.15 253.81c0.0249 0.0781-0.6128 1.793-1.1411 2.2412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.88 253.59c-0.60986 0.0767-1.6631 1.6294-1.6079 2.0767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.93 253.68c-0.4292 0.14795-1.4307 1.7222-1.4565 2.0278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.01 253.76c-0.11524 0.0454-1.2896 1.687-1.3301 2.0552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.05 253.82c-0.0112 0.0859-1.0186 1.8599-1.2354 2.1138"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 253.55,
    cx: 371.23,
    r: 0.53628
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.11192,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m379.06 224.4c0.11865 0.92724-0.82764 1.7534-0.7959 2.1963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.23 226.18c0.0337 0.53223-0.8877 1.2783-0.87647 1.9839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.24 227.88c-0.0156 0.62012-0.91211 1.2017-0.94824 2.2256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.16 229.8c-0.0654 0.67383-0.9541 1.1606-1.0566 2.3193"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.96 231.7c-0.0859 0.71142-0.99805 1.5967-1.0977 2.2119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.65 233.84c-0.15039 0.84571-1.0942 1.6045-1.2466 2.3574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.24 236.03c-0.20557 0.8916-1.2183 1.7602-1.3794 2.4419"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.65 238.53c-0.22949 0.88086-1.2827 1.8008-1.6226 2.8433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.79 241.52c-0.44141 1.4092-1.3594 1.7036-1.7051 2.6987"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.66 244.94c-0.41211 1.1255-1.499 1.6709-1.8921 2.6011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.5 247.88c-0.48926 1.1865-1.6724 1.7388-2.0425 2.4976"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.96 251.29c-0.26904 0.54834-1.5176 1.0757-2.0518 2.041"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m361.69 262.74c6.9243-4.665 17.062-24.205 16.54-35.284l0.37403-5.0225-3.166 2.4253-28.627 21.277 0.38525 1.3345 3.334-1.5547 11.16 16.824z",
    stroke: "#081b55",
    strokeWidth: 0.2798,
    fill: "#081b55"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.55959,
    y2: 222.74,
    x2: 378.43,
    stroke: "#081b55",
    strokeMiterlimit: 10,
    y1: 246.08,
    x1: 346.94,
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#081b55",
    d: "m354.37 210.55c3.3828 1.0674 7.1719-0.02 2.8677-4.8403-2.1533-2.4106 2.938-12.289 13.842-0.96289 3.1079 3.229-1.1665 7.7612-4.3188 3.1084 0.46143 0.6626-1.354-2.6646-3.3296-4.6147-1.2319-0.8501-1.521-1.0478-2.1567-1.3188-0.89209-0.18164-2.8433 0.0488-3.2754 1.4712-0.0747 0.98926 2.5303 0.9834 3.1411 0.82227 0.65917-0.17383 0.90429 1.4463 1.5273 1.9272 0.34814 0.26856 0.70264 0.65479 1.0772 1.1743 1.0469 1.4497 0.51709 0.52393 1.4478 2.6352 1.6865 3.8228 6.895 4.2778 8.084 0.10498 0.38086-1.3413 0.69336-2.9629-0.34766-5.4951-0.875-2.1265-0.88379-1.6895-4.0444-3.854-3.0044-2.0557-5.8892-3.0723-8.6069-2.4048-5.7212 1.4048-6.7012 5.5156-4.1631 8.2886 2.5386 2.771 3.481 3.3174-1.7441 3.9585z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.2798
  }, /*#__PURE__*/React.createElement("path", {
    d: "m378.34 223.67c0.45703 0.32519 0.4043 0.46875 0.75879-0.30811 0.81738 0.59277 0.11182 1.7104 2.4814-2.5464-3.3814-0.21191-2.4614-0.38476-2.8237 1.0356-0.56006-0.1333-0.48536-0.18067-0.69092 0.60986",
    strokeMiterlimit: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.54 220.28-11.788 21.97-2.9448-1.6733 12.977-21.27c0.12842 0.0381 1.189 0.65137 1.7559 0.97314z",
    fill: "#081b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.75 242.25 12.862-10.175c0.49902-0.39502 1.188-0.49561 1.6484-0.57373l3.7793-3.3564-1.4995-1.373 7.8379-5.9717-5.6689 5.9141 1.7432 1.5605-19.921 17.677-4.3428 2.9966-3.0415-1.7275s3.6899-33.78 3.8408-34.346c-0.51221-0.22803-0.49756-1.0024-0.0132-1.7046-0.92823-0.39892-1.3858-0.27002 1.0566-4.4849 1.9126 2.7954 1.4521 2.9658 0.41552 4.0059 0.40088 0.41211 0.29493 1.2173-0.27783 1.7988 0.0713 0.49316-1.3638 28.087-1.3638 28.087",
    fill: "#081b55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.2 205.04c-7.6235 3.6084-17.163 15.435-21.021 23.654l0.86866 0.16065c4.3105-8.9395 12.706-18.769 18.603-21.844 0.34326-0.26758 1.896-1.6235 2.2695-1.8018l-0.72022-0.16944z",
    strokeLinecap: "round",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.6 205.37c-0.51269-0.22705-0.60889-0.1084-0.12305-0.81055-0.92822-0.39844-1.5268 0.78125 0.91651-3.4346 1.9131 2.7954 1.5908 1.916 0.55566 2.9546 0.40088 0.41357 0.40332 0.32519-0.16943 0.90576",
    strokeMiterlimit: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.7 228.68c-0.88135-0.20996-1.4878 0.93164-1.7896 1.2954-0.46289 0.55664-0.81836 1.3852-0.25049 1.1709 0.28467-0.10498 1.3652 0.17578 1.3877 0.34765 0.0439 0.31592 0.55762-0.0893 0.77246-0.77441 0.11523-0.37402 0.69531-1.8442-0.12012-2.0396z",
    strokeLinecap: "round",
    fill: "#081b55"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.16788,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m319.32 228.88c-0.51074 0.0259-1.6543 1.9556-1.6577 2.2695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.41 228.91c-0.10058 0.0645-1.2397 1.3389-1.4297 2.2061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.49 228.95c-0.0791 0.0274-1.146 1.5391-1.206 2.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.84 229.03c0.30029 0.5127-0.3794 2.2437-0.79053 2.4683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.73 229.04c0.13086 0.41553-0.59619 2.1191-0.83887 2.3213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.63 229.03c0.0293 0.11524-0.65235 1.9907-0.93946 2.2412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.55 229.03c-0.0654 0.0596-0.96094 1.8867-1.0444 2.2041"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    stroke: "#081b55",
    cy: 228.74,
    cx: 319.67,
    r: 0.53211,
    fill: "#081b55"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.11192,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m339.58 205.35c-0.85352 0.46436-0.98584 1.6802-1.3774 1.9185"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.97 206.29c-0.46826 0.29346-0.54638 1.4409-1.148 1.854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.53 207.29c-0.5127 0.38282-0.46729 1.4136-1.311 2.0537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.96 208.49c-0.52929 0.45362-0.40869 1.4224-1.3257 2.1914"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.48 209.79c-0.5498 0.48974-0.74951 1.7139-1.209 2.1587"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.85 211.3c-0.62305 0.61865-0.69873 1.792-1.2441 2.3574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.26 212.93c-0.62988 0.68799-0.75635 1.978-1.2339 2.5102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.5 214.87c-0.60743 0.70214-0.75342 2.0552-1.4297 2.9355"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.49 217.31c-0.9248 1.1772-0.62402 2.0537-1.2554 2.9116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.28 220.21c-0.70459 0.98682-0.51367 2.1411-1.0635 2.9966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.5 222.85c-0.70899 1.082-0.46729 2.3135-0.88526 3.0498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m320.54 226.07c-0.30371 0.5332-0.00098 1.8008-0.49658 2.7847"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    fill: "#081b55"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.11192
  }, /*#__PURE__*/React.createElement("path", {
    d: "m338.58 243.17-3.334-1.2124-2.7236 5.2656-2.8247 0.73731c-0.38428-1.1299 0.4209-4.7485-3.6846-4.0474-3.77 0.64356-5.0684-5.8906-4.6914-9.0498 1.9976-16.704 19.511-29.831 20.123-30.003 0.0869 1.3516-0.86084 37.191-0.86084 37.191-1.21 0.40185-2.0039 1.1186-2.0039 1.1186z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.99 235.82c-2.229 1.312-2.0674 2.7305-1.9321 4.206 0.104 1.1133-0.66699 2.5303-0.0312 3.3804l0.0767 0.19629c0.36133 0.17285 0.89063 0.48438 1.9067 0.31201 4.1562-0.70263 3.3018 2.9209 3.6846 4.0474l2.2148-0.55518 0.0298-0.38525c0.47754-2.3643 0.25635-6.7686-2.729-4.6768-2.8408 1.9907-3.5908 0.73974-3.709-0.54395-0.0444-0.46631 0.0752-2.7334 1.709-4.0015"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.44 213.07c-2.2075 2.4863-4.5254 5.5225-6.5796 9.0894-0.9541 1.6572-1.8516 3.4277-2.6543 5.3125 1.3359-0.54541 2.4976-1.8394 3.1367-1.6069 0.63672 0.23144-1.3315 3.5444-1.335 4.4541-0.003 0.90918 1.0073 6.9565 1.7998 7.6665 1.1494-0.51904 6.4302-3.6436 7.606-5.7119 1.1753-2.0684 3.5215-3.3418 6.4595-4.1484 0.12842-1.8818 0.59375-21.812 0.56348-23.264-0.18897 0.1709-4.3506 2.9697-8.9966 8.2085z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.58 238.53c0.81543-2.3379 2.2402-4.3955 3.979-4.9712l-0.55127-3.2451c-1.7373 0.57617-2.748 1.8272-3.562 4.1655l-0.11426 1.9556 0.24853 2.0952z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.9 233.34c-0.4751 0.42773-1.542 0.45801-2.1382 0.61621-1.6113 0.43017-2.2402 1.6372-3.4497 3.165-1.2104 1.5288-2.5347 3.8589-4.1186 4.3921 0 0-0.41113-0.33447-1.0107 0.11865 0 0-0.34326-0.0937-1.75 0.92578-0.96533 0.70117-1.3208-1.1406-1.0816-1.706 0.25293-0.59522 0.99366-1.3472 2.5786-1.8799 1.5854-0.5332 3.2598-2.5776 4.4702-4.1064 1.2095-1.5269 2.1431-2.8208 3.3589-3.3037 1.5107-0.60108 2.2393-0.68213 3.1245-1.041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.75 239.92c-1.2104 1.2803-2.6797 1.6133-3.9394 2.4365-0.0259 0.0161-0.0508 0.0327-0.0757 0.0488l0.0757-0.0488c0.0645 0.0361-1.5811-0.37696-1.5811-0.37696l-1.0737 2.0391c-0.0708-0.19287-0.0244-0.45948-0.0967-0.64356-0.0317-0.0781-0.15039-0.0723-0.19092-0.14551-0.17041-0.31201-0.73388-0.60205-0.41113-1.041 0.99365-1.3462 1.3066-1.6465 2.8013-2.6221 1.4936-0.97559 3.2812-1.2632 4.5864-3.2573"
  })), /*#__PURE__*/React.createElement("line", {
    strokeWidth: 0.2798,
    y2: 204.96,
    x2: 341.38,
    strokeMiterlimit: 10,
    y1: 242.01,
    x1: 340.54
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m364.66 250.32c0.23682-0.64355 1.8027-4.5234 2.3198-5.8838 0.51758-1.3604 2.0576-7.5107 2.8511-9.2832 1.4883-3.3232 3.375-6.522 5.5405-9.2192 1.2534-1.564 1.8745-2.4512 2.7021-3.4175l0.29444 1.1064c-1.1245 1.2192-2.7153 3.4854-3.5327 4.4453-1.6069 2.1064-3.1245 4.6616-4.3721 7.4346-0.79687 1.7715-2.3384 7.9297-2.8555 9.2905-0.51709 1.3594-2.083 5.2412-2.3213 5.8833",
    stroke: "#081b55",
    strokeLinecap: "round",
    strokeWidth: 0.2798,
    fill: "#fff"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.11192,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.76 228.1c-0.31933 0.4795 0.17969 1.1943-0.22119 1.832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.95 229.35c-0.31738 0.55761 0.30713 0.96533-0.27099 1.8921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.01 230.85c-0.29687 0.60742 0.25196 1.023-0.21435 1.936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.27 232.18c-0.29834 0.64258 0.1206 1.4297-0.16504 1.9814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.53 233.65c-0.37744 0.76318 0.0957 1.4824-0.20557 2.1792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.64 224.31c-0.68652 0.86035-0.40771 1.9644-0.84717 2.5474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.81 222.86c-0.30713 0.41455-0.31299 1.7798-0.61329 2.1738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m375.28 226.03c-0.68457 0.9419-0.18896 1.6836-0.77685 2.4736"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m369.6 235.75c-0.14453 0.45263 0.26074 1.3389 0.0801 1.9668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.94 237.79c-0.26661 0.89453 0.35351 1.3188 0.0845 2.2119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.18 240.39c-0.15137 0.54639 0.3916 1.2192 0.18994 1.8833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.66 242.21c-0.3418 1.1924 0.31396 1.6382-0.0439 2.5791"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.82 244.87c-0.3208 0.7915 0.15576 1.5244-0.0327 2.0259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.92 247.16c-0.17188 0.41357 0.27978 1.2783 0.0474 1.8272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.1 249.25c-0.28027 0.71582 0.23487 1.3008 0.0405 1.897"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "#081b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m365.04 250.46c-0.91992-0.0464-1.3174 1.0478-1.5532 1.4136-0.36279 0.56006-0.56689 1.3403-0.0376 1.0659 0.26563-0.1377 1.3955-0.0601 1.4497 0.0855 0.10156 0.27099 0.54199-0.16455 0.63037-0.79932 0.0483-0.34326 0.35987-1.7241-0.48926-1.7656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.69 250.69c-0.5044 0.104-1.2974 1.9726-1.2432 2.2495"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.79 250.7c-0.0879 0.0732-0.99609 1.3672-1.0273 2.1553"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.88 250.73c-0.0747 0.0376-0.86621 1.5288-0.80517 2.125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.24 250.74c0.39306 0.40088 0.0268 2.0225-0.34229 2.2842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.14 250.77c0.20654 0.34228-0.2124 1.9487-0.41894 2.1646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.03 250.78c0.0523 0.0962-0.28906 1.8452-0.52929 2.1094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.95 250.79c-0.0542 0.0635-0.61767 1.8042-0.64355 2.0947"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 250.51,
    cx: 365.01,
    r: 0.47589
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.2798
  }, /*#__PURE__*/React.createElement("path", {
    d: "m362.12 219.55c-0.38379-0.89892 3.0566-6.7305 0.20898-8.3486-2.8486-1.6167-7.0659 4.4297-7.9805 4.6894l7.7715 3.6592z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    y2: 216.8,
    x2: 359.15,
    y1: 211.2,
    x1: 362.33,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.23 217.91c1.0576-2.0098 1.6582-1.9277 2.7232-2.1465 2.1509-0.44385 6.0268 1.7295 7.0102 3.4604 0.79395 1.4004 0.37305 2.2539-0.8081 4.083-1.6055 2.4883-4.8843 0.63233-6.043-0.0259-3.0894-1.7549-3.605-3.9951-2.8823-5.3711z",
    strokeMiterlimit: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.87 223.72c-1.688 1.8452-4.6743 0.17383-5.7607-0.44336-2.5181-1.4307-3.3389-3.2148-3.1602-4.5581 0.56006-0.56152 1.0478-0.60742 1.7466-0.75195 2.1509-0.44385 6.0283 1.7295 7.0117 3.4614 0.48291 0.85254 0.47852 1.5005 0.1626 2.292z",
    strokeMiterlimit: 10,
    fill: "#081b55"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "347.94 223.5 349.04 223.87 347.84 224.36 347.79 225.37 347.18 224.38 345.74 224.86 346.51 223.73 345.49 222.76 347.04 223.25 347.87 222.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.44 234.37 369.53 234.73 368.34 235.22 368.29 236.24 367.68 235.24 366.23 235.72 367 234.6 365.99 233.63 367.54 234.12 368.36 232.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.43 237.9 367.53 238.26 366.33 238.76 366.28 239.77 365.67 238.77 364.23 239.25 365 238.13 363.98 237.16 365.53 237.65 366.36 236.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.55 242.83 367.64 243.2 366.45 243.69 366.4 244.7 365.79 243.71 364.34 244.19 365.11 243.06 364.1 242.09 365.65 242.58 366.47 241.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.3 241.62 373.39 241.98 372.2 242.48 372.15 243.49 371.54 242.49 370.09 242.98 370.86 241.85 369.85 240.88 371.4 241.37 372.22 240.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.75 237 374.85 237.36 373.66 237.86 373.6 238.87 373 237.87 371.55 238.35 372.32 237.23 371.31 236.26 372.85 236.75 373.68 235.52"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.119,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 260.87,
    x2: 363.92,
    y1: 242.81,
    x1: 351.31
  }), /*#__PURE__*/React.createElement("line", {
    y2: 259.14,
    x2: 365.49,
    y1: 241.57,
    x1: 353.08
  }), /*#__PURE__*/React.createElement("line", {
    y2: 257.14,
    x2: 367.11,
    y1: 240.27,
    x1: 354.9
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m360.54 202.16c-0.51368-0.0542-2.4014 0.66504-2.1543 1.3062 0.2168 0.56104 0.78955 0.46533 1.4351 0.47412 2.4604 0.0361 2.1894-1.627 0.71924-1.7803z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "m384.02 173.74c4.4756 6.1533 3.6367 83.924-4.477 92.876h2.7978c6.7148-8.6714 11.19-75.533 1.6792-92.876z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m371.58 135.49c23.113 18.193 41.471 64.77 43.92 94.8l-3.4536-0.21093c-3.105-32.756-20.09-71.868-37.56-86.857-0.89013-1.1621-4.9883-3.7485-5.8262-7.7842l2.9199 0.0523z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.43 137.02c2.5044 2.231 1.2373 6.3003 2.3462 7.4121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.03 141.43c1.3223 1.3516-0.0483 5.1562 1.5913 7.0083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.96 145.92c1.3501 1.6787-0.30372 4.9971 1.9014 7.7949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m386.03 151.16c1.3096 1.9253-0.53662 4.9785 1.7544 8.2583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.68 156.64c1.3345 2.0615 0.31055 6.2202 1.3774 8.0562"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.53 162.93c1.4214 2.544 0.006 6.4302 1.2148 8.7344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m397.11 169.57c1.3491 2.7739-0.0464 7.0859 0.96093 9.2212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.83 177.39c1.2363 2.7988-0.17383 7.3276 1.064 10.769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.77 187.02c1.7334 4.6167-0.65039 7.2183 0.4541 10.547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.78 198.35c1.1909 3.8091-1.1846 7.4087-0.37842 10.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.6 208.45c1.0762 4.1201-1.6069 7.9307-1.1157 10.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.22 220.59c0.35547 1.9941-2.5972 5.8657-2.1792 9.4893"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m413.59 229.81c3.5757 0.0586 4.1802 4.2881 4.7783 5.728 0.91455 2.2036 1.0386 5.2002-0.76319 4.0274-0.90234-0.58594-5.3272-0.57813-5.6592-0.0439-0.61865 0.99463-1.9443-0.75781-1.7441-3.1743 0.10694-1.3096 0.0776-6.5903 3.3882-6.5371z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m414.73 230.77c1.8564 0.51709 3.3184 7.7681 2.876 8.7959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.33 230.78c0.2788 0.29492 2.6704 5.4106 2.1191 8.3916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.95 230.87c0.25634 0.1582 2.0332 5.981 1.2939 8.2178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.57 230.82c-1.855 1.4126-1.8291 7.6235-0.62891 8.7022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.94 230.95c-1.0898 1.2422-0.84473 7.4058-0.23389 8.2705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.34 231c-0.27979 0.34765-0.45606 7.0317 0.24609 8.0908"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.64 231.08c0.1582 0.25049 0.8413 6.9585 0.69531 8.063"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinecap: "round",
    rx: 3.0159,
    ry: 1.7768,
    stroke: "#7f7100",
    cy: 230.01,
    cx: 413.62,
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m377.02 235.54c-0.48438-2.231-2.9458-15.899-3.919-20.641-0.97363-4.7398-8.1533-24.817-9.0034-31.196-1.5976-11.955-1.5547-24.235 0.47754-35.558 1.1763-6.5586 1.5254-10.13 2.4356-14.275l3.2773 2.6455c-1.4258 5.3652-2.3384 14.488-3.228 18.601-1.2949 8.6992-1.3638 18.525-0.0508 28.513 0.83789 6.3804 8.0268 26.482 9 31.223 0.97363 4.7398 3.436 18.41 3.9189 20.641",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m363.4 157.04c-0.13769 1.9028 3.0562 3.0903 2.9639 5.581"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.13 161.97c0.0352 2.1191 3.0376 2.2231 2.9131 5.832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m362.9 167.82c0.20703 2.2285 2.9639 2.4805 3.2002 5.8667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.05 172.84c0.26855 2.3291 3.3296 3.8545 3.4648 5.9082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.47 178.26c0.24073 2.8013 3.3501 4.0488 3.7202 6.5376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.65 141.41c-0.6333 3.604 2.5923 6.271 2.2471 8.6694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.79 135.32c-0.22705 1.6943 2.5356 5.581 2.292 7.209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.44 148.58c-0.46191 3.831 2.772 5.1045 2.3403 8.3394"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m364.51 185.8c0.41797 1.5322 3.6372 3.3682 4.2871 5.456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m366.36 192.7c0.88867 2.9932 3.9131 3.1533 4.8008 6.1465"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.02 201.4c0.58935 1.8091 3.8525 2.8062 4.5039 5.0327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.91 207.45c1.2407 3.9663 4.4326 4.123 5.1021 7.3999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.41 216.43c0.49317 2.79 3.648 4.0674 4.0127 5.8105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m374.94 224.45c0.24756 1.4644 3.5772 3.1592 3.8887 5.1123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.35 231.78c0.48926 2.5088 3.4678 3.2988 4.0049 5.3188"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m378.6 235.31c-3.2891 1.4204-2.4434 5.2041-2.519 6.6426-0.11621 2.2026 0.76221 4.7666 2.0405 3.0903 0.63867-0.83936 4.7344-2.5283 5.2188-2.2075 0.90283 0.59814 1.5478-1.3818 0.56201-3.3345-0.53515-1.0591-2.2583-5.5064-5.3022-4.1909z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.87 236.55c-1.5459 1.146-0.49365 7.7964 0.25635 8.4898"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.24 236.42c-0.16162 0.35547-0.67773 5.5674 0.82081 7.8594"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.62 236.34c-0.18261 0.23047 0.10401 5.8022 1.5298 7.3965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.87 235.77c2.1841 0.47412 4.2207 5.7007 3.4668 7.0669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.58 236.02c1.4184 0.62598 3.2363 5.895 2.9585 6.856"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.22 236.22c0.37256 0.18506 2.7529 5.7324 2.4546 6.8916"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.97 236.4c-0.063 0.27246 1.5303 6.1675 2.0312 7.0391"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.0222,
    ry: 1.6046,
    stroke: "#7f7100",
    cy: 235.5,
    cx: 378.63,
    strokeWidth: 0.55959,
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.31 135.46c2.7686 0.51367 3.2837 1.355 3.2373-1.4766 4.978 0.95752 4.1572 5.2568 5.8394-10.76-14.839 6.2583-10.964 4.2251-8.602 8.7109-2.7246 0.77783-1.7686 1.0249-0.47461 3.5259z",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828,
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.74 204.66c-0.9419 0.73047-1.686 1.4507-3.1367 2.6611-6.6626 5.5654-12.46 15.637-13.834 23.368l0.93799-0.1875c1.6157-8.4492 6.8491-16.617 11.928-21.102 0.93164-0.72705 2.8374-2.564 4.0942-3.457l0.0112-1.2827z",
    stroke: "#081b55",
    strokeWidth: 0.2798,
    fill: "#fff"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.11192,
    strokeLinecap: "round",
    fill: "#081b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m325.3 230.49c-0.96875 0.15283-1.2319 1.2515-1.4287 1.6396-0.29883 0.59717-0.40381 1.3628 0.11182 0.99561 0.25781-0.18506 1.4531-0.35205 1.5312-0.22901 0.14355 0.22901 0.54297-0.26758 0.54638-0.875 0.002-0.32861 0.13575-1.6724-0.76074-1.5312z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.97 230.78c-0.51368 0.20312-1.0816 2.1035-0.98584 2.3472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.07 230.77c-0.0835 0.0859-0.85156 1.478-0.77344 2.2163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.17 230.78c-0.0723 0.0508-0.6914 1.5996-0.54443 2.1396"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.55 230.71c0.46875 0.28663 0.31396 1.8672-0.0361 2.188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.45 230.76c0.26563 0.27441 0.0532 1.8506-0.13183 2.0942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.33 230.79c0.0664 0.0767-0.0439 1.7705-0.25879 2.0664"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.25 230.82c-0.0483 0.0703-0.39307 1.8022-0.38037 2.0776"
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 230.55,
    cx: 325.28,
    r: 0.45475
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    stroke: "#081b55",
    strokeWidth: 0.11192,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.7 209.05c-0.38965 0.39258-0.13086 1.3345-0.62793 1.8696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.71 210.09c-0.40527 0.479 0.0337 1.1382-0.68408 1.915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.54 211.35c-0.40088 0.54004-0.0269 1.1787-0.64697 1.9829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.59 212.5c-0.41016 0.57568-0.2373 1.5625-0.61328 2.0493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.61 213.79c-0.50586 0.67431-0.27197 1.6113-0.69678 2.2427"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.36 215.53c-0.50098 0.70459-0.26172 1.7363-0.58594 2.3179"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.06 217.6c-0.43359 0.69629-0.0127 1.4712-0.50342 2.3696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.82 219.72c-0.64551 1.2319-0.0845 1.7402-0.46143 2.6299"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.48 222.44c-0.41308 1.0142 0.0601 1.791-0.23584 2.6489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.41 225c-0.43213 1.1426 0.16064 1.9424-0.0337 2.6489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.34 228.18c-0.14307 0.5205 0.56494 1.3896 0.36475 2.3281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.4 207.5c-0.81201 0.75537-0.56348 1.7256-1.2559 2.353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.08 206.05c-0.79493 0.66846-0.81739 1.9443-1.3359 2.4048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m341.44 204.86c-0.36279 0.32861-0.70703 1.8623-1.0596 2.1724"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m425.58 305.9-40.659-39.021h-18.352-82.031l0.0347 34.458h36.68c9.7417 18.764 35.827 21.187 46.428 3.5859 0.51367-0.75537 1.6392-1.249 2.4048 0.0825 6.5825 11.296 30.192 52.134 30.192 52.134 11.422-16.641 21.073-36.082 25.303-51.239z",
    strokeWidth: 0.73857,
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.57 298.97 38.82 0.003c9.606 18.711 33.194 20.881 42.444 2.0244l5.6221 0.0249 31 52.832",
    strokeMiterlimit: 10,
    strokeWidth: 1.4725,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.76 266.92 366.27 265.31 386.37 265.31 426.4 303.63 425.58 305.9 384.83 266.92",
    strokeWidth: 1.4986,
    fill: "#7f7100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m367.18 274.72c0.36572-3.2617 0.45703-10.897-5.562-16.056-7.8325-6.7144-11.122-7.3086-17.904-10.63-6.1333-3.0044-25.738-13.708-25.738-13.708l-20.143 22.101v17.904",
    strokeWidth: 1.119,
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.05 273.46c1.8188 0 7.8335 0.27978 9.2324-0.70459h8.6396l44.653 47.275-1.2227 2.7617-45.388-48.078h-15.731c-0.74853 16.853-20.973 16.104-21.723-1.4995h-25.841l1.9575-1.958h6.959c4.6133 1.3652 16.084 0.94532 17.623 0.94532",
    strokeMiterlimit: 10,
    strokeWidth: 0.87269,
    fill: "#7f7100"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.83916
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.06,
    cy: 285.95,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.54,
    cy: 285.95,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.77,
    cy: 286.32,
    r: 2.1194
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336.14,
    cy: 297.18,
    r: 2.1182
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 345.88,
    cy: 304.3,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356.37,
    cy: 297.93,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360.11,
    cy: 285.95,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.22 288.07c1.1685 0 2.1167-0.94824 2.1167-2.1191s-0.94824-2.1182-2.1167-2.1182c-1.1733 0-2.1206 0.94727-2.1206 2.1182s0.94726 2.1191 2.1206 2.1191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.96 300.43c1.1684 0 2.1167-0.94825 2.1167-2.1182 0-1.1719-0.94824-2.1191-2.1167-2.1191-1.1724 0-2.1206 0.94727-2.1206 2.1191 0 1.1699 0.94824 2.1182 2.1206 2.1182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.2 313.53c1.1699 0 2.1182-0.94873 2.1182-2.1182 0-1.1733-0.94824-2.1196-2.1182-2.1196-1.1719 0-2.1182 0.94629-2.1182 2.1196 0 1.1694 0.94629 2.1182 2.1182 2.1182z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 397.56,
    cy: 323.78,
    r: 2.1187
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.8 337.13c1.1689 0 2.1182-0.94922 2.1182-2.1182 0-1.1719-0.94922-2.1201-2.1182-2.1201-1.1728 0-2.1216 0.94824-2.1216 2.1201 0 1.1689 0.94873 2.1182 2.1216 2.1182z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m293.02 256.13c3.3716-8.2393 16.403-25.359 22.472-26.216 3.0591-0.43262 5.9468 2.8384 2.4966 5.7427-7.1157 5.9932-14.48 14.48-18.602 21.596l-6.3672-1.1221z",
    strokeWidth: 0.74828
  }), /*#__PURE__*/React.createElement("path", {
    d: "m346.91 249.48c-4.7285 0.83056-19.486 17.825-19.898 22.621-4.8877 0-6.5816-0.81885-7.5073-0.81885 1.625-5.9355 15.892-23.141 21.039-24.938 0.93799-0.72021 6.3408 1.6768 6.3667 3.1358z",
    strokeWidth: 0.74828
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 348.5,
    cy: 275.4,
    r: 10.846,
    strokeWidth: 0.83916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.38,
    cy: 275.96,
    r: 10.847,
    strokeWidth: 0.83916
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 347.38,
    cy: 275.96,
    r: 7.7681,
    strokeWidth: 0.87269
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.73857,
    cy: 275.96,
    cx: 347.38,
    r: 2.5376
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m310.78 268.49c0.83887 0.83984 6.9936 2.3789 8.5322 2.5176",
    stroke: "#7f7100",
    strokeWidth: 1.4986,
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m309.42 243.61c0.69238 0.84473 17.725 12.606 19.678 13.044 0.68994 1.1245 4.4443 3.6763 5.7031 3.6865 0.83447 0.56787 6.272 2.5742 8.1079 0.63232 1.8359-1.9424-3.3071-5.7642-3.8672-5.6284-0.26953-1.1226-4.1616-3.8154-5.0015-3.8223-0.97461-0.56885-19.616-12.135-20.876-12.005-0.40527-1.6826-3.4619-4.0874-5.6523-1.5898-1.9883 2.2686 0.0918 5.5957 1.9082 5.6826z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m313.16 239.99c1.1978-0.0566 19.554 11.275 20.511 11.834 0.80322 0.0474 4.6489 2.6621 4.959 3.6885 0.52979-0.0947 5.623 3.6021 3.9624 5.2686-1.6621 1.6665-6.9507-0.4043-7.7754-0.95654-1.2031-0.0698-4.9102-2.5518-5.6216-3.6006-1.8887-0.48779-18.716-11.918-19.416-12.715-1.7412-0.16455-3.8862-3.2686-2.0933-5.2232 1.9736-2.1509 5.0073 0.16504 5.4736 1.7041z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m313.15 240.47c1.1348 0.0156 19.205 11.113 20.146 11.663 0.76464 0.0859 4.5649 2.6265 4.9175 3.5566 0.49756-0.0552 5.5415 3.5137 4.0542 4.9048-1.4868 1.3921-6.6274-0.7417-7.4404-1.2793-1.147-0.12744-4.8076-2.5415-5.5425-3.5137-1.8203-0.53857-18.444-11.64-19.154-12.387-1.6616-0.2417-3.8716-3.1216-2.2759-4.7622 1.7568-1.8066 4.7671 0.42334 5.2954 1.8179z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m313.15 240.94c1.0728 0.0879 18.857 10.95 19.782 11.492 0.72851 0.12402 4.4814 2.5889 4.8745 3.4233 0.46631-0.0156 5.4624 3.4282 4.1494 4.5444-1.312 1.1157-6.3052-1.0825-7.1089-1.603-1.0908-0.1875-4.7036-2.5327-5.4614-3.4292-1.7534-0.5879-18.173-11.358-18.892-12.058-1.5864-0.31934-3.8594-2.9761-2.4619-4.3027 1.5415-1.46 4.5288 0.68213 5.1182 1.9331z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m313.14 241.41c1.0108 0.16016 18.51 10.787 19.417 11.32 0.69091 0.16357 4.3979 2.5527 4.8325 3.291 0.4336 0.0239 5.3799 3.3433 4.2422 4.1831-1.1372 0.84033-5.9819-1.4214-6.7749-1.9282-1.0352-0.24511-4.6011-2.5215-5.3799-3.3408-1.688-0.63916-17.902-11.08-18.631-11.729-1.5068-0.39746-3.8467-2.832-2.645-3.8438 1.3232-1.1143 4.2881 0.93945 4.9394 2.0474z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m313.14 241.89c0.94727 0.23145 18.16 10.624 19.051 11.147 0.65381 0.2041 4.314 2.5176 4.7896 3.1592 0.40185 0.0644 5.3008 3.2563 4.3369 3.8208-0.96338 0.56543-5.6592-1.7593-6.4404-2.2505-0.97998-0.30469-4.4995-2.5107-5.3022-3.2549-1.6201-0.68994-17.629-10.801-18.368-11.4-1.4307-0.47656-3.8345-2.686-2.8296-3.3838 1.1064-0.76807 4.0488 1.1978 4.7622 2.1621z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m311.31 243.01c0.74951 0.54736 16.6 10.252 18.158 10.985 0.8291 0.6626 4.3096 2.7852 5.2358 3.1445 0.77343 0.47168 5.3325 2.8408 6.1206 2.5459 0.78711-0.29346-4.0762-3.3364-4.4487-3.438-0.51904-0.54443-4.1436-2.7642-4.7612-3.0044-0.87598-0.51172-17.851-10.586-18.737-10.888-0.77881-0.81494-3.708-2.6802-4.5962-2.2534-0.80518 0.3872 1.6719 2.3608 3.0293 2.9087z"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    stroke: "#b3aa35",
    strokeWidth: 0.74828,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.15 256.73c1.6148-1.9014 3.2744-3.7192 4.8506-5.2944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.03 255.35c-1.4917 1.4902-3.0181 3.1533-4.4609 4.8481"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.42 239.81c-1.3345 1.3018-2.6509 2.6611-3.9258 4.0557"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m231.9 26.244c-5.05 0.824-8.7 1.413-11.62 1.822-2.93 0.412-6.67 0.862-11.61 1.444 0.24 1.966 0.79 4.302 0.98 6.125l1.47-0.209c-0.05-0.934-0.14-1.865-0.16-2.504 0.33-0.876 0.63-1.182 1.5-1.418l5.44-0.764 2.6 18.53c0.34 2.668 0.24 2.986-2.73 3.33l0.21 1.552c2.43-0.454 4.31-0.793 5.75-0.996 1.44-0.202 3.3-0.389 5.76-0.621l-0.23-1.592c-2.98 0.533-3.17 0.258-3.54-2.406l-2.61-18.531 5.22-0.733c2.04-0.25 1.7 0.026 2.22 1.838 0.14 0.507 0.22 1.026 0.29 1.543l1.44-0.203c-0.12-2.245-0.26-4.527-0.38-6.207zm42 0.936c-6.87 0.257-11.67 4.313-12.52 11.972-0.95 8.459 3.59 13.548 11.9 14.479 8.57 0.958 14.74-3.57 15.72-12.287 0.93-8.309-4.05-13.15-12.03-14.041-1.06-0.119-2.08-0.16-3.07-0.123zm20.46 3.078l-0.33 1.379c2.85 0.947 2.92 1.274 2.46 3.541l-3.92 16.445c-0.66 2.605-0.88 2.861-3.76 2.096l-0.37 1.525c2.43 0.461 4.29 0.83 5.71 1.168 1.41 0.337 3.21 0.842 6.2 1.67l0.37-1.561c-3.58-0.739-3.66-1.064-3.03-3.677l1.81-7.625 4.18 0.996c0.65 0.156 2.02 0.522 2 1.435 0.03 0.815-0.19 1.604-0.39 2.403l1.49 0.355 1.85-7.732-1.46-0.346-0.22 0.943c-0.17 0.536-0.21 1.027-0.8 1.268-0.74 0.207-1.57-0.029-2.29-0.203l-3.92-0.934 2.18-9.148 2.49 0.48c1.83 0.361 3.84 0.799 5.38 1.897l0.15 0.187c-0.05 0.987-0.28 1.968-0.44 2.965l1.42 0.336c0.63-2.034 1.3-3.868 1.77-5.178l-0.09-0.289c-3.1-0.662-6.18-1.281-9.26-2.017-3.09-0.735-6.11-1.57-9.18-2.379zm-90.7 0.138c-1.76 0.617-3.07 1.067-4.15 1.374-1.04 0.296-2.42 0.611-4.07 0.962l0.44 1.545c2.88-0.934 3.1-0.688 3.84 1.897l3.87 13.611-1.08-0.664-7.58-4.949-11.32-8c-1.57 0.486-2.73 0.894-3.7 1.17-0.93 0.265-2.18 0.54-3.64 0.84l0.44 1.545c2.87-0.936 3.1-0.689 3.83 1.896l4.58 16.088c0.73 2.586 0.67 2.913-2.27 3.631l0.44 1.545c1.65-0.587 3-1.047 4.04-1.344 1.08-0.307 2.43-0.61 4.18-0.992l-0.44-1.545c-2.88 0.934-3.1 0.69-3.84-1.897l-4.19-14.757 21.48 14.421 3.12-0.378 0.13-0.231-0.26-0.898-0.84-2.672-4.83-17.022c-0.74-2.585-0.68-2.914 2.26-3.633l-0.44-1.543zm-35.96 11.309c-2.96 1.416-5.91 2.868-8.91 4.217-3.02 1.364-6.06 2.611-9.09 3.892l0.58 1.291c2.83-0.987 3.09-0.776 4.11 1.303l7.21 15.99c0.67 1.496 0.64 2.33-0.78 3.375l0.45 0.989c3.52-1.712 6.18-2.992 8.33-3.957 2.11-0.951 4.79-2.078 8.65-3.692l-2.3-6.008-1.33 0.6c0.3 1.297 0.77 2.886 0.81 3.606-0.73 0.738-2.91 1.803-8.42 4.287l-4.14-9.186 4.52-2.039c0.61-0.276 1.73-0.697 2.26 0.008 0.51 0.587 0.73 1.349 1.12 2.033l1.43-0.644-3.3-7.315-1.36 0.613c0.35 0.782 0.59 1.493 0.68 2.149 0.18 0.658-0.3 0.873-0.78 1.088l-5.34 2.404-3.27-7.246c-0.18-0.407-0.28-0.896-0.31-1.33 0.99-0.446 5.33-2.442 6.6-2.893 0.78-0.268 1.62-0.484 1.9 0.045 0.4 0.718 0.83 1.469 1.16 2.217l1.29-0.58-1.34-3.897-0.43-1.32zm169.51 1.652c-0.89 1.765-1.73 4.013-2.59 5.627l1.34 0.651c0.47-0.807 0.91-1.631 1.26-2.17 0.76-0.543 1.17-0.633 2.03-0.344l4.94 2.389-8.15 16.84c-1.2 2.403-1.46 2.608-4.12 1.24l-0.68 1.412c2.26 0.971 4.01 1.732 5.32 2.367 1.31 0.634 2.96 1.514 5.13 2.688l0.7-1.444c-2.77-1.217-2.77-1.551-1.6-3.97l8.14-16.84 4.74 2.293c1.83 0.927 1.4 0.966 0.82 2.759-0.16 0.503-0.39 0.975-0.61 1.446l1.31 0.633c1.14-1.935 2.3-3.903 3.13-5.368-4.65-2.125-8.01-3.668-10.67-4.953-2.65-1.283-6.02-2.993-10.44-5.256zm-196.93 11.008c-1.48 1.137-2.55 1.952-3.48 2.578-0.9 0.607-2.09 1.315-3.67 2.246 0.48 2.514 1.64 10.108 2.64 16.461 0.2 1.221 0.37 2.411 0.48 3.643l-11.78-6.914c-1.63-0.881-4.27-2.524-5.73-3.479-1.45 1.116-2.53 1.928-3.45 2.555-0.9 0.605-2.09 1.316-3.98 2.455l0.9 1.332c2.45-1.784 2.74-1.62 4.24 0.608l9.35 13.867c1.51 2.227 1.55 2.558-1.02 4.156l0.9 1.332c1.45-1.115 2.59-1.973 3.49-2.578 0.89-0.605 2.08-1.315 3.6-2.205l-0.9-1.33c-2.44 1.783-2.74 1.619-4.24-0.61l-9.04-13.4 17.04 9.898c0.99 0.595 2.59 1.582 2.84 1.819l1.06-0.711-0.14-0.942-2.05-12.849-1.21-9.002 9.02 13.369c1.47 2.249 1.52 2.58-1 4.19l0.87 1.3c1.98-1.47 3.52-2.597 4.73-3.412 1.21-0.814 2.79-1.797 4.9-3.082l-0.9-1.33c-2.44 1.784-2.73 1.62-4.24-0.609l-9.35-13.866c-1.51-2.228-1.55-2.559 1.02-4.158l-0.9-1.332zm223.02 1.908l-0.88 1.299c2.52 1.605 2.48 1.937 1.01 4.188l-9.33 13.871c-1.53 2.207-1.82 2.373-4.25 0.644l-0.88 1.303c2.11 1.281 3.73 2.283 4.94 3.094s2.71 1.913 4.69 3.381l0.9-1.332c-2.57-1.595-2.53-1.926-1.03-4.155l4.46-6.627c2.15 1.407 3.8 2.427 5.07 3.282 1.27 0.852 2.81 1.976 4.96 3.465l-4.46 6.626c-1.53 2.208-1.82 2.374-4.25 0.645l-0.88 1.303c2.11 1.281 3.73 2.28 4.94 3.094 1.2 0.81 2.71 1.913 4.69 3.38l0.9-1.332c-2.57-1.593-2.53-1.924-1.03-4.154l9.33-13.873c1.5-2.23 1.79-2.393 4.23-0.613l0.9-1.332c-2.11-1.281-3.7-2.26-4.91-3.073-1.2-0.811-2.74-1.936-4.72-3.402l-0.88 1.301c2.52 1.603 2.48 1.933 1.01 4.183l-3.56 5.297c-2.19-1.427-3.81-2.428-5.08-3.281-1.27-0.854-2.84-1.997-4.95-3.467l3.56-5.293c1.5-2.23 1.79-2.394 4.23-0.615l0.9-1.332c-2.11-1.281-3.7-2.259-4.91-3.07-1.2-0.814-2.74-1.937-4.72-3.405zm-255.25 20.842c-3.68 3.54-6.35 6.094-8.527 8.088-2.171 1.992-4.997 4.487-8.728 7.76 1.31 1.482 3.089 3.089 4.271 4.486l1.102-1.011c-0.577-0.736-1.18-1.449-1.555-1.967-0.225-0.907-0.154-1.326 0.43-2.014l4.039-3.709 12.638 13.772c1.79 2 1.89 2.32-0.36 4.28l1.06 1.16c1.73-1.75 3.08-3.09 4.16-4.08 1.07-0.98 2.49-2.19 4.38-3.77l-1.08-1.178c-2.15 2.128-2.47 2.008-4.28 0.027l-12.64-13.77 3.87-3.556c1.54-1.359 1.42-0.943 2.87 0.254 0.41 0.334 0.76 0.719 1.11 1.103l1.08-0.984c-1.38-1.775-2.78-3.577-3.84-4.891zm285.3 0.471l-0.96 1.047c2.03 2.204 1.94 2.526 0.44 4.287l-11.82 12.959c-1.1 1.214-1.88 1.513-3.4 0.633l-0.73 0.799c2.97 2.556 5.19 4.489 6.93 6.069 1.71 1.56 3.81 3.58 6.83 6.48l4.6-4.49-1.08-0.99c-1.07 0.79-2.34 1.86-2.99 2.18-0.97-0.38-2.81-1.96-7.28-6.03l6.79-7.448 3.67 3.344c0.49 0.452 1.33 1.313 0.89 2.072-0.34 0.703-0.95 1.205-1.42 1.832l1.15 1.06 5.41-5.931-1.1-1.006c-0.58 0.636-1.14 1.137-1.71 1.481-0.53 0.42-0.92 0.068-1.3-0.284l-4.33-3.947 5.35-5.873c0.31-0.331 0.71-0.616 1.1-0.818 0.8 0.73 4.35 3.922 5.27 4.908 0.56 0.608 1.09 1.297 0.72 1.764-0.5 0.656-1.02 1.342-1.58 1.947l1.05 0.957 3.04-2.783 1.05-0.92c-2.48-2.156-4.99-4.285-7.41-6.498-2.46-2.238-4.81-4.534-7.18-6.801zm-307.71 23.824c-2.791 0.19-4.625 2.55-6.305 4.55-1.618 2.1-2.81 3.64-3.818 4.84-1.009 1.2-2.337 2.67-4.127 4.63l1.201 1c1.862-2.33 2.188-2.25 4.271-0.55l12.809 10.75c2.035 1.75 2.168 2.06 0.191 4.3l1.2 1.01c1.499-1.96 2.666-3.47 3.601-4.58 0.938-1.12 2.194-2.5 3.865-4.32l-1.23-1.03c-1.858 2.39-2.183 2.31-4.242 0.59l-13.897-11.67c-0.2-0.16-0.382-0.41-0.562-0.66 0.369-0.62 0.818-1.27 1.297-1.84 1.871-2.23 4.442-2.85 6.787-0.88 2.687 2.25 2.683 5.56 0.246 8l0.347 0.64 15.357 1.97c0.63-0.93 1.3-1.84 2.02-2.7 0.76-0.91 1.61-1.81 2.47-2.65l-1.2-1.01c-0.69 0.64-2.01 1-2.97 0.92l-12.179-1.4c1.134-3.09 1.031-6.4-1.658-8.65-1.172-0.98-1.919-1.37-3.474-1.26zm348.09 19.34l-1.57 0.44-1.62 0.37-2.65 0.71-15.2 3.61c-1.31 0.29-2.67 0.75-4.06 0.55-0.67-0.3-1.16-0.86-1.59-1.47l-1.31 0.93c1.13 1.4 1.97 2.45 2.6 3.33s1.35 2.01 2.3 3.53l1.21-0.86c-0.25-0.74-1.67-2.79-0.57-3.12l5.07-1.56 5.44 7.62-2.95 4.54c-0.75 1.13-1.95-0.81-2.72-1.5l-1.21 0.87c1.52 1.93 2.66 3.41 3.51 4.59 0.84 1.19 1.85 2.72 3.21 4.81l1.3-0.93-0.26-0.36c-0.73-1.35-0.96-1.6-0.14-2.97l12.75-20.97-1.54-2.16zm-372.58 9.94l-1.401 2.25 1 1.28 0.963 1.35 1.67 2.18 9.162 12.66c0.769 1.1 1.721 2.18 2.063 3.53-0.02 0.74-0.35 1.41-0.745 2.04l1.36 0.85c0.853-1.58 1.501-2.76 2.074-3.67 0.571-0.92 1.346-2.02 2.389-3.48l-1.268-0.79c-0.585 0.51-1.938 2.62-2.658 1.73l-3.385-4.09 4.955-7.95 5.319 0.99c1.332 0.26 0.001 2.11-0.342 3.08l1.267 0.79c1.208-2.14 2.131-3.77 2.901-5 0.769-1.23 1.802-2.74 3.219-4.81l-1.362-0.84-0.236 0.37c-0.968 1.2-1.113 1.51-2.684 1.28l-24.261-3.75zm384.32 7.57l-1.39 0.72c1.44 2.61 1.24 2.88-1.12 4.15l-14.84 7.7c-2.41 1.21-2.74 1.21-4.05-1.47l-1.39 0.72c1.23 2.13 2.18 3.79 2.85 5.08s1.46 2.98 2.5 5.22l1.42-0.74c-1.49-2.63-1.3-2.9 1.09-4.14l16.1-8.35c0.23-0.12 0.53-0.19 0.83-0.26 0.43 0.58 0.85 1.24 1.2 1.9 1.34 2.58 0.93 5.19-1.79 6.6-3.12 1.62-6.17 0.34-7.49-2.84l-0.71 0.08-7.71 13.42c0.61 0.94 1.19 1.9 1.71 2.89 0.55 1.06 1.05 2.19 1.5 3.3l1.39-0.72c-0.33-0.88-0.15-2.24 0.29-3.09l5.96-10.71c2.42 2.24 5.51 3.41 8.63 1.79 1.35-0.7 2-1.24 2.49-2.72 0.9-2.65-0.58-5.25-1.78-7.57-1.32-2.3-2.28-3.99-3-5.38s-1.57-3.18-2.69-5.58zm-389.84 8.09c-0.768-0.02-1.536 0.14-2.33 0.51-1.734 0.95-2.52 2.6-3.305 4.25l-5.812 12.24 1.281 0.61c1.196-2.78 1.53-2.78 3.957-1.63l15.106 7.17c2.412 1.19 2.618 1.45 1.269 4.12l1.416 0.67c0.956-2.27 1.706-4.02 2.33-5.34 0.624-1.31 1.492-2.97 2.651-5.15l-1.45-0.68c-1.196 2.78-1.529 2.78-3.957 1.63l-16.218-7.7c-0.237-0.11-0.759-0.32-0.797-0.59-0.097-0.67 0.37-1.56 0.642-2.13 0.528-1.11 1.508-2.22 2.737-2.55 1.328-0.36 2.738 0.15 3.92 0.71 0.978 0.46 1.858 1.05 2.394 2 0.607 1.08 0.719 2.41 0.19 3.52-0.225 0.48-0.584 0.88-0.875 1.32l0.175 0.5c0.351-0.04 1.219-0.04 1.453-0.01 0.34-0.54 0.781-1.03 1.071-1.64 2.05-4.32 0.967-9.09-3.518-11.22-0.792-0.37-1.561-0.58-2.33-0.61zm404.47 20.57l-1.52 0.49c1.03 2.84 0.79 3.08-1.77 3.9l-15.91 5.13c-2.55 0.82-2.88 0.77-3.7-2.14l-1.53 0.5c0.67 1.7 1.17 3.03 1.51 4.06 0.33 1.03 0.68 2.37 1.11 4.07l1.53-0.49c-1.03-2.85-0.8-3.08 1.76-3.9l15.38-4.96-14.24 13.6c-0.84 0.79-2.24 2.06-2.53 2.23l0.39 1.21 0.94 0.13 12.91 1.6 8.97 1.34-15.34 4.95c-2.57 0.79-2.9 0.73-3.74-2.13l-1.49 0.48c0.86 2.31 1.52 4.1 1.96 5.48 0.45 1.39 0.95 3.19 1.6 5.57l1.53-0.5c-1.04-2.84-0.8-3.07 1.76-3.9l15.91-5.13c2.56-0.82 2.88-0.77 3.71 2.14l1.52-0.49c-0.68-1.74-1.16-3-1.5-4.06-0.33-1.03-0.69-2.37-1.14-4.15-2.55-0.23-10.16-1.23-16.54-2.03-1.22-0.16-2.41-0.32-3.63-0.56l9.91-9.39c1.3-1.32 3.61-3.4 4.93-4.53-0.66-1.71-1.15-2.96-1.49-4.03-0.33-1.03-0.69-2.36-1.26-4.49zm-419.52 4.99c-0.943 3.15-1.851 6.31-2.867 9.44-1.026 3.16-2.146 6.25-3.232 9.36l1.351 0.43c1.171-2.76 1.501-2.81 3.727-2.16l16.699 5.42c1.563 0.5 2.158 1.09 1.983 2.84l1.031 0.33c1.103-3.76 1.944-6.59 2.67-8.83 0.714-2.2 1.683-4.95 3.082-8.89l-5.996-2.34-0.45 1.38c1.163 0.65 2.658 1.37 3.217 1.83 0.055 1.04-0.623 3.37-2.49 9.13l-9.594-3.11 1.533-4.73c0.209-0.64 0.648-1.76 1.524-1.67 0.779 0.02 1.489 0.37 2.258 0.54l0.486-1.49-7.639-2.48-0.463 1.42c0.818 0.27 1.506 0.57 2.053 0.94 0.605 0.32 0.444 0.81 0.281 1.31l-1.81 5.58-7.566-2.46c-0.427-0.14-0.855-0.39-1.2-0.66 0.335-1.03 1.776-5.59 2.297-6.83 0.326-0.76 0.732-1.53 1.313-1.38 0.805 0.18 1.643 0.37 2.425 0.63l0.438-1.35-3.793-1.63-1.268-0.57zm0.041 26.18c-2.038 0.06-4 0.59-5.705 1.98-2.69 2.24-3.785 5.31-4.4 8.65-0.594 3.24-0.851 5.66-1.201 7.57-0.352 1.91-0.87 4.32-1.602 7.68l1.58 0.29c0.798-2.89 1.12-2.98 3.41-2.64l17.86 3.29c0.845 0.15 1.512 0.65 1.631 2.08l0.881 0.16 2.011-10.95c0.871-4.74 0.486-9.67-2.855-13.4-2.111-2.36-4.771-3.8-7.895-4.38-1.24-0.22-2.491-0.36-3.715-0.33zm432.39 6.48l-0.99 0.14c0.17 2.05-1.4 3.25-1.73 3.5l-12.17 9.17-5.85 0.84c-3.3 0.48-3.52-0.47-4.19-3.17l-0.99 0.14 1.98 13.81 0.99-0.14c-0.12-2.83-0.17-3.72 3.14-4.19l7.32-1.05 13.47 5.82c1.38 0.62 1.71 1.75 1.93 2.49l1-0.15-1.26-8.75-0.99 0.14c0.15 1.89 0.28 3.37-1.27 3.6-1.08 0.15-3.45-0.81-3.93-1.03l-7.99-3.36 8.55-6.09c0.59-0.42 1.49-1.19 2.09-1.28 1.11-0.16 1.42 0.28 1.81 3.03l1-0.14-1.92-13.33zm-433.77 38.43a5.3402 5.3402 0 0 0 -5.339 5.34 5.3402 5.3402 0 0 0 5.339 5.34 5.3402 5.3402 0 0 0 5.342 -5.34 5.3402 5.3402 0 0 0 -5.342 -5.34zm424.56 0.79c-0.19 0-0.37 0.01-0.55 0.02-2.94 0.27-5.1 2.87-4.83 5.8 0.27 2.94 2.86 5.1 5.8 4.83 2.94-0.26 5.1-2.86 4.83-5.8-0.25-2.75-2.55-4.82-5.25-4.85zm9.91 20.75l-0.06 0.45c-0.36 1.5-0.36 1.84-1.88 2.3l-23.55 7-0.3 2.63 1.46 0.73 1.44 0.81 2.45 1.26 13.7 7.53c1.17 0.66 2.49 1.23 3.38 2.31 0.3 0.67 0.29 1.42 0.2 2.16l1.6 0.19c0.09-1.8 0.17-3.14 0.3-4.21 0.12-1.08 0.35-2.4 0.67-4.17l-1.49-0.17c-0.3 0.71-0.63 3.19-1.66 2.7l-4.81-2.25 1.08-9.31 5.23-1.38c1.32-0.34 0.91 1.9 1.01 2.93l1.49 0.17c0.17-2.46 0.31-4.32 0.48-5.76 0.17-1.45 0.45-3.26 0.85-5.73l-1.59-0.19zm-420.85 3.04l-1.553 0.23c0.51 2.95 0.236 3.14-2.42 3.57l-14.273 2.11c-4.179 0.61-6.644 4.64-5.612 11.63 0.415 2.81 1.269 5.25 3.481 7.19 2.304 2.05 5.062 2.05 7.947 1.63l11.535-1.71c2.668-0.35 2.985-0.25 3.348 2.72l1.554-0.23c-0.416-2.05-0.688-3.37-0.845-4.45-0.159-1.07-0.282-2.41-0.406-4.02l-1.553 0.23c0.51 2.95 0.237 3.14-2.42 3.57l-9.651 1.42c-1.921 0.29-4.472 0.67-6.273-0.01-2.202-0.85-3.176-3.35-3.504-5.57-0.295-1.99-0.158-4.39 1.358-5.9 1.483-1.47 4.213-1.65 6.173-1.94l9.909-1.46c2.662-0.39 2.98-0.29 3.312 2.73l1.59-0.24c-0.471-2.42-0.818-4.26-1.031-5.7s-0.416-3.34-0.666-5.8zm394.99 21.66c-0.28 0.02-0.41 0.28-0.55 0.48-1.66 2.66-2.66 4.95-3.41 7.92-1.94 7.71 0.53 15.52 8.85 17.61 3.73 0.94 7.66 0.62 10.9-1.57 3.24-2.15 5.06-5.73 5.99-9.42 0.72-2.9 0.99-5.95 0.1-8.83l-1.58-1.24-0.54 0.32c0.62 2.12 0.65 5.25 0.11 7.38-0.8 3.19-2.16 5.39-5.1 6.99-2.81 1.53-5.93 1.55-8.98 0.79-2.42-0.61-4.96-1.83-6.41-3.88-1.62-2.29-1.95-5.11-1.27-7.79 0.62-2.46 1.84-4.58 4.12-5.85 1.09 0.12 2.11 0.34 3.17 0.56l0.35-1.41c-1.57-0.47-4.32-1.47-5.43-1.98-0.12-0.06-0.23-0.08-0.32-0.08zm-390.87 6.07l-1.541 0.46c0.971 2.87 0.729 3.09-1.848 3.86l-16.041 4.78c-2.577 0.77-2.906 0.71-3.662-2.23l-1.541 0.46c0.609 1.65 1.087 2.99 1.396 4.03 0.319 1.08 0.644 2.42 1.047 4.17l1.539-0.46c-0.97-2.86-0.726-3.09 1.852-3.86l14.713-4.38-14.162 21.68 0.418 3.11 0.234 0.12 0.895-0.26 2.664-0.87 16.968-5.06c2.579-0.77 2.908-0.71 3.664 2.22l1.539-0.46c-0.639-1.75-1.105-3.06-1.425-4.13-0.309-1.04-0.643-2.42-1.016-4.06l-1.539 0.45c0.97 2.87 0.727 3.1-1.85 3.87l-13.57 4.04 0.65-1.09 4.858-7.64 7.861-11.43c-0.503-1.56-0.928-2.72-1.217-3.69-0.277-0.93-0.567-2.17-0.886-3.63zm381.87 21.38c-0.77 2.35-1.36 4.12-1.88 5.48s-1.27 3.11-2.25 5.38l1.47 0.56c0.99-2.82 1.32-2.86 3.85-1.94l15.64 5.94c2.49 0.99 2.72 1.24 1.59 4.01l1.47 0.55c0.77-2.34 1.38-4.15 1.89-5.51 0.52-1.36 1.25-3.08 2.23-5.34l-1.5-0.57c-0.97 2.86-1.3 2.9-3.81 1.94l-15.64-5.94c-2.51-0.95-2.74-1.2-1.56-3.99l-1.5-0.57zm-371.7 9.34l-1.45 0.6c1.219 2.73 1.001 2.98-1.466 4.05l-15.448 6.44c-2.495 1-2.83 0.98-3.91-1.81l-1.449 0.6c1.053 2.24 1.854 3.97 2.414 5.31 0.561 1.35 1.212 3.1 2.057 5.42l1.482-0.62c-1.267-2.75-1.049-3 1.434-4.04l15.445-6.44c2.482-1.03 2.817-1.01 3.877 1.83l1.482-0.62c-1.051-2.23-1.838-3.93-2.398-5.27-0.561-1.35-1.226-3.14-2.07-5.45zm367.39 10.37c-0.43-0.01-0.89 0.07-1.45 0.25-2.68 0.82-3.93 3.53-5.11 5.86-1.1 2.41-1.91 4.18-2.62 5.58s-1.67 3.13-2.97 5.44l1.39 0.71c1.29-2.7 1.62-2.7 4.03-1.51l14.92 7.57c2.38 1.25 2.58 1.51 1.16 4.14l1.4 0.71c1.01-2.24 1.81-3.98 2.47-5.27 0.66-1.3 1.57-2.93 2.79-5.08l-1.44-0.73c-1.27 2.75-1.6 2.75-4 1.53l-16.18-8.21c-0.23-0.12-0.46-0.32-0.7-0.52 0.23-0.68 0.51-1.42 0.85-2.08 1.32-2.6 3.68-3.79 6.41-2.4 3.13 1.59 3.88 4.81 2.06 7.74l0.48 0.54 15.4-1.56c0.41-1.05 0.85-2.09 1.36-3.08 0.54-1.07 1.16-2.13 1.8-3.15l-1.39-0.71c-0.53 0.78-1.73 1.43-2.68 1.57l-12.18 1.4c0.4-3.27-0.45-6.47-3.58-8.05-0.85-0.44-1.49-0.68-2.22-0.69zm-360.91 5.1c-1.743 0.93-3.716 2.29-5.348 3.12l0.727 1.3c0.851-0.39 1.682-0.81 2.271-1.06 0.936-0.01 1.328 0.16 1.862 0.88l2.679 4.79-16.306 9.13c-2.361 1.28-2.695 1.29-4.088-1.35l-1.365 0.77c1.3 2.09 2.294 3.71 3.004 4.98 0.711 1.27 1.556 2.94 2.66 5.14l1.4-0.78c-1.574-2.59-1.386-2.86 0.957-4.17l16.309-9.13 2.568 4.59c0.969 1.81 0.591 1.59-0.908 2.73-0.42 0.32-0.875 0.57-1.33 0.83l0.711 1.27c2.043-0.93 4.12-1.88 5.638-2.6-2.593-4.41-4.462-7.6-5.902-10.17-1.439-2.57-3.214-5.89-5.539-10.27zm346.39 17.38c-1.84 2.72-3.65 5.47-5.55 8.15-1.92 2.71-3.91 5.33-5.87 7.96l1.16 0.82c1.94-2.28 2.27-2.23 4.2-0.96l14.32 10.15c1.34 0.95 1.73 1.68 1.04 3.3l0.89 0.63c2.17-3.27 3.82-5.72 5.18-7.64 1.33-1.89 3.08-4.22 5.58-7.57l-5.02-4.01-0.84 1.19c0.91 0.97 2.13 2.1 2.52 2.7-0.25 1.01-1.59 3.03-5.09 7.96l-8.23-5.82 2.88-4.05c0.38-0.55 1.14-1.48 1.94-1.14 0.74 0.25 1.32 0.79 2 1.19l0.91-1.28-6.56-4.64-0.86 1.22c0.7 0.49 1.27 0.98 1.68 1.5 0.48 0.48 0.18 0.91-0.12 1.34l-3.39 4.78-6.49-4.6c-0.36-0.26-0.69-0.63-0.94-0.99 0.62-0.88 3.35-4.8 4.22-5.84 0.54-0.62 1.16-1.24 1.67-0.92 0.71 0.41 1.45 0.85 2.12 1.32l0.82-1.15-3.13-2.68-1.04-0.92zm-333.1 5.27l-1.133 0.86c1.591 2.53 1.442 2.83-0.357 4.29l-13.988 10.57c-1.311 0.99-2.131 1.14-3.463 0l-0.864 0.65c2.452 3.06 4.288 5.36 5.705 7.24 1.394 1.85 3.09 4.21 5.52 7.61l5.346-3.57-0.879-1.16c-1.2 0.58-2.644 1.39-3.336 1.59-0.882-0.55-2.404-2.44-6.049-7.26l8.037-6.08 2.992 3.96c0.405 0.54 1.064 1.54 0.493 2.2-0.462 0.63-1.152 1.01-1.733 1.54l0.943 1.25 6.401-4.83-0.901-1.19c-0.685 0.52-1.324 0.91-1.943 1.14-0.603 0.32-0.918-0.1-1.232-0.52l-3.532-4.67 6.34-4.79c0.357-0.27 0.812-0.48 1.229-0.6 0.652 0.86 3.56 4.65 4.281 5.79 0.435 0.69 0.834 1.47 0.381 1.86-0.611 0.55-1.25 1.13-1.904 1.63l0.853 1.13 3.5-2.18 1.192-0.71c-2.04-2.58-4.109-5.13-6.088-7.75-2.003-2.65-3.891-5.33-5.811-8zm318.89 14.07c-1.22 1.42-2.09 2.44-2.87 3.25-0.75 0.78-1.76 1.73-3.1 2.97 0.99 2.36 3.72 9.53 6.04 15.53 0.44 1.15 0.86 2.28 1.23 3.46l-12.97-4.28c-1.78-0.52-4.7-1.57-6.33-2.19-1.18 1.39-2.06 2.41-2.84 3.22-0.75 0.78-1.76 1.73-3.36 3.24l1.16 1.11c2.01-2.26 2.33-2.16 4.27-0.3l12.06 11.59c1.93 1.86 2.05 2.17-0.13 4.27l1.16 1.12c1.18-1.4 2.11-2.47 2.86-3.25s1.76-1.73 3.06-2.92l-1.16-1.11c-2.01 2.26-2.33 2.16-4.27 0.3l-11.66-11.2 18.74 6.09c1.09 0.38 2.87 1 3.16 1.18l0.88-0.92-0.33-0.89-4.71-12.12-3.07-8.55 11.62 11.17c1.92 1.89 2.03 2.2-0.09 4.3l1.13 1.09c1.62-1.85 2.89-3.28 3.9-4.33 1-1.05 2.35-2.34 4.14-4.04l-1.16-1.11c-2.01 2.26-2.33 2.16-4.27 0.3l-12.06-11.59c-1.94-1.86-2.05-2.17 0.13-4.28l-1.16-1.11zm-304.8 4.72l-1.131 1.13c1.931 2.3 1.821 2.62 0.241 4.31l-12.827 12.83c-0.607 0.6-1.396 0.87-2.638 0.16l-0.635 0.63 7.869 7.86c3.405 3.41 7.683 5.89 12.641 5.25 3.14-0.39 5.84-1.77 8.08-4.01 2.37-2.38 4.27-5.18 3.98-8.69-0.31-3.48-2.22-6.12-4.62-8.52-2.32-2.32-4.17-3.91-5.54-5.28-1.38-1.37-3.07-3.16-5.42-5.67zm267.29 29.29l-2.14 1.57 0.45 1.57 0.4 1.61 0.74 2.65 3.81 15.17c0.31 1.31 0.8 2.66 0.61 4.05-0.29 0.68-0.85 1.18-1.45 1.62l0.95 1.29c1.38-1.15 2.42-2 3.29-2.64s2-1.38 3.51-2.35l-0.88-1.2c-0.73 0.26-2.77 1.71-3.11 0.62l-1.63-5.07 7.56-5.54 4.57 2.89c1.15 0.74-0.78 1.97-1.46 2.75l0.88 1.2c1.93-1.55 3.39-2.71 4.56-3.57 1.18-0.87 2.69-1.89 4.78-3.28l-0.95-1.29-0.36 0.26c-1.35 0.76-1.6 0.99-2.97 0.19l-21.16-12.5zm-227.92 6.34c-2.54-0.07-4.89 1.04-6.67 3.89-1.7 2.73-1.25 6.18 2.11 9.19l2.77 2.47c1.92 1.73 1.72 3.81 0.87 5.17-1.79 2.88-4.96 2.89-7.66 1.21-1.65-1.03-3.51-3.55-3.58-5.62l1.64-2.85-1.27-0.79c-1.12 1.81-2.34 3.56-3.83 5.1 1.36 2.34 3.38 4.25 5.66 5.67 1.05 0.66 3.4 1.82 4.62 2.05 4.2 0.81 7.45-0.73 9.43-3.9 1.89-3.04 0.99-6.33-2.15-9.21l-2.27-2.07c-1.81-1.61-3.17-3.17-1.63-5.64 1.32-2.12 4.21-2.52 6.84-0.89 1.49 0.93 2.93 2.58 3.13 4.37l-1.51 2.58 1.42 0.89c1.04-1.47 2.04-3 3.27-4.26l0.11-0.46c-1.52-2.09-3.27-3.57-5.24-4.8-2.01-1.25-4.09-2.03-6.06-2.1zm207.7 7.1c-2.73 1.62-5.41 3.26-8.17 4.81-2.77 1.56-5.56 3-8.36 4.49l0.69 1.24c2.74-1.24 3.01-1.05 4.21 0.93l8.3 14.74c1.28 2.37 1.3 2.7-1.34 4.1l0.77 1.37c2.09-1.31 3.72-2.31 4.98-3.02 1.27-0.72 2.94-1.57 5.7-2.99l-0.79-1.4c-3.14 1.89-3.41 1.71-4.73-0.64l-3.85-6.83 3.74-2.11c0.59-0.33 1.85-0.99 2.45-0.3 0.58 0.57 0.95 1.31 1.35 2.02l1.34-0.75-3.9-6.93-1.31 0.73 0.48 0.85c0.24 0.5 0.54 0.89 0.27 1.47-0.4 0.66-1.17 1.05-1.82 1.41l-3.51 1.98-4.62-8.2 2.16-1.34c1.59-0.98 3.36-2.02 5.24-2.26l0.24 0.03c0.63 0.76 1.13 1.63 1.69 2.48l1.27-0.72c-0.91-1.93-1.67-3.73-2.22-5l-0.26-0.16zm-188.72 3.19c-0.84 1.79-1.61 4.07-2.42 5.71l1.36 0.61c0.45-0.82 0.86-1.66 1.19-2.21 0.74-0.57 1.16-0.67 2.02-0.41l5.02 2.23-7.61 17.1c-1.13 2.44-1.39 2.66-4.09 1.37l-0.64 1.44c2.3 0.9 4.07 1.6 5.4 2.19 1.33 0.6 3.01 1.43 5.22 2.53l0.65-1.47c-2.81-1.12-2.83-1.46-1.73-3.92l7.61-17.09 4.81 2.14c1.87 0.87 1.43 0.92 0.91 2.73-0.14 0.51-0.36 0.99-0.57 1.47l1.33 0.59c1.09-1.97 2.18-3.98 2.97-5.47-4.72-1.98-8.13-3.41-10.83-4.61-2.69-1.2-6.11-2.81-10.6-4.93zm162.92 11.27c-2.09-0.06-4.34 0.38-6.67 1.31-7.95 3.14-11.46 9.59-8.22 17.77 3.14 7.91 9.53 10.28 17.3 7.2 8.02-3.17 11.34-10.07 8.12-18.22-2.12-5.34-5.93-7.93-10.53-8.06zm-129.75 1.82l-0.98 1.31-1.04 1.28-1.67 2.19-9.79 12.19c-0.86 1.03-1.65 2.24-2.86 2.93-0.72 0.18-1.46 0.03-2.17-0.18l-0.46 1.54c1.75 0.4 3.06 0.72 4.09 1.03 1.04 0.31 2.31 0.76 3.99 1.38l0.43-1.43c-0.65-0.43-3.04-1.18-2.37-2.11l3.05-4.35 8.98 2.68 0.46 5.4c0.1 1.35-2.04 0.56-3.07 0.48l-0.43 1.43c2.39 0.6 4.2 1.06 5.6 1.48 1.39 0.42 3.12 1.01 5.49 1.83l0.46-1.53-0.43-0.13c-1.41-0.62-1.75-0.68-1.94-2.25l-2.8-24.41-2.54-0.76zm14.44 4.32c-0.36 1.95-0.53 4.34-0.9 6.13l1.47 0.25c0.23-0.91 0.42-1.83 0.59-2.44 0.58-0.74 0.96-0.94 1.86-0.9l5.41 0.9-3.06 18.44c-0.48 2.65-0.68 2.92-3.61 2.35l-0.26 1.55c2.45 0.29 4.34 0.53 5.78 0.77 1.43 0.24 3.26 0.62 5.67 1.13l0.27-1.58c-3-0.39-3.1-0.7-2.66-3.35l3.06-18.45 5.19 0.86c2.02 0.37 1.62 0.53 1.57 2.42-0.01 0.52-0.1 1.04-0.18 1.55l1.43 0.24c0.55-2.18 1.11-4.39 1.5-6.03-5.07-0.73-8.72-1.26-11.63-1.74s-6.62-1.18-11.5-2.1zm71.11 2.46c-0.58 0.03-1.16 0.07-1.73 0.14-5.38 0.65-9.52 3.44-8.81 9.38 0.38 3.19 2.89 5.6 7.4 5.84l3.71 0.2c2.58 0.14 3.73 1.88 3.92 3.48 0.41 3.37-2.07 5.36-5.22 5.74-1.93 0.23-4.96-0.57-6.31-2.14l-0.51-3.25-1.48 0.18c0.25 2.11 0.4 4.24 0.2 6.37 2.53 0.98 5.3 1.21 7.97 0.89 1.23-0.15 3.79-0.72 4.89-1.3 3.78-2 5.35-5.23 4.91-8.95-0.43-3.56-3.19-5.56-7.44-5.84l-3.07-0.19c-2.42-0.13-4.46-0.48-4.81-3.38-0.3-2.48 1.7-4.6 4.78-4.97 1.75-0.21 3.9 0.17 5.18 1.44l0.43 2.96 1.67-0.2c-0.1-1.79-0.28-3.61-0.12-5.36l-0.2-0.43c-1.87-0.51-3.63-0.67-5.36-0.61zm-41.47 1.87l-0.03 1.42c2.98 0.33 3.12 0.63 3.15 2.95l-0.39 17.56c-0.04 1.64-0.43 2.38-2.15 2.71l-0.03 1.09c3.93-0.03 6.88-0.04 9.23 0.01 2.32 0.05 5.23 0.19 9.41 0.4l0.52-6.42-1.46-0.03c-0.29 1.3-0.55 2.94-0.83 3.6-0.97 0.36-3.4 0.38-9.46 0.25l0.23-10.09 4.96 0.11c0.68 0.01 1.87 0.11 2.04 0.98 0.21 0.75 0.08 1.53 0.13 2.32l1.57 0.03 0.18-8.03-1.5-0.03c-0.01 0.86-0.11 1.6-0.3 2.23-0.13 0.67-0.65 0.66-1.18 0.65l-5.86-0.13 0.17-7.95c0.01-0.45 0.13-0.94 0.29-1.34 1.09 0.02 5.87 0.09 7.21 0.23 0.82 0.09 1.68 0.26 1.7 0.86 0.06 0.82 0.11 1.68 0.09 2.51l1.42 0.03 0.47-4.1 0.18-1.38c-3.29 0-6.58 0.04-9.87-0.03-3.32-0.07-6.61-0.26-9.89-0.41z",
    fill: "#081b55",
    transform: "matrix(1.002,0,0,1.002,-1,-1)"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "369.73 419.26 372.15 428.44 377.87 424.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.73 218.71c0.35986-0.9961 0.54199-1.9888 0.71777-2.9473 0.51074-2.7739 0.72754-5.4941-1.0645-7.8774-1.6587-2.1455-4.6777-3.4438-7.3145-3.9282-2.4985-0.4585-5.7437-0.52393-7.917 1.0928-2.1396 1.626-2.9038 4.2466-3.3638 6.7456-0.19531 1.061-0.2583 2.1821-0.40527 3.3589l19.347 3.5557z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.5 136.02 70.152 143.64 73.904 137.62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.07 38.323c-0.28223 2.5225-0.10498 5.3086 0.93017 7.6279 1.1167 2.5405 2.9819 3.6943 5.7134 3.999 5.7378 0.64258 8.0039-4.2822 8.5508-9.1567 0.28223-2.5234 0.22998-5.189-0.76709-7.541-1.1426-2.6128-2.939-3.7598-5.7051-4.0669-6.0825-0.68213-8.1416 3.9526-8.7222 9.1377z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.94 123.77 418.73 126.07 422.85 131.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.475 404.98c0.61572 0.86035 1.3291 1.5737 2.0181 2.2637 1.9927 1.9907 4.1084 3.7114 7.085 3.5869 2.7065-0.14795 5.4849-1.8945 7.3774-3.7891 1.7964-1.7954 3.6885-4.4282 3.5894-7.1338-0.12451-2.6816-1.8462-4.7949-3.6426-6.5913-0.76221-0.7622-1.6475-1.4512-2.5337-2.2368l-13.894 13.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.72 448.3 183.86 455.77 190.66 457.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.49 456.27c0.93506 2.3599 2.3984 4.7344 4.4014 6.2974 2.1758 1.7192 4.3638 1.8628 6.918 0.85206 5.3667-2.125 5.0562-7.5366 3.252-12.095-0.93408-2.3599-2.23-4.689-4.2129-6.2969-2.2344-1.7705-4.3584-1.9385-6.9438-0.91552-5.6895 2.2524-5.334 7.3086-3.4146 12.158z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "454.53 277.48 462.91 281.95 463.73 274.9"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    fill: "#081b55"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m247.15 93.838c-0.74219-0.17383-1.0332-0.17822-1.2842 0.66846l-1.5093 5.0742c-0.12793 0.4292 0.062 0.49707 0.95264 0.76318 1.6089 0.47754 2.3081 0.63819 3.3379-0.58496l0.26855 0.08057-1.0703 1.7129-5.771-1.7153 0.0601-0.2041c0.7002 0.16016 0.97461 0.13867 1.2207-0.68799l1.4155-4.7622c0.25196-0.84912 0.0137-0.98926-0.64697-1.2441l0.0625-0.20361 3.0234 0.89893-0.0596 0.2041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.68 102.82-1.9023 2.6582-0.17285-0.12305c0.55664-0.85498 0.36572-1.0312-0.30713-1.5142l-4.5488-3.2564-0.35254 0.49122c-0.7168 1-0.72021 1.3706 0.12891 2.2808l-0.15576 0.21777-1.5088-1.1616 3.6743-5.1318 1.5864 1.0522-0.15723 0.21777c-1.1367-0.5249-1.4824-0.38818-2.2007 0.61426l-0.35108 0.49121 4.6499 3.3286c0.61962 0.44238 0.87011 0.45703 1.4448-0.28809l0.17285 0.12305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.02 102.05c0.74219-0.57812 0.63672-0.80517 0.15381-1.4907l-2.7935-3.9595c-0.47754-0.67627-0.66943-0.67871-1.3852-0.25537l-0.12305-0.17285 2.5425-1.7949 0.12207 0.1748c-0.65479 0.54541-0.68213 0.74072-0.22363 1.3901l1.251 1.7749 2.771-1.9556-1.251-1.7729c-0.47802-0.67725-0.66992-0.67822-1.3857-0.25488l-0.12305-0.17529 2.543-1.792 0.12158 0.17432c-0.65576 0.54394-0.68164 0.74072-0.22461 1.3887l2.8648 4.061c0.42529 0.60303 0.64014 0.71289 1.3852 0.25537l0.12305 0.17285-2.5425 1.7939-0.12207-0.1748c0.7417-0.57715 0.63672-0.8042 0.15234-1.4907l-1.2578-1.7827-2.7705 1.9546 1.3286 1.8843c0.42578 0.60205 0.64013 0.71142 1.3852 0.25439l0.12354 0.17383-2.542 1.793-0.12304-0.17383z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.43 97.513c0.90088-0.30469 0.97217-0.52588 0.73584-1.2837l-1.48-4.7432c-0.24707-0.79053-0.43701-0.8706-1.3369-0.63672l-0.062-0.20361 3.1714-0.98877 0.0635 0.20068c-0.771 0.27686-1.0142 0.43506-0.74756 1.2886l1.4814 4.7422c0.25976 0.83301 0.5498 0.86035 1.3457 0.63574l0.0645 0.20215-3.1728 0.99024-0.063-0.20361z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.46 90.66-0.27881 0.03076c-0.29004-0.89111-1.1123-1.8145-2.2798-1.686-0.55664 0.06104-1.085 0.46875-1.0093 1.1572 0.18408 1.6699 3.9238 1.4829 4.1753 3.7632 0.10303 0.94629-0.53516 2.0972-2.126 2.272-0.8457 0.09277-1.4326-0.22608-1.7646-0.18848-0.23486 0.02588-0.32519 0.22705-0.30615 0.40625l-0.24365 0.02588-0.59424-2.3213 0.25635-0.02832c0.26904 0.50049 0.99463 1.8838 2.4976 1.7178 0.88965-0.09717 1.2646-0.78027 1.1982-1.3823-0.0703-0.6333-0.28906-0.99121-2.0303-1.769-1.0874-0.47559-1.853-0.8877-1.9746-1.9883-0.14014-1.269 0.80371-2.0029 1.8052-2.1128 0.66748-0.07422 1.3101 0.23828 1.5874 0.20654 0.31202-0.03369 0.33985-0.2959 0.34815-0.4209l0.2334-0.0249 0.50586 2.3428z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230.37 89.903c-0.55517 0.01904-0.75293 0.15137-0.96386 0.56445-1.0312 1.9658-2.2246 4.2271-3.1548 6.2842l-0.16601-0.02148c-0.24073-1.2031-0.8501-3.6514-1.1733-4.9214l-2.312 4.4731-0.16601-0.02002c-0.34766-1.7705-1.0962-5.0708-1.3765-6.2349-0.2373-0.96777-0.35009-1.3086-0.97656-1.4453l0.0269-0.21094 2.7192 0.34863-0.0273 0.21143c-0.50146-0.04199-0.73291-0.0049-0.76904 0.28418-0.02 0.15478 0.0215 0.35254 0.0591 0.50391l1.062 4.3784 1.5898-2.9775-0.24952-0.95752c-0.24804-0.96728-0.40527-1.0557-0.99218-1.1411l0.0259-0.21143 2.9648 0.38037-0.0283 0.21045c-0.34326-0.04297-0.85693-0.0874-0.90869 0.3125-0.0239 0.18848 0.0776 0.44922 0.18945 0.9043l0.97803 3.9731 1.8706-3.5845c0.11866-0.22266 0.25098-0.54346 0.28028-0.77686 0.0566-0.43262-0.32618-0.52734-0.7002-0.6084l0.0273-0.21045 2.1982 0.28125-0.0273 0.21143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.79 98.731-5.896-1.3164 0.0449-0.20898c0.70899 0.11279 0.98243 0.07129 1.1709-0.77002l1.084-4.8481c0.19189-0.86182-0.0557-0.98682-0.73047-1.1948l0.0459-0.20752 5.7978 1.2974-0.31592 1.5679-0.27344-0.06055c0.0532-1.0083-0.19189-1.2466-1.4018-1.5186l-1.4746-0.32861c-0.2295-0.05127-0.36035-0.08057-0.44385 0.29102l-0.54199 2.4233 1.6812 0.37598c0.97217 0.21777 1.1401-0.02051 1.4326-0.76807l0.25195 0.05517-0.56543 2.5327-0.25195-0.05518c0.063-0.90234-0.0654-1.0933-0.96875-1.3052l-1.6768-0.39893-0.60645 2.708c-0.0991 0.44678-0.10254 0.45801 1.5244 0.82178 1.3652 0.30615 1.9839 0.10059 2.7119-0.89404l0.30615 0.06738-0.90429 1.7344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.8 94.801c0.0483-0.62354 0.15576-1.9966 0.23584-2.2988 0.0781-0.29248 0.36573-0.37842 0.58252-0.3208 0.20557 0.0542 0.41455 0.27197 0.33789 0.56348-0.0801 0.30371-0.66406 1.5488-0.9292 2.1157l-0.22705-0.05957z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.9 96.099c-0.73633-0.19971-1.0264-0.21484-1.3076 0.62305l-1.6846 5.0176c-0.14209 0.42481 0.0454 0.49903 0.92578 0.79492 1.5923 0.53418 2.2842 0.71924 3.356-0.46728l0.26514 0.0894-1.1294 1.6743-5.7061-1.916 0.0679-0.20117c0.69287 0.18653 0.96875 0.17188 1.2427-0.64453l1.581-4.7095c0.28125-0.83887 0.0474-0.98682-0.60302-1.2646l0.0679-0.20068 2.9922 1.0024-0.0679 0.20215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m261.69 105.76c0.8086 0.26855 0.99951 0.1499 1.2852-0.57813l1.8179-4.625c0.30225-0.77099 0.229-0.91992-0.54785-1.2974l0.0772-0.19824 2.8125 1.105c2.4995 0.9834 3.709 2.77 2.793 5.1035-0.54492 1.3843-2.1699 3.103-5.3574 1.8496l-2.958-1.1631 0.0776-0.19629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m276.01 111.62-5.624-2.2109 0.0781-0.19776c0.68311 0.22022 0.9585 0.22022 1.2749-0.58154l1.8164-4.6235c0.32519-0.82276 0.0996-0.9834-0.53711-1.294l0.0776-0.19873 5.5312 2.1738-0.5542 1.5029-0.26075-0.10303c0.20899-0.98926 0.003-1.2612-1.1528-1.7148l-1.4058-0.55323c-0.22021-0.0859-0.34424-0.13574-0.4834 0.21875l-0.90869 2.3125 1.6035 0.62989c0.92675 0.36474 1.1299 0.15576 1.5352-0.53955l0.23975 0.0937-0.94971 2.4175-0.23926-0.0937c0.20215-0.8833 0.10352-1.0898-0.75781-1.4409l-1.5952-0.65137-1.0151 2.5845c-0.16846 0.42676-0.17187 0.43702 1.3799 1.0464 1.3018 0.51172 1.9453 0.4043 2.8169-0.46729l0.29248 0.11524-1.1621 1.5752z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m283.62 111.83c0.22949-0.91943 0.0205-1.1226-0.75635-1.4399l-1.5015-0.61426-0.89648 2.2812c-0.30713 0.78125-0.14942 0.9878 0.5791 1.3096l-0.0781 0.19727-2.9165-1.1455 0.0781-0.19775c0.79736 0.26514 0.98339 0.15771 1.3198-0.6958l1.773-4.5107c0.32275-0.82276 0.0981-0.9834-0.5376-1.2925l0.0767-0.19874 5.5312 2.1748-0.5542 1.5015-0.26074-0.10156c0.20899-0.99023 0.002-1.2637-1.1528-1.7163l-1.417-0.55761c-0.25977-0.10157-0.3501-0.0894-0.47315 0.22363l-0.90869 2.312 1.5107 0.59424c0.8545 0.33496 1.123 0.19971 1.5342-0.54004l0.23926 0.0937-0.94824 2.4175-0.24072-0.0947z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.77 117.42-5.624-2.2095 0.0767-0.19873c0.68311 0.22021 0.95996 0.22119 1.2749-0.58155l1.8188-4.626c0.32324-0.82178 0.0972-0.9834-0.53857-1.2925l0.0781-0.19776 5.5303 2.1748-0.55469 1.5005-0.25928-0.10157c0.20752-0.98828 0.002-1.2612-1.1528-1.7163l-1.4072-0.55224c-0.21875-0.0869-0.34277-0.13526-0.48291 0.21924l-0.90771 2.311 1.603 0.62988c0.92725 0.36475 1.1294 0.15723 1.5347-0.53808l0.24024 0.0947-0.95069 2.416-0.23925-0.0947c0.20312-0.88183 0.104-1.0898-0.75635-1.4385l-1.5957-0.65235-1.0161 2.583c-0.16699 0.42676-0.17138 0.43799 1.3799 1.0478 1.3027 0.51172 1.9463 0.4043 2.8184-0.46875l0.29102 0.11524-1.1606 1.5762z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.67 114.36c-0.68555-0.18408-1.0352-0.27441-1.5142 0.94483l-2.1528 5.4785-0.17774-0.0688-2.3394-7.5108-0.02-0.008-1.5967 4.0625c-0.42139 1.0737-0.29346 1.3887 0.45508 1.7183l-0.0781 0.19776-2.4487-0.96192 0.0791-0.19873c0.81153 0.25977 1.0918 0.18946 1.5342-0.93506l1.8042-4.5933c-0.22119-0.68847-0.36816-0.80566-0.78467-0.96972l0.0781-0.19874 1.7817 0.70118 2.0195 6.5771 0.0205 0.009 1.3672-3.48c0.47119-1.1978 0.21241-1.3955-0.47509-1.7261l0.0767-0.19775 2.4478 0.96191-0.0767 0.19775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m303.08 121.64c0.84912 0.063 1.0049-0.0972 1.1045-0.875l0.62744-4.9277c0.104-0.82178-0.003-0.94824-0.8501-1.123l0.0274-0.21142 2.9966 0.38183c2.6646 0.33838 4.2744 1.7739 3.9585 4.2598-0.18847 1.4761-1.3428 3.54-4.7388 3.1064l-3.1514-0.40088 0.0259-0.20996z"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m264.15 105.77c-0.12647 0.32178-0.0395 0.43457 0.4165 0.6128 0.60645 0.2373 2.938 1.1543 4.022-1.6045 0.3125-0.79589 0.3872-1.6528-0.0352-2.4971-0.2959-0.58642-0.72608-1.0513-1.9204-1.52-0.44629-0.17626-0.51611 0.004-0.59082 0.19434l-1.8921 4.8144z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m305.47 121.06c-0.044 0.34228 0.0679 0.42822 0.55224 0.49121 0.64698 0.0825 3.1309 0.39844 3.5059-2.5405 0.1084-0.84912-0.0308-1.6968-0.64844-2.4126-0.42871-0.49561-0.95849-0.84131-2.2319-1.0029-0.47412-0.061-0.49902 0.13232-0.5249 0.33447l-0.65283 5.1304z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m103.14 274.27c-3.4062-2.7564-8.7627-9.0669-10.645-10.746-1.8833-1.6777-0.02588-6.208 2.4727-3.8242 2.501 2.3858 6.0654 5.4771 6.9497 6.4604l1.7197 3.7432-0.49707 4.3662z",
    stroke: "#061742",
    strokeWidth: 0.73857,
    fill: "#081b55"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m103.6 267.77c-3.4062-2.7549-6.105-6.1284-7.9868-7.8066-1.8823-1.6787-0.02588-6.2085 2.4736-3.8228 2.4985 2.3833 6.0645 5.4751 6.9482 6.4585l1.7197 3.7427-3.1548 1.4282z",
    stroke: "#061742",
    strokeWidth: 0.73857,
    fill: "#081b55"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.68 260-3.271 1.2768c-5.7026 1.5562-3.1475 10.295-0.82764 12.16 10.29 8.2754 34.598 15.339 64.685 7.5967l3.6524-0.73731-1.8604-4.4575-62.378-15.839z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "m105.04 278.32s4.189 30.056 4.5635 32.303c0.84229 1.4971 0.62354 1.8403 2.123 1.8403 1.4043-2.1543 5.7422-2.4028 9.8613-0.34326 2.1543 0.37597 8.0537 2.6216 29.776-9.9248 0 0 22.145-12.781 23.642-14.278-34.418 8.8574-62.086-0.5083-69.966-9.5972z",
    stroke: "#061742",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828,
    fill: "#081b55"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m105.04 278.32s6.5982 8.9175 30.31 12.475c16.786 2.5166 34.97-1.3989 38.887-2.5181 0 0 4.4756-2.5176 5.0288-2.373l-2.3408-5.606-3.6524 0.73731c-30.087 7.7422-54.395 0.67871-64.685-7.5967-2.3198-1.8652-4.875-10.604 0.82764-12.16 1.2852-0.57373-0.37451-2.7129-1.498-2.5268-7.022 3.1831-5.8252 9.2256-5.8022 9.8003 0.0723 1.9038 0.32178 7.2095 2.9243 9.7681z",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828,
    fill: "#b9a400"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#bfbfbf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m108.62 303.34 7.3413-10.695 0.27783-6.9448s-2.0312-5.8047 2.1655-6.6436c0 0 2.9365 0.90869 3.8467 1.2588-3.0078 1.0478-2.0977 4.7558-2.0469 6.9238l0.25049 5.7798 11.82 18.161-4.1201 0.93604-9.9473-15.352-8.939 11.209",
    strokeLinecap: "round",
    strokeWidth: 0.73857
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.62 283.88c-2.7275 0.771-1.4936 5.6655-1.4936 7.2036v5.1167l-4.9858 14.979 4.6812-1.6846 3.1128-9.7358 3.9551 6.4819 3.3716-1.8721-6.2031-8.5425 0.1084-4.3237c0-1.5376-0.23828-6.2231 1.8608-7.481-1.3301-0.0713-3.1211-0.50244-4.4072-0.14112z",
    strokeWidth: 0.74828
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158 283.53c-1.8267 0.11426-0.48975 6.2246-0.48438 7.5537l-0.34668 3.8062-2.1768 5.1475 8.0527-4.6821-1.0073-2.7124-0.26757-1.9688c0.14599-1.3384 1.4702-7.7026-0.20313-7.564-0.83984 0.0698-2.4487 0.3501-3.5669 0.41992z",
    strokeWidth: 0.74828
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.73857
  }, /*#__PURE__*/React.createElement("path", {
    d: "m115.37 285.24c0.72559 0.29004 4.3364 1.8188 5.2456 2.0976 0.90869 0.28028 1.1186-0.979 0.14013-1.3286-0.979-0.34912-4.2344-1.6206-5.0361-1.8882-1.0488-0.3501-1.3989 0.69922-0.34961 1.1191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.18 290.83c0.77685 0.0791 4.6699 0.5503 5.6206 0.56836 0.95069 0.0181 0.80469-1.04-0.23291-1.1069-1.0376-0.064-4.5171-0.59717-5.3608-0.6333-1.1055-0.0464-1.1514 1.0581-0.0269 1.1719z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.03 291.06c0.77685-0.0889 4.6802-0.45459 5.6128-0.64014 0.93359-0.18408 0.56543-1.1865-0.46191-1.0308-1.0274 0.15723-4.54 0.37598-5.3745 0.51953-1.0884 0.18946-0.89892 1.2793 0.22364 1.1514z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m206.21 257.68-17.625 1.958 1.1758 19.583-10.543 6.7319c-4.4951-2.6206-9.9722-14.336-26.217-5.6172-14.912 8.0029-36.864-8.6558-43.07-18.353-32.829-51.276 11.235-117.6 13.482-119.1 3.7451 3.7441 88.797 108.3 88.797 108.3-4.3086 3.1333-5.999 6.4888-5.999 6.4888z",
    stroke: "#9ebbd9",
    strokeWidth: 0.74828
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#c50025",
    d: "m120.23 272.09c-2.2466-8.0537-1.123-16.292 5.0562-20.785l-10.487-8.4287c-6.1797 4.4951-7.4902 9.7383-5.2436 17.79l4.3696 5.8057 6.3047 5.6182z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#c50025",
    d: "m132.76 257.1c-6.4956 7.4102-2.2627 11.224 2.0088 15.245 3.2202 3.0293 3.3701 8.3643 8.2715 9.7681l0.82422 0.43897c2.0146-0.0947 5.1104-0.0664 9.1314-2.2173 16.465-8.8071 21.735 3.0034 26.217 5.6172l8.3247-5.2119-0.83447-1.1553c-3.7881-7.5747-15.727-19.873-23.595-8.9873-7.4912 10.361-13.889 7.9892-17.604 4.4936-1.3491-1.27-6.4697-7.9849-2.4648-14.295"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#081b55",
    d: "m104.42 181.16c-3.481 10.752-6.0732 23.265-6.1943 36.87-0.05615 6.3193 0.41992 12.876 1.5908 19.601 4.4941-3.7451 6.3672-9.3638 9.7373-9.7373 3.3706-0.375 2.9966 12.359 5.2436 14.98 2.2466 2.623 21.722 18.352 26.966 19.101 3.7451-3.3701 19.101-20.973 19.101-28.836 0-7.8652 7.1157-15.356 17.978-22.473-4.1201-5.6172-51.685-63.668-55.43-67.787-0.3999 0.80029-11.663 15.639-18.991 38.282z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "151.87 195.69 155.62 194.94 153 198.31 154.5 201.31 151.12 199.43 147.75 203.18 148.13 198.69 143.63 197.56 148.88 196.44 149.25 191.57",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "108.05 206.17 111.8 205.43 109.18 208.8 110.68 211.79 107.31 209.92 103.93 213.67 104.31 209.17 99.814 208.05 105.06 206.92 105.43 202.06",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#c50025",
    d: "m191.91 225.63c-1.0151 2.0078-5.6157 3.832-7.8276 5.2617-5.9922 3.8691-5.7436 8.3633-7.2412 14.731-1.498 6.3672-1.498 15.229-7.1162 19.349 0 0-2.6323-0.28906-4.1338 1.9888 0 0-1.7388 0.29102-5.3564 5.5176-2.4849 3.5918-8.6309-1.1201-8.9863-3.1367-0.37353-2.1226 0.99903-5.4927 6.6177-9.6118 5.6157-4.1201 7.8628-12.735 9.3623-19.101 1.498-6.3672 2.3721-11.61 6.4922-14.982 5.126-4.1943 8.1138-5.6172 11.1-8.0957"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#c50025",
    d: "m207.64 244.8c-2.1216 5.6558-7.7251 9.0112-11.199 13.432-0.0688 0.0903-0.13916 0.17872-0.20654 0.26416l0.20654-0.26416c0.375 0-7.8652 1.4995-7.8652 1.4995l0.375 7.6147c-0.79395-0.43799-1.25-1.2817-2.0269-1.689-0.333-0.1753-0.84033 0.0381-1.1992-0.10742-1.522-0.62012-4.7148-0.53516-4.3896-2.3237 0.99902-5.4932 1.6235-6.8662 5.7436-12.109 4.1196-5.2436 11.235-8.9888 11.984-16.853"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    strokeWidth: 3.1333,
    y2: 143.27,
    x2: 123.41,
    stroke: "#000",
    strokeMiterlimit: 10,
    y1: 251.14,
    x1: 211.91,
    fill: "none"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.33 185.07 119.08 184.32 116.46 187.69 117.96 190.68 114.59 188.81 111.22 192.56 111.59 188.06 107.1 186.94 112.34 185.81 112.71 180.95",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b76b6",
    d: "m128.28 170.6c-1.2983 12.37 24.725 60.322 32.048 65.355 0.77002-2.728 0.49024-4.8257 1.0488-6.5059-6.5044-2.2368-32.32-43.04-29.794-60.426 1.189-8.1826-2.1675-9.2314-3.3022 1.5772z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.99 210.3 162.73 209.55 160.11 212.92 161.61 215.91 158.24 214.04 154.87 217.79 155.24 213.29 150.75 212.17 155.99 211.04 156.37 206.17",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b76b6",
    d: "m113.19 200.07c2.1621 1.2588 18.184 23.219 16.506 26.855-1.6787 3.6382-1.6787 25.179 1.398 29.094 1.8892 1.2602 2.939 2.0293 4.0581 2.5894-2.5181-6.4346-3.3818-27.687-2.938-31.684 0.83887-7.5522-14.294-27.027-16.506-27.974-3.9165-1.6787-6.6963-1.3144-2.5176 1.1191z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#5b76b6",
    d: "m123.54 192.52c0.53808 3.2788 9.5859 22.834 12.868 25.177 5.8755 4.1968 14.828 32.242 13.149 35.599-1.3989 1.6792-2.5879 3.0078-2.5879 3.0078-0.5586-5.5957-5.2456-32.172-11.96-36.369-3.4214-2.1387-13.427-23.149-13.708-26.297-0.70557-7.9438 1.3989-6.2246 2.2393-1.1186z"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "128.65 188.2 132.4 187.45 129.78 190.82 131.27 193.82 127.9 191.94 124.53 195.69 124.91 191.2 120.41 190.07 125.66 188.95 126.03 184.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.14 203.55 139.89 202.81 137.27 206.17 138.76 209.17 135.39 207.3 132.02 211.04 132.4 206.55 127.9 205.43 133.15 204.3 133.52 199.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.15 167.97 130.9 167.23 128.28 170.6 129.78 173.59 126.41 171.72 123.03 175.47 123.41 170.97 118.91 169.85 124.16 168.72 124.53 163.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.51 180.71 146.25 179.96 143.63 183.33 145.13 186.33 141.76 184.45 138.39 188.2 138.76 183.7 134.27 182.58 139.51 181.46 139.89 176.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.13 221.91 151.87 221.16 149.25 224.53 150.75 227.52 147.38 225.65 144.01 229.4 144.38 224.9 139.89 223.78 145.13 222.66 145.51 217.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.29 209.55 126.03 208.8 123.41 212.17 124.91 215.16 121.54 213.29 118.17 217.04 118.54 212.54 114.05 211.42 119.29 210.3 119.66 205.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.9 225.28 134.65 224.53 132.02 227.9 133.52 230.89 130.15 229.02 126.78 232.77 127.15 228.27 122.66 227.15 127.9 226.03 128.28 221.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.39 243.63 142.14 242.88 139.51 246.25 141.01 249.24 137.64 247.37 134.27 251.12 134.65 246.62 130.15 245.5 135.39 244.38 135.77 239.51"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m143.12 282.4c-14.542-0.64355-29.3-14.213-33.189-20.425-0.68897-1.0981-1.4712-2.4453-2.1182-3.5405",
    stroke: "#e6e6e6",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828,
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m119.27 145.45c-22.192 20.246-38.103 68.221-38.956 98.266l3.4517-0.53613c1.3604-32.813 16.296-73.245 33.004-89.781 0.82862-1.2349 4.3413-7.2837 5.4229-8.2773l-2.9233 0.32861z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.49 147.14c-2.3901 2.4526-0.90283 6.3716-1.9556 7.5796"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.12 151.96c-1.2534 1.4658 0.32422 5.1138-1.2192 7.1079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.42 156.78c-1.2637 1.7949 0.57227 4.9326-1.4892 7.9194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m105.62 162.37c-1.2114 2.0347 0.80273 4.8911-1.3188 8.3633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.26 168.16c-1.2285 2.1733 0.02 6.2041-0.95215 8.127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.729 174.77c-1.2871 2.6602 0.33789 6.3853-0.75098 8.7866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.504 181.7c-1.2026 2.8818 0.42432 7.0298-0.46973 9.2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.187 189.81c-1.0918 2.895 0.56543 7.2593-0.49365 10.792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.756 199.75c-1.4917 4.7476 1.0352 7.1055 0.10596 10.514"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.341 211.38c-0.99023 3.894 1.583 7.2441 0.94824 10.548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.051 221.66c-0.8584 4.1924 2.0312 7.7227 1.6865 10.498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.075 233.96c-0.24951 2.0132 2.9185 5.5767 2.6919 9.2148"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "m122.97 141.83c-1.8457 3.6367-3.0215 6.9238-5.6929 12.771-12.276 26.872-12.545 65.292-1.9702 89.753l2.9209-2.0708c-11.161-26.92-9.0811-58.944-0.20996-80.127 1.8188-3.6099 4.8403-12.003 7.4702-16.619l-2.5181-3.707z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m114.06 162.68c-0.57911 1.7695 2.2007 4.0503 1.5264 6.3975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.64 167.29c-0.46387 2.0381 2.3857 3.2158 1.4185 6.6211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m111.04 172.81c-0.32763 2.2051 2.2534 3.4336 1.6831 6.7554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110 177.66c-0.29004 2.3247 2.2832 4.8799 1.9287 6.8921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.14 182.99c-0.43017 2.7656 2.2559 5.0732 2.0244 7.5854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.22 190.02c-0.35352 2.8442 2.5371 5.4219 2.563 7.6211"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.77 198.08c-0.13232 2.7124 2.8892 4.25 2.9536 7.6338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.69 206.21c0.18555 4.5977 3.1728 5.1421 3.6191 8.3125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.37 216.21c0.57568 3.5894 3.7769 5.0488 4.4497 7.9961"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.74 225.33c0.75733 3.9936 4.4282 5.3213 5.1553 7.6743"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.32 236.19c0.53418 1.7295 4.7432 3.0776 5.9141 6.0967"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.92 155.45c-1.3438 3.4971 1.4541 5.8745 0.27881 8.8125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.9 148.55c-1.4546 3.2168 1.0068 6.9233 0.11279 9.0928"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.3 142.88c-0.61523 1.5376 1.231 6.5034 0.61572 7.9722"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m116.77 242.93c-3.0903 2.019-1.8247 5.6074-1.7363 7.0444 0.13526 2.2031 1.2949 4.5776 2.3686 2.6797 0.5376-0.9497 4.3945-3.3852 4.9092-3.1582 0.96094 0.42334 1.374-1.6562 0.17725-3.4067-0.64795-0.94824-2.8574-5.0288-5.7188-3.1592z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m116.19 244.3c-1.3989 1.4224 0.39746 7.8096 1.2173 8.3564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.54 244.09c-0.11865 0.38135-0.0376 5.6387 1.7046 7.6279"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.91 243.95c-0.15674 0.2622 0.75976 5.7256 2.3506 7.0376"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.08 243.15c2.2129 0.062 4.8203 4.8564 4.2295 6.3501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.82 243.45c1.4732 0.35449 3.8691 5.2324 3.7046 6.2349"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.49 243.72c0.39063 0.1128 3.3716 5.1597 3.209 6.3633"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.26 243.94c-0.0317 0.27978 2.2129 5.8203 2.8057 6.5894"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    strokeLinecap: "round",
    rx: 3.1163,
    ry: 1.5619,
    stroke: "#7f7100",
    cy: 243.11,
    cx: 116.82,
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "m82.204 243.05c-3.5811 0.39648-3.9604 4.6518-4.4824 6.1377-0.79932 2.2749-0.76416 5.2602 0.979 3.9268 0.87402-0.66846 5.3081-1.0772 5.6689-0.5791 0.67432 0.9292 1.9082-0.93506 1.5796-3.3149-0.17822-1.2905-0.43018-6.5376-3.7451-6.1704z",
    stroke: "#7f7100",
    strokeLinecap: "round",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.2798,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.114 244.12c-1.8325 0.68848-2.9111 8.0244-2.4131 9.0029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.511 244.09c-0.26562 0.31836-2.3882 5.6226-1.6782 8.5303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.899 244.14c-0.24707 0.17969-1.7173 6.1284-0.85693 8.2798"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.276 243.96c1.9341 1.2266 2.2397 7.3955 1.0938 8.5801"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.917 244.13c1.1562 1.1289 1.2412 7.2715 0.67676 8.188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.511 244.22c0.29834 0.31934 0.83106 6.939 0.18555 8.0571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.217 244.32c-0.146 0.26416-0.47217 6.9878-0.26904 8.0703"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("ellipse", {
    strokeLinecap: "round",
    rx: 3.0407,
    ry: 1.7668,
    cy: 243.26,
    cx: 82.179,
    strokeWidth: 0.55959
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.47 144.08c1.1919-2.5508 2.1372-2.8374-0.61768-3.5039 2.1792-4.5781 6.1353-2.7041-8.9482-8.356 2.3316 15.937 1.3379 11.674 6.2734 10.515 0.0674 2.8315 0.54736 1.9688 3.2925 1.3447z",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.74828
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.46 279.31s-0.32617-0.51611-20.599 12.732c-40.662 26.575-52.862 20.224-47.565 20.224 0.39209 0 28.266 42.831 28.266 42.831 12.593-9.7983 55.152-41.672 67.372-49.331 0 0 4.4394-3.4741 4.8315-3.4741 0.39161 0-5.875-19.191-5.875-19.191l-26.43-3.7915z",
    strokeWidth: 1.119
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    stroke: "#403801",
    strokeWidth: 0.74828,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.66 291.97c11.609 4.8677 20.19 14.167 22.063 32.144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.43 290.16c11.61 4.8686 20.131 14.022 22.003 31.997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.34 287.7c11.609 4.8686 20.06 13.483 21.933 31.459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.94 285.94c11.609 4.8686 20.177 13.366 22.049 31.342"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m149.17 350.48c1.1831 10.319-4.8857 17.302-16.869 9.812-9.7212-6.0757-19.954-24.565-19.954-24.565-8.5225-12.607-5.5259-32.957 12.451-21.72 17.978 11.235 24.718 32.582 24.346 38.575",
    strokeWidth: 1.119
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.35 335.73c-8.5225-12.607-5.5259-32.957 12.451-21.72 17.978 11.235 24.718 32.582 24.346 38.575",
    strokeMiterlimit: 10,
    strokeWidth: 1.119
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.06 319.89c-0.7295 5.4219 1.7354 12.097 8.0078 20.821 5.8179 8.0923 11.537 13.018 16.789 14.629",
    strokeMiterlimit: 10,
    strokeWidth: 0.72053
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m133.69 355.48c2.4209 1.2446 4.5186 1.5142 5.9399 0.56006 3.7803-2.5371 1.3599-12.768-5.4058-22.848-6.7666-10.081-15.316-16.197-19.098-13.659-1.2363 0.83105-1.811 2.4863-1.7837 4.6904",
    strokeWidth: 0.72053,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.79 344.65c-3.4946-2.3086-5.2153-0.0742-5.5449 0.31201-1.5073 1.7666-2.5293 5.5415-2.5293 5.5415-1.7139 2.8506-4.8369 4.7568-8.4038 4.7568-5.4116 0-9.7993-4.3867-9.7993-9.7974 0-8.0513 10.842-9.7993 9.7993-9.7993l-0.56202-0.12646s2.8081 0.40088 5.0347-0.26416c0.40723-0.12305 3.2676-1.4204 1.6436-5.477",
    strokeWidth: 1.119,
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.9 344.55c-0.33887-3.5869-2.6489-6.603-5.834-7.9512",
    strokeWidth: 0.69903,
    fill: "none"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m126.92 315.25c3.0127 1.3901 5.9507 4.6064 7.8325 6.1548 21.543-9.2324 62.387-35.809 66.863-40.285l-9.791-1.3989c-1.958 2.5166-48.959 31.612-64.905 35.529z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#c4b011",
    d: "m128.24 315.31c16.044-4.5015 61.283-32.338 63.722-35.02l8.7095 1.1167c-4.4248 4.3037-44.544 30.215-65.537 39.372-1.6372-1.3877-4.2261-4.1772-6.895-5.4692z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#cfbd22",
    d: "m129.55 315.38c16.143-5.0864 59.623-31.665 62.54-34.512l7.6279 0.83692c-4.373 4.1289-43.767 29.376-64.211 38.459-1.3911-1.2275-3.6314-3.5894-5.957-4.7842z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9ca35",
    d: "m130.87 315.44c16.241-5.6729 57.96-30.993 61.358-34.004l6.5464 0.55566c-4.3223 3.9566-42.99 28.537-62.884 37.545-1.145-1.0669-3.0371-3.001-5.02-4.0972z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4d74a",
    d: "m132.19 315.51c16.339-6.2563 56.3-30.319 60.177-33.496l5.4624 0.27539c-4.2705 3.7827-42.212 27.699-61.557 36.632-0.90137-0.90771-2.4434-2.4131-4.083-3.4121z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#efe561",
    d: "m133.5 315.57c16.438-6.8423 54.638-29.646 58.995-32.986l4.3809-0.005c-4.2183 3.6084-41.436 26.861-60.231 35.718-0.65478-0.74707-1.8472-1.8257-3.1445-2.7266z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#faf27b",
    d: "m134.82 315.64c0.95264 0.80518 1.7983 1.4541 2.2061 2.0405 18.247-8.7832 54.738-31.37 58.906-34.804l-3.2993 0.28662c-4.8369 3.5049-41.276 25.05-57.812 32.477z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    stroke: "#b3aa35",
    strokeWidth: 0.74828,
    strokeLinecap: "round",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.14 293.11c2.4321 1.208 4.7095 2.6421 6.7905 4.3457"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.08 291.37c2.3994 1.2021 4.644 2.6206 6.6943 4.3008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.08 288.95c2.3901 1.189 4.6216 2.5718 6.6582 4.208"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.79 287.24c2.3589 1.1743 4.5649 2.5361 6.585 4.1416"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cy: 342.53,
    cx: 114.46,
    r: 5.3862,
    fill: "#b9a400"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cy: 342.21,
    cx: 114.46,
    r: 4.7524,
    fill: "#c4b011"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cy: 341.9,
    cx: 114.46,
    r: 4.1189,
    fill: "#cfbd22"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cy: 341.58,
    cx: 114.46,
    r: 3.4844,
    fill: "#d9ca35"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cy: 341.27,
    cx: 114.46,
    r: 2.8511,
    fill: "#e4d74a"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cy: 340.95,
    cx: 114.46,
    r: 2.2168,
    fill: "#efe561"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cy: 340.64,
    cx: 114.46,
    r: 1.5818,
    fill: "#faf27b"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 327.61,
    r: 17.478,
    cy: 348.88
  }), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "m322.62 339.91c-1.2998 0.38965-3.3374 2.1733-2.4434 3.6641 0.81543 1.3569 2.9863 2.8506 4.3438 2.3076 1.3569-0.54296 3.0122-2.8755 2.4434-3.8003-1.0864-1.7637-2.9868-2.5791-4.3438-2.1714z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "m360.1 339.91c-1.2993 0.38965-3.3374 2.1733-2.4434 3.6641 0.81543 1.3569 2.9868 2.8506 4.3438 2.3076 1.3569-0.54296 3.0122-2.8755 2.4434-3.8003-1.0864-1.7637-2.9854-2.5791-4.3438-2.1714z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m333.73 327.99-1.2319 4.2036c-0.6582-0.21875-1.3018-0.41065-2.0976-0.48779l0.76318-2.606h-7.874l0.88281 2.6929c-0.66065 0.14941-1.2983 0.20019-2.0054 0.48144l-1.3696-4.1812c-0.1626-0.43701 0.11865-0.93603 0.67773-0.93603h11.47c0.55908 0 0.93945 0.39746 0.78467 0.83301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m318.66 333.96c-0.56347-1.3301-1.8809-2.2637-3.4165-2.2637-2.0478 0-3.7065 1.6597-3.7065 3.708 0 1.3999 0.77685 2.6182 1.9214 3.2495 0.66748-0.0815 1.0176-0.57031 1.294-1.4702-0.78125-0.21583-1.3535-0.93165-1.3535-1.7793 0-1.0195 0.82617-1.8462 1.8447-1.8462 0.88428 0 1.6235 0.62207 1.8042 1.4507 0.64502 0.76563 2.1138-0.21289 1.6123-1.0488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m336.61 333.96c0.56348-1.3301 1.8799-2.2637 3.4155-2.2637 2.0478 0 3.7065 1.6597 3.7065 3.708 0 1.3999-0.77441 2.6182-1.9214 3.2495-0.66748-0.0815-1.0166-0.57031-1.294-1.4702 0.77979-0.21583 1.3545-0.93165 1.3545-1.7793 0-1.0195-0.82618-1.8462-1.8457-1.8462-0.88428 0-1.6226 0.62207-1.8032 1.4507-0.646 0.76563-2.1138-0.21289-1.6123-1.0488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 363.13,
    r: 17.478,
    cy: 348.88
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#4d4d4d",
    d: "m360.1 339.91c-1.2993 0.38965-3.3374 2.1733-2.4434 3.6641 0.81543 1.3569 2.9868 2.8506 4.3438 2.3076 1.3569-0.54296 3.0122-2.8755 2.4434-3.8003-1.0864-1.7637-2.9854-2.5791-4.3438-2.1714z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m369.26 327.99-1.2319 4.2036c-0.65674-0.21875-1.3003-0.41065-2.0967-0.48779l0.76367-2.606h-7.8755l0.88282 2.6929c-0.66065 0.14941-1.2974 0.20019-2.0054 0.48144l-1.3682-4.1812c-0.1626-0.43701 0.11719-0.93603 0.67725-0.93603h11.469c0.56005 0 0.93945 0.39746 0.78466 0.83301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m354.19 333.96c-0.56348-1.3301-1.8814-2.2637-3.4155-2.2637-2.0483 0-3.708 1.6597-3.708 3.708 0 1.3999 0.77686 2.6182 1.9219 3.2495 0.66846-0.0815 1.0171-0.57031 1.2939-1.4702-0.78027-0.21583-1.354-0.93165-1.354-1.7793 0-1.0195 0.82666-1.8462 1.8462-1.8462 0.88281 0 1.6226 0.62207 1.8032 1.4507 0.64454 0.76563 2.1133-0.21289 1.6123-1.0488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "m372.14 333.96c0.56348-1.3301 1.8799-2.2637 3.4155-2.2637 2.0483 0 3.708 1.6597 3.708 3.708 0 1.3999-0.77588 2.6182-1.9219 3.2495-0.66845-0.0815-1.0171-0.57031-1.2939-1.4702 0.78027-0.21583 1.354-0.93165 1.354-1.7793 0-1.0195-0.82666-1.8462-1.8462-1.8462-0.88281 0-1.6226 0.62207-1.8032 1.4507-0.64453 0.76563-2.1148-0.21289-1.6123-1.0488z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 154.95,
    r: 14.301,
    cy: 366.11
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 183.41,
    r: 14.301,
    cy: 364.98
  }), /*#__PURE__*/React.createElement("circle", {
    style: {},
    cx: 168.06,
    r: 14.3,
    cy: 341.76
  }), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m166.52 332.53c-1.1191 0-2.938 1.2602-3.4971 2.0991-0.56006 0.83886 1.688 2.9062 2.5879 3.7065 1.2578 1.1191 4.126 0.55908 3.5659-1.749-0.50147-2.0708-1.5381-4.0566-2.6567-4.0566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.77 357.15c-1.1177 0-2.937 1.2588-3.4971 2.0976-0.55859 0.84034 1.6894 2.9077 2.5879 3.707 1.2593 1.1186 4.127 0.56005 3.5669-1.748-0.50244-2.0708-1.5376-4.0566-2.6577-4.0566z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.03 356.59c-1.1187 0-2.938 1.2588-3.498 2.0991-0.55859 0.83887 1.6894 2.9072 2.5879 3.7065 1.2593 1.1191 4.127 0.55909 3.5669-1.749-0.50098-2.0693-1.5391-4.0566-2.6567-4.0566z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.83916,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m197.4 260.39h-8.5493c-0.18603 3.3408 0.0352 5.6362 0.0352 8.502 0 3.9888 1.2192 6.5586 1.5288 10.77h6.8457",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "190.41 278.91 197.05 278.91 196.66 276.85 190.13 276.85 189.71 274.86 196.2 274.86 195.81 272.74 189.28 272.74 188.93 270.68 195.56 270.68 195.6 268.62 188.86 268.62 188.86 266.56 195.63 266.56 195.73 264.51 188.79 264.51 188.78 262.45 195.76 262.45",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.12 281.34h-7.6856c-0.30859-4.2119-1.9478-8.1792-1.9478-12.448 0-3.7046 0.19873-6.8389 0.38379-10.18h7.2905",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "203.8 279.29 196.15 279.29 195.87 277.23 203.41 277.23 203.02 275.17 195.44 275.17 194.88 273.18 202.56 273.18 202.18 271.06 194.6 271.06 194.46 269 201.93 269 201.96 266.94 194.53 266.94 194.59 264.89 201.99 264.89 202.09 262.83 194.66 262.83 194.73 260.77 202.13 260.77",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.46 283.02c-0.30957-3.0923-2.2378-8.3169-2.5078-13.986-0.23828-4.9961 0.75782-9.7778 0.94288-11.999h-6.0146c-0.18506 2.2212-1.1812 7.0029-0.94385 11.999 0.271 5.669 2.1992 10.894 2.5078 13.986h6.0156z",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "200.61 259.19 206.64 259.19 206.33 261.25 200.4 261.25 200.12 263.31 206.16 263.31 205.98 265.36 199.98 265.36 199.92 267.42 205.95 267.42 205.99 269.55 199.99 269.55 200.2 271.53 206.24 271.53 206.49 273.59 200.55 273.59 200.98 275.65 207.02 275.65 207.4 277.79 201.39 277.79 201.88 279.89 207.89 279.89 208.31 281.98 202.23 281.98",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.66 260.39h8.5493c0.18652 3.3408-0.0352 5.6362-0.0352 8.502 0 3.9888-1.2192 6.5586-1.5283 10.77h-6.8457",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "309.65 278.91 303.02 278.91 303.4 276.85 309.93 276.85 310.36 274.86 303.86 274.86 304.25 272.74 310.78 272.74 311.13 270.68 304.5 270.68 304.47 268.62 311.2 268.62 311.2 266.56 304.44 266.56 304.33 264.51 311.28 264.51 311.28 262.45 304.3 262.45",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m295.95 281.34h7.6846c0.30908-4.2119 1.9487-8.1792 1.9487-12.448 0-3.7046-0.19873-6.8389-0.38526-10.18h-7.2905",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "296.27 279.29 303.91 279.29 304.2 277.23 296.65 277.23 297.04 275.17 304.62 275.17 305.18 273.18 297.5 273.18 297.89 271.06 305.46 271.06 305.6 269 298.13 269 298.1 266.94 305.54 266.94 305.47 264.89 298.07 264.89 297.97 262.83 305.4 262.83 305.33 260.77 297.94 260.77",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.6 283.02c0.30908-3.0923 2.2378-8.3169 2.5073-13.986 0.23731-4.9961-0.75879-9.7778-0.94384-11.999h6.0146c0.18506 2.2212 1.1812 7.0029 0.94385 11.999-0.26953 5.669-2.1992 10.894-2.5073 13.986h-6.0146z",
    fill: "#b9a400"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "299.46 259.19 293.42 259.19 293.73 261.25 299.66 261.25 299.94 263.31 293.91 263.31 294.08 265.36 300.08 265.36 300.15 267.42 294.11 267.42 294.07 269.55 300.07 269.55 299.86 271.53 293.82 271.53 293.58 273.59 299.51 273.59 299.09 275.65 293.05 275.65 292.67 277.79 298.67 277.79 298.18 279.89 292.18 279.89 291.76 281.98 297.83 281.98",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m284.9 314.43 28.05 56.97c-18.831 9.7847-40.228 15.314-62.915 15.314-18.868 0-36.842-3.8232-53.19-10.738l23.296-60.796c3.7441 1.873 22.096 10.112 32.208 1.873 8.6148 6.7407 30.677 1.1221 32.55-2.623z",
    strokeWidth: 1.3428,
    fill: "#b9a400"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 1.4381,
    strokeMiterlimit: 10,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 385.24,
    x2: 270.07,
    y1: 374.7,
    x1: 268.23
  }), /*#__PURE__*/React.createElement("line", {
    y2: 386.14,
    x2: 260.77,
    y1: 375.63,
    x1: 260.4
  }), /*#__PURE__*/React.createElement("line", {
    y2: 386.11,
    x2: 238.09,
    y1: 375.68,
    x1: 239.24
  }), /*#__PURE__*/React.createElement("line", {
    y2: 386.58,
    x2: 246.66,
    y1: 376.1,
    x1: 247.1
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m200.78 365.99c15.178 6.4751 31.705 10.13 49.25 10.13 19.925 0 41.736-5.7026 58.163-14.222",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 0.99848,
    fill: "none"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 1.3428,
    strokeMiterlimit: 10,
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.91 303.57c3.4312 1.6982 21.947 10.269 31.988 2.0879 8.6138 6.7417 31.459 1.1235 33.332-2.6216l0.0713 0.0244c2.1758-1.4292 3.2944-9.0527-0.93604-11.423-5.2817 4.4678-24.718 9.3638-33.332 2.6216-10.112 8.2402-28.465 0-32.21-1.8716-4.0137 2.7388-1.4961 11.062 1.0874 11.182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.9 314.43c2.1372-0.98096 2.8374-11.123-0.59717-11.371-1.8721 3.7451-24.568 9.123-33.182 2.3823-10.112 8.2378-28.464 0-32.209-1.873-3.5635 1.5967-1.9546 10.439 1.2295 11.612 3.7451 1.873 21.734 9.8975 31.846 1.6582 8.6123 6.7407 31.04 1.3369 32.913-2.4082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.22 245.54c-8.9898-1.4971-18.012 7.5244-20.259 10.521 0.18359 1.479-1.2861 7.1572-1.0098 12.979 0.27002 5.669 2.1982 10.894 2.5078 13.986 4.1191 3.7451 6.7407 7.4902 9.3623 9.3638 0 0 7.9995 4.1333 17.009 5.3086 9.0078 1.1743 12.142-1.5669 15.274-3.5249 15.666 8.2241 31.302-0.96631 33.26-2.5337 1.959-1.5659 4.1201-4.8686 8.2398-8.6138 0.19238-1.9219 3.749-8.187 4.0381-14.234 0.27295-5.7349-2.7226-11.273-2.5396-12.73-2.2275-2.9707-10.34-11.09-19.235-9.7754l-15.146 20.471h-17.625l-13.876-21.217z"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 1.4381,
    strokeMiterlimit: 10,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 375.08,
    x2: 305.49,
    y1: 365.21,
    x1: 301.32
  }), /*#__PURE__*/React.createElement("line", {
    y2: 377.38,
    x2: 299.87,
    y1: 367.4,
    x1: 296
  }), /*#__PURE__*/React.createElement("line", {
    y2: 379.67,
    x2: 293.2,
    y1: 369.63,
    x1: 289.78
  }), /*#__PURE__*/React.createElement("line", {
    y2: 382.05,
    x2: 285.5,
    y1: 371.71,
    x1: 282.64
  }), /*#__PURE__*/React.createElement("line", {
    y2: 383.77,
    x2: 277.75,
    y1: 373.33,
    x1: 275.67
  }), /*#__PURE__*/React.createElement("line", {
    y2: 377.89,
    x2: 201.63,
    y1: 367.9,
    x1: 205.46
  }), /*#__PURE__*/React.createElement("line", {
    y2: 379.95,
    x2: 207.61,
    y1: 369.87,
    x1: 211.07
  }), /*#__PURE__*/React.createElement("line", {
    y2: 383.9,
    x2: 222.18,
    y1: 373.39,
    x1: 224.59
  }), /*#__PURE__*/React.createElement("line", {
    y2: 385.21,
    x2: 230.1,
    y1: 374.81,
    x1: 231.69
  }), /*#__PURE__*/React.createElement("line", {
    y2: 382.1,
    x2: 214.96,
    y1: 371.95,
    x1: 218
  }), /*#__PURE__*/React.createElement("line", {
    y2: 386.55,
    x2: 253.78,
    y1: 376.16,
    x1: 253.78
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#c7bd14",
    d: "m277.13 322.26c-4.7559 15.107-28.704 23.78-38.887 20.143-4.2476-1.5176-10.352-14.548-18.743-8.9526-4.478 2.9854-13.648 26.897-12.311 30.914 2.5181 7.5522 33.288 9.6514 44.203 9.6514 17.624 0 49.167-8.3237 50.006-12.799 0.57568-3.0747-16.506-40.285-18.744-40.285-1.958 0.83984-2.7266 2.168-5.5244 1.3286z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m280.62 318.26c-1.5649 1.2226-2.9839 1.731-4.6821 1.6167-1.7119 2.5845-6.4292 12.251-5.4761 21.884 0.52832 5.3482 5.9478 31.41 19.255 26.518 2.624-0.96533 9.623-3.0732 10.849-4.6089 3.3569-4.2061-7.751-24.392-9.4082-26.939-1.6567-2.5483-7.5942-17.12-10.538-18.471z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m223.7 318.72c1.6792 1.1201 2.7979 1.3999 4.477 1.1201 1.958 2.5176 1.958 13.705 1.958 23.778 0 5.5957-8.1128 27.695-10.909 27.695-2.7993 0-9.437-2.2593-10.912-3.6353-4.8945-4.5708 5.4351-26.257 6.7134-28.815 1.3989-2.7969 5.876-18.463 8.6724-20.143z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m263.97 270.66c2.7129 2.0088 5.793 4.2759 7.4482 5.4399 2.3555-6.9936 12.706-23.5 16.902-24.898",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 1.119,
    fill: "none"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    stroke: "#7f7100",
    cy: 269.35,
    cx: 269.59,
    r: 3.4319,
    fill: "#b9a400"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.24,
    cx: 269.7,
    r: 2.9175,
    fill: "#b9a70e"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.12,
    cx: 269.82,
    r: 2.4028,
    fill: "#b9aa17"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.01,
    cx: 269.93,
    r: 1.8879,
    fill: "#b9ad22"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cy: 268.9,
    cx: 270.04,
    r: 1.3728,
    fill: "#b9af2e"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    stroke: "#7f7100",
    cy: 262.07,
    cx: 274.38,
    r: 3.4319,
    fill: "#b9a400"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.96,
    cx: 274.49,
    r: 2.917,
    fill: "#b9a70e"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.84,
    cx: 274.61,
    r: 2.4026,
    fill: "#b9aa17"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.73,
    cx: 274.72,
    r: 1.8877,
    fill: "#b9ad22"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.62,
    cx: 274.83,
    r: 1.3728,
    fill: "#b9af2e"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    stroke: "#7f7100",
    cy: 255.19,
    cx: 279.09,
    r: 3.4316,
    fill: "#b9a400"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cy: 255.08,
    cx: 279.21,
    r: 2.9177,
    fill: "#b9a70e"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.96,
    cx: 279.32,
    r: 2.4014,
    fill: "#b9aa17"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.85,
    cx: 279.43,
    r: 1.8877,
    fill: "#b9ad22"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.74,
    cx: 279.54,
    r: 1.3723,
    fill: "#b9af2e"
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.74204,
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 268.41,
    cx: 261.12,
    r: 1.8792
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 265.1,
    cx: 263.66,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 261.79,
    cx: 266.2,
    r: 1.8787
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 258.48,
    cx: 268.74,
    r: 1.8792
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 255.17,
    cx: 271.28,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 251.86,
    cx: 273.82,
    r: 1.8787
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 248.54,
    cx: 276.36,
    r: 1.8794
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "m235.74 270.66c-2.7188 2.0151-5.8057 4.2861-7.4487 5.4409-2.354-6.9936-12.496-23.358-16.691-24.757",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 1.119,
    fill: "none"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    stroke: "#7f7100",
    cy: 262.07,
    cx: 225.33,
    r: 3.4319,
    fill: "#b9a400"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.96,
    cx: 225.22,
    r: 2.917,
    fill: "#b9a70e"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.84,
    cx: 225.11,
    r: 2.4028,
    fill: "#b9aa17"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.73,
    cx: 224.99,
    r: 1.8877,
    fill: "#b9ad22"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cy: 261.62,
    cx: 224.88,
    r: 1.3728,
    fill: "#b9af2e"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    stroke: "#7f7100",
    cy: 255.19,
    cx: 220.62,
    r: 3.4316,
    fill: "#b9a400"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cy: 255.08,
    cx: 220.51,
    r: 2.9177,
    fill: "#b9a70e"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.96,
    cx: 220.39,
    r: 2.4021,
    fill: "#b9aa17"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.85,
    cx: 220.28,
    r: 1.8877,
    fill: "#b9ad22"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cy: 254.74,
    cx: 220.17,
    r: 1.3723,
    fill: "#b9af2e"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m282.03 247.56c-3.6367 0.83984-16.086 18.325-17.905 23.08h-28.535c-1.8179-4.7544-14.547-22.38-18.184-23.219",
    stroke: "#7f7100",
    strokeWidth: 1.119,
    fill: "none"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.74204
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 268.62,
    cx: 257.36,
    r: 1.8789
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 268.62,
    cx: 253.61,
    r: 1.8787
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 268.62,
    cx: 249.86,
    r: 1.8789
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 268.62,
    cx: 246.1,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 268.62,
    cx: 242.35,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 268.41,
    cx: 238.6,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 265.1,
    cx: 236.05,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 261.79,
    cx: 233.51,
    r: 1.8787
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 258.48,
    cx: 230.97,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 255.17,
    cx: 228.43,
    r: 1.8794
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 251.86,
    cx: 225.89,
    r: 1.8789
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 248.54,
    cx: 223.35,
    r: 1.8794
  })), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 0.55959,
    cy: 269.35,
    cx: 230.12,
    r: 3.4316
  }))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.24,
    cx: 230.01,
    r: 2.9175,
    fill: "#b9a70e"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.12,
    cx: 229.9,
    r: 2.4021,
    fill: "#b9aa17"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cy: 269.01,
    cx: 229.78,
    r: 1.8872,
    fill: "#b9ad22"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cy: 268.9,
    cx: 229.67,
    r: 1.3728,
    fill: "#b9af2e"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m257.07 294.66c-5.4243-2.6113-4.0254-17.019 0.83985-16.366 6.0137 0.80713 16.253 2.2852 19.163-2.0982 1.2476-1.8789 8.1138 7.5537 6.7148 10.351-1.3989 2.7978-6.1548 5.7354-8.1138 6.2944-1.958 0.56006-14.815 3.6436-18.604 1.8188z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m219.19 307.28c-0.80274 0.21094-1.0635 3.0698-0.48877 4.0772 1.749 3.0698 14.526 7.7114 21.542 7.1064 4.6157-0.39844 9.0913-1.9375 9.7212-4.8936 0.12891-0.60742 0.1626-3.6274-1.3286-2.8813-3.0781 1.5425-6.5137 1.3223-10.282 1.5107-8.2524 0.40967-17.624-5.3247-19.164-4.9194z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m238.58 312.47c3.4678-0.14892 6.5747 0.0337 9.2734-1.3144 1.3682-0.68164 1.3506 2.0029 1.2305 2.561-0.5835 2.7041-4.6992 4.0093-8.8135 4.373-6.4292 0.57227-17.271-3.3594-18.919-6.0825-0.57129-0.92041-0.30713-3.4424 0.46728-3.6743 1.3892-0.39258 9.4282 4.4702 16.761 4.1372z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m238.8 312.74c3.165-0.11084 5.9448 0.0361 8.2637-1.1177 1.2466-0.61669 1.2422 1.7319 1.1314 2.2378-0.53614 2.4546-4.2915 3.5273-7.9048 3.8545-5.8418 0.54102-14.748-2.6836-16.295-5.0581-0.56885-0.83203-0.30273-3.0181 0.44385-3.27 1.2397-0.38378 7.9463 3.6089 14.361 3.3535z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m239.02 313.01c2.8633-0.0723 5.3149 0.0381 7.2554-0.92237 1.1235-0.5498 1.1338 1.4619 1.0322 1.917-0.49024 2.2051-3.8843 3.0439-6.9937 3.3374-5.2568 0.50586-12.228-2.0083-13.674-4.0361-0.56543-0.74511-0.29688-2.5938 0.42138-2.8647 1.0894-0.37354 6.4648 2.7461 11.959 2.5688z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m239.24 313.28c2.562-0.0361 4.686 0.0386 6.2476-0.72705 1.0005-0.48438 1.0249 1.1914 0.93262 1.5952-0.44141 1.9536-3.4766 2.5601-6.0835 2.8184-4.6714 0.47412-9.708-1.3325-11.052-3.0122-0.56445-0.65723-0.29101-2.1704 0.39649-2.4614 0.94287-0.36133 4.9849 1.8867 9.5586 1.7871z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m239.47 313.55c2.2602 0.003 4.0566 0.0405 5.2398-0.53077 0.87744-0.41992 0.91601 0.91944 0.83349 1.2739-0.39648 1.7036-3.0703 2.0772-5.1758 2.2998-4.084 0.44141-7.1846-0.65722-8.4287-1.9892-0.56103-0.57032-0.28564-1.7456 0.37402-2.0586 0.79248-0.3501 3.5044 1.0264 7.1572 1.0049z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m234.93 313.6c-0.6289 0.33203-0.91015 1.1719-0.3501 1.6533 1.1426 0.98535 2.3081 1.375 5.8047 0.96533 1.6045-0.1875 3.917-0.32764 4.2671-1.7817 0.0723-0.30176 0.02-1.3042-0.73388-0.95215-0.80518 0.37744-2.273 0.37744-4.2319 0.33643-2.7334-0.0571-4.1123-0.56201-4.7559-0.22119z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m259.64 278.97c5.4004 0.72461 14.229 1.8018 16.977-1.9839 1.2476-1.6528 7.0908 6.4956 5.8394 8.9966-1.2495 2.502-5.4961 5.0391-7.2476 5.5396-1.75 0.50097-12.857 3.1689-16.245 1.5366-4.8482-2.335-3.6728-14.674 0.67627-14.089z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m261.36 279.65c4.7861 0.64355 12.204 1.3198 14.79-1.8711 1.2485-1.4258 6.0674 5.4414 4.9658 7.6465-1.102 2.2036-4.8394 4.3413-6.3828 4.7827s-10.899 2.6929-13.886 1.2544c-4.2759-2.0571-3.3218-12.328 0.5127-11.812z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m263.09 280.33c4.1719 0.56006 10.179 0.83789 12.603-1.7568 1.25-1.2002 5.0459 4.3843 4.0918 6.2925-0.95411 1.9092-4.1807 3.646-5.5166 4.0273-1.3354 0.38184-8.9424 2.2188-11.528 0.97363-3.7002-1.7817-2.9697-9.9814 0.3501-9.5366z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m264.82 281.01c3.5576 0.47754 8.1543 0.35546 10.415-1.644 1.251-0.97461 4.0249 3.3272 3.2178 4.9399-0.80517 1.6123-3.5215 2.9487-4.6509 3.272-1.1289 0.32275-6.9844 1.7422-9.1689 0.69092-3.1265-1.5049-2.6172-7.6372 0.1875-7.2588z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m266.54 281.69c2.9448 0.39502 6.1299-0.12548 8.229-1.5288 1.252-0.74853 3.001 2.2705 2.3438 3.5869-0.65821 1.3154-2.8643 2.2515-3.7847 2.5146-0.92139 0.26416-5.0288 1.2681-6.8115 0.41064-2.5518-1.2295-2.2651-5.2905 0.0234-4.9834z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m268.41 285.08c-1.977-0.95166-1.9141-2.9434-0.14111-2.7051 2.3306 0.31152 4.1055-0.6084 6.043-1.416 1.2529-0.52148 1.978 1.2148 1.4688 2.2334-0.50927 1.021-2.206 1.5562-2.9199 1.7602-0.71338 0.20313-3.0698 0.79395-4.4507 0.12745z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m240.48 293.26c5.4243-2.6113 4.8652-12.682 0-12.029-6.0146 0.80762-14.434-0.65235-17.345-5.0356-1.2476-1.8789-8.1138 7.5537-6.7148 10.351 1.3989 2.7978 6.4346 5.0356 8.3936 5.5957 1.959 0.56006 11.877 2.9434 15.666 1.1186z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m239.48 281.61c-5.4019 0.72559-12.715-0.64502-15.462-4.4331-1.2485-1.6518-7.0894 6.498-5.8384 8.999 1.25 2.502 5.728 4.4556 7.479 4.9556s10.41 2.5854 13.797 0.95411c4.8506-2.335 4.373-11.06 0.0239-10.476z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m238.48 281.98c-4.7861 0.64258-10.992-0.63769-13.578-3.8286-1.2485-1.4272-6.0674 5.4409-4.9644 7.645 1.102 2.2051 5.0244 3.876 6.5679 4.3164 1.5425 0.4414 8.9414 2.2275 11.928 0.78906 4.2759-2.0581 3.8804-9.4356 0.0464-8.9219z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m237.47 282.36c-4.1719 0.56005-9.27-0.62989-11.694-3.2246-1.25-1.2012-5.0459 4.3833-4.0908 6.2915 0.9541 1.9092 4.3198 3.2969 5.6558 3.6772 1.3369 0.38183 7.4732 1.8686 10.059 0.62451 3.7012-1.7817 3.3882-7.8135 0.0698-7.3686z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m236.47 282.74c-3.5576 0.47851-7.5478-0.62354-9.8096-2.6221-1.251-0.97412-4.023 3.3276-3.2168 4.9399 0.80615 1.6123 3.6152 2.7153 4.7432 3.0386 1.1294 0.32276 6.0068 1.5093 8.1904 0.45801 3.1265-1.5049 2.8975-6.1904 0.0928-5.8144z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m235.46 283.11c-2.9434 0.39648-5.8272-0.6167-7.9263-2.019-1.252-0.74707-3.001 2.271-2.3428 3.5884 0.65722 1.3154 2.9111 2.1352 3.832 2.3984 0.92139 0.2627 4.5381 1.1514 6.3208 0.29346 2.5518-1.2285 2.4062-4.5674 0.11621-4.2612z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m234.32 286.2c1.978-0.95166 1.9136-2.9434 0.14111-2.7051-2.3306 0.31152-4.1055-0.60889-6.043-1.416-1.251-0.52148-1.978 1.2148-1.4678 2.2344 0.50928 1.0186 2.2051 1.5547 2.9185 1.7593 0.71386 0.20313 3.0703 0.79346 4.4512 0.12745z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m218.08 295.81c-0.80274 0.21191-1.0635 3.0698-0.48877 4.0772 1.7485 3.0723 14.525 7.7114 21.542 7.1064 4.6157-0.3999 9.0913-1.9365 9.7217-4.8926 0.12842-0.6084 0.16113-3.6289-1.3291-2.8823-3.0776 1.5435-6.5137 1.3232-10.281 1.5107-8.2524 0.41065-17.624-5.3252-19.164-4.9194z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m237.46 301c3.4673-0.15039 6.5747 0.0327 9.273-1.3154 1.3686-0.68067 1.3506 2.0039 1.2295 2.5605-0.58252 2.7056-4.6978 4.0108-8.8125 4.3745-6.4287 0.57227-17.271-3.3594-18.917-6.0825-0.57129-0.92041-0.30957-3.4414 0.46631-3.6743 1.3896-0.39502 9.4287 4.4692 16.761 4.1372z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m237.68 301.27c3.165-0.11084 5.9448 0.0361 8.2651-1.1182 1.2451-0.61523 1.2407 1.7324 1.1313 2.2393-0.53662 2.4546-4.292 3.5259-7.9038 3.8545-5.8433 0.54004-14.749-2.6826-16.296-5.0581-0.56934-0.8335-0.30274-3.0181 0.44238-3.27 1.2407-0.38477 7.9478 3.6074 14.361 3.3525z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m237.9 301.54c2.8633-0.0732 5.3144 0.0371 7.2554-0.92383 1.1235-0.54834 1.1323 1.4624 1.0332 1.9175-0.49121 2.2051-3.8852 3.044-6.9946 3.3374-5.2573 0.50586-12.228-2.0073-13.675-4.0352-0.56543-0.74561-0.29688-2.5947 0.42041-2.8657 1.0903-0.37255 6.4673 2.7461 11.96 2.5698z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m238.13 301.81c2.562-0.0342 4.6846 0.0381 6.2485-0.72607 0.99903-0.48535 1.0239 1.1899 0.93116 1.5942-0.44239 1.9546-3.4766 2.5606-6.0845 2.8193-4.6699 0.47413-9.7056-1.3325-11.05-3.0122-0.56494-0.65869-0.2915-2.1704 0.396-2.4629 0.94189-0.36133 4.9849 1.8867 9.5591 1.7876z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m238.35 302.08c2.2593 0.003 4.0566 0.0396 5.2388-0.53174 0.87842-0.41797 0.91601 0.92041 0.83447 1.2734-0.39599 1.7041-3.0698 2.0776-5.1758 2.3003-4.0835 0.44141-7.1841-0.65625-8.4282-1.9883-0.56153-0.57031-0.28565-1.7456 0.37353-2.0596 0.79248-0.3501 3.5034 1.0264 7.1572 1.0059z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m233.81 302.13c-0.63037 0.33203-0.90918 1.1719-0.3501 1.6528 1.1436 0.98584 2.3076 1.3755 5.8047 0.96534 1.604-0.1875 3.918-0.32715 4.2666-1.7803 0.0732-0.30273 0.0205-1.3052-0.73389-0.95215-0.80517 0.37598-2.2739 0.37598-4.2319 0.33545-2.7334-0.0576-4.1118-0.56103-4.7554-0.22119z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m284.17 306.72c0.80273 0.21143 1.0635 3.0679 0.48877 4.0762-1.749 3.0713-14.525 7.7114-21.541 7.1064-4.6167-0.39844-9.0928-1.9365-9.7227-4.8921-0.1289-0.60889-0.28125-3.3154 1.3301-2.8828 3.5015 0.94287 6.5127 0.90332 10.28 1.0918 8.2539 0.41016 17.625-4.9058 19.164-4.4995z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a400",
    d: "m284.17 295.25c0.80273 0.21094 1.0635 3.0688 0.48877 4.0772-1.749 3.0698-14.525 7.7114-21.541 7.1055-4.6167-0.39892-9.0928-1.9365-9.7227-4.8926-0.1289-0.60743-0.16162-3.6289 1.3301-2.8814 0.68067 0.34082 8.1631 1.4048 10.28 1.5107 8.2539 0.40967 17.625-5.3257 19.164-4.9194z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m229.23 341.95c0 4.896-7.959 27.699-10.268 27.614-2.3618 0.12549-8.2319-1.8755-9.5474-3.1816-4.2129-4.0537 5.6406-26.332 6.7598-28.571 1.2236-2.4478 5.1406-16.155 7.5898-17.624 1.5186 0.91651 2.4512 1.1494 3.981 1.041 1.7139 2.2026 1.4849 11.906 1.4849 20.721z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m228.32 340.28c0 4.1968-7.8042 27.703-9.6279 27.532-1.9263 0.24951-7.0283-1.4902-8.1836-2.7266-3.5293-3.5376 5.8486-26.406 6.8076-28.326 1.0488-2.0977 4.4067-13.847 6.5044-15.106 1.3618 0.71485 2.1079 0.90088 3.4878 0.96338 1.4688 1.8887 1.0117 10.107 1.0117 17.663z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m227.41 338.61c0 3.4971-7.6519 27.706-8.9863 27.452-1.4902 0.37159-5.8237-1.1079-6.8198-2.2739-2.8462-3.0215 6.0542-26.482 6.8535-28.081 0.875-1.748 3.6719-11.541 5.4199-12.588 1.2036 0.5127 1.7622 0.65283 2.9941 0.88526 1.2241 1.5742 0.53858 8.3091 0.53858 14.606z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m226.51 336.95c0 2.7969-7.4971 27.709-8.3462 27.368-1.0532 0.49659-4.6191-0.72168-5.4556-1.8179-2.1636-2.5044 6.2617-26.556 6.8999-27.835 0.70118-1.3989 2.938-9.2314 4.3369-10.071 1.0444 0.31006 1.418 0.40381 2.4995 0.80811 0.97998 1.2593 0.0654 6.5102 0.0654 11.548z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m225.6 335.28c0 2.0986-7.3423 27.713-7.7046 27.288-0.61767 0.62109-3.4155-0.33741-4.0918-1.3638-1.4814-1.9883 6.4673-26.632 6.9463-27.59 0.52491-1.0488 2.2051-6.9248 3.2524-7.5547 0.88672 0.1084 1.0728 0.15576 2.0054 0.73144 0.73388 0.94385-0.40772 4.7104-0.40772 8.4898z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m224.06 327.53c0.72705-0.0937 0.72705-0.0937 1.5107 0.65284 0.49024 0.6289-0.88037 2.9131-0.88037 5.4307 0 1.3989-7.189 27.717-7.0649 27.207-0.18164 0.74659-2.2095 0.0464-2.728-0.90869-0.79687-1.4726 6.6753-26.707 6.9951-27.345 0.34863-0.7002 1.4688-4.6162 2.1675-5.0361z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m272.18 340.67c-0.82226-8.4458 3.0854-16.859 4.5137-19.216 1.459-0.0982 2.6221-0.58155 4.0478-1.5967 2.5757 1.1846 7.7739 13.958 9.2246 16.191 1.4453 2.2236 12.458 23.182 9.4507 26.87-1.1982 1.4331-7.6157 3.3071-10.193 3.898-11.482 3.8613-16.562-21.068-17.043-26.146z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m273.9 339.57c-0.69092-7.2603 2.4062-14.423 3.5522-16.548 1.2192-0.31396 2.127-0.77001 3.4141-1.5776 2.2085 1.0161 6.6675 11.993 7.9116 13.913 1.2319 1.9004 12.152 23.628 9.4922 26.8-1.1684 1.3301-7.0059 2.9727-9.5386 3.1851-9.6548 2.8315-14.396-20.966-14.832-25.772z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m275.61 338.47c-0.55957-6.0732 1.7275-11.985 2.5913-13.881 0.98144-0.52832 1.6318-0.95752 2.7812-1.5571 1.8403 0.84912 5.5596 10.029 6.5972 11.633 1.0186 1.5762 11.845 24.078 9.5352 26.73-1.1406 1.227-6.3984 2.6387-8.8848 2.4746-7.8272 1.8022-12.23-20.865-12.62-25.4z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m277.33 337.38c-0.42919-4.8867 1.0479-9.5474 1.6294-11.214 0.7417-0.74317 1.1367-1.144 2.1475-1.5366 1.4722 0.68164 4.4507 8.0635 5.2817 9.3545 0.80762 1.252 11.54 24.524 9.5781 26.66-1.1108 1.1235-5.7886 2.3022-8.2285 1.7637-6.0015 0.771-10.066-20.764-10.408-25.027z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m279.05 336.28c-0.29932-3.7012 0.36816-7.1099 0.66699-8.5474 0.50293-0.95752 0.6416-1.331 1.5132-1.5176 1.1045 0.51514 3.3442 6.1006 3.9688 7.0772 0.59521 0.92725 11.233 24.972 9.6211 26.589-1.083 1.021-5.1802 1.9683-7.5742 1.0537-4.1753-0.25977-7.9014-20.664-8.1958-24.655z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m293.68 359.13c1.2637-1.0986-9.2812-25.916-9.6626-26.52-0.41797-0.66162-1.9185-4.4487-2.6558-4.7964-0.73291-0.0215-0.61523 0.32617-0.87939 1.4971-0.0146 1.207 0.12744 3.3647 0.2959 5.8779 0.24804 3.7202 3.6352 22.992 5.9829 24.283 2.3486 1.2905 5.8643 0.57617 6.9189-0.3418z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m208.17 346.4c1.9185 0.40429 3.3579 2.1069 3.3579 4.145 0 2.3418-1.8955 4.2388-4.2363 4.2388-0.76416 0-1.481-0.20215-2.1001-0.55811l2.9785-7.8257z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m205.44 353.54c0.45752 0.21142 0.9668 0.32763 1.5044 0.32763 1.9892 0 3.6006-1.6113 3.6006-3.6006 0-1.6113-1.0571-2.9766-2.5156-3.436l-2.5894 6.709z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m207.88 347.32c0.9917 0.47949 1.6733 1.4946 1.6733 2.6699 0 1.6387-1.3276 2.9663-2.9648 2.9663-0.30274 0-0.59375-0.0454-0.86817-0.12988l1.9058-4.9883c0.57227 0.42578 0.94287 1.1055 0.94287 1.8721 0 1.2881-1.0434 2.3315-2.3306 2.3315-0.0825 0-0.1626-0.006-0.24268-0.0137"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m206.37 351.05c0.70362-0.20556 1.2183-0.85693 1.2183-1.627 0-0.32178-0.0889-0.62207-0.24365-0.87744l-0.97461 2.5044z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m203.65 358.07c0.0102 0.0767 0.0171 0.15479 0.0171 0.23487 0 0.50244-0.21924 0.95263-0.56592 1.2632"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m204.74 355.42c1.6689 0.56885 2.8691 2.1509 2.8691 4.0127 0 2.3394-1.897 4.2363-4.2373 4.2363-0.59619 0-2.1206-0.6914-1.6792-0.3457 0.0972 0.0757 3.0474-7.9033 3.0474-7.9033z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m201.94 362.58c0.34423 0.10839 0.70996 0.16699 1.0894 0.16699 1.9883 0 3.6006-1.6108 3.6006-3.6006 0-1.4248-0.8252-2.6553-2.0254-3.2393l-2.6646 6.6729z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m204.35 356.42c0.77783 0.53516 1.2886 1.4307 1.2886 2.4468 0 1.6382-1.3267 2.9658-2.9653 2.9658-0.12939 0-0.25732-0.008-0.38134-0.0249l2.0581-5.3877z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m202.65 360.9c1.1323-0.1582 2.0039-1.1314 2.0039-2.3081 0-0.56689-0.20215-1.0859-0.53857-1.4892l-1.4653 3.7974z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 360.76,
    cx: 293.34,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 351.74,
    cx: 289.63,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 368.65,
    cx: 253.78,
    r: 4.2375
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 358.91,
    cx: 253.78,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 367.2,
    cx: 269.02,
    r: 4.2371
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 364.56,
    cx: 281.62,
    r: 4.2371
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 357.62,
    cx: 267.27,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 355.19,
    cx: 278.83,
    r: 4.2373
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 368.18,
    cx: 238.75,
    r: 4.2375
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 363.27,
    cx: 214.08,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 366.31,
    cx: 226,
    r: 4.2363
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 358.53,
    cx: 240.01,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 356.8,
    cx: 228.24,
    r: 4.2368
  }), /*#__PURE__*/React.createElement("circle", {
    cy: 354.04,
    cx: 217.22,
    r: 4.2368
  }))), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.65,
    cx: 253.78,
    r: 3.6013,
    fill: "#b9a70e"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.65,
    cx: 253.78,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.65,
    cx: 253.78,
    r: 2.3306,
    fill: "#b9ad22"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.65,
    cx: 253.78,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.11,
    cx: 238.68,
    r: 3.6018,
    fill: "#b9a70e"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cy: 368.04,
    cx: 238.61,
    r: 2.9656,
    fill: "#b9aa17"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cy: 367.97,
    cx: 238.54,
    r: 2.3298,
    fill: "#b9ad22"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cy: 367.9,
    cx: 238.47,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cy: 366.17,
    cx: 225.86,
    r: 3.6018,
    fill: "#b9a70e"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cy: 366.03,
    cx: 225.72,
    r: 2.9656,
    fill: "#b9aa17"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cy: 365.89,
    cx: 225.58,
    r: 2.3308,
    fill: "#b9ad22"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cy: 365.75,
    cx: 225.44,
    r: 1.6943,
    fill: "#b9af2e"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cy: 363.06,
    cx: 213.87,
    r: 3.6013,
    fill: "#b9a70e"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cy: 362.86,
    cx: 213.66,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cy: 362.65,
    cx: 213.45,
    r: 2.3303,
    fill: "#b9ad22"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cy: 362.44,
    cx: 213.24,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.91,
    cx: 253.78,
    r: 3.6013,
    fill: "#b9a70e"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.91,
    cx: 253.78,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.91,
    cx: 253.78,
    r: 2.3306,
    fill: "#b9ad22"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.91,
    cx: 253.78,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.46,
    cx: 239.94,
    r: 3.6016,
    fill: "#b9a70e"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.39,
    cx: 239.87,
    r: 2.9653,
    fill: "#b9aa17"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.32,
    cx: 239.8,
    r: 2.3306,
    fill: "#b9ad22"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cy: 358.25,
    cx: 239.73,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cy: 356.66,
    cx: 228.1,
    r: 3.6018,
    fill: "#b9a70e"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cy: 356.52,
    cx: 227.96,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cy: 356.38,
    cx: 227.82,
    r: 2.3303,
    fill: "#b9ad22"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cy: 356.24,
    cx: 227.68,
    r: 1.6946,
    fill: "#b9af2e"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cy: 353.83,
    cx: 217.01,
    r: 3.6023,
    fill: "#b9a70e"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cy: 353.62,
    cx: 216.8,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cy: 353.41,
    cx: 216.59,
    r: 2.3298,
    fill: "#b9ad22"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cy: 353.2,
    cx: 216.38,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cy: 367.13,
    cx: 269.09,
    r: 3.6006,
    fill: "#b9a70e"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cy: 367.06,
    cx: 269.16,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cy: 366.99,
    cx: 269.23,
    r: 2.3298,
    fill: "#b9ad22"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cy: 366.92,
    cx: 269.3,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cy: 364.42,
    cx: 281.76,
    r: 3.6011,
    fill: "#b9a70e"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cy: 364.28,
    cx: 281.9,
    r: 2.9656,
    fill: "#b9aa17"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cy: 364.14,
    cx: 282.04,
    r: 2.3298,
    fill: "#b9ad22"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cy: 364,
    cx: 282.18,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cy: 360.55,
    cx: 293.55,
    r: 3.6011,
    fill: "#b9a70e"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cy: 360.34,
    cx: 293.76,
    r: 2.9656,
    fill: "#b9aa17"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cy: 360.13,
    cx: 293.97,
    r: 2.3298,
    fill: "#b9ad22"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cy: 359.92,
    cx: 294.18,
    r: 1.6943,
    fill: "#b9af2e"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cy: 357.55,
    cx: 267.34,
    r: 3.6006,
    fill: "#b9a70e"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cy: 357.48,
    cx: 267.41,
    r: 2.9661,
    fill: "#b9aa17"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cy: 357.41,
    cx: 267.48,
    r: 2.3303,
    fill: "#b9ad22"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cy: 357.34,
    cx: 267.55,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cy: 355.05,
    cx: 278.97,
    r: 3.6013,
    fill: "#b9a70e"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cy: 354.91,
    cx: 279.1,
    r: 2.9663,
    fill: "#b9aa17"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cy: 354.77,
    cx: 279.24,
    r: 2.3306,
    fill: "#b9ad22"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cy: 354.63,
    cx: 279.39,
    r: 1.6948,
    fill: "#b9af2e"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cy: 351.53,
    cx: 289.84,
    r: 3.6011,
    fill: "#b9a70e"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cy: 351.32,
    cx: 290.05,
    r: 2.9663,
    fill: "#b9aa17"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cy: 351.11,
    cx: 290.26,
    r: 2.3311,
    fill: "#b9ad22"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cy: 350.9,
    cx: 290.47,
    r: 1.6953,
    fill: "#b9af2e"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m209.78 342.35c12.439 5.5029 25.78 8.3506 40.257 8.3506 16.658 0 33.349-4.189 47.187-11.353",
    stroke: "#7f7100",
    strokeMiterlimit: 10,
    strokeWidth: 1.0621,
    fill: "none"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "m299.02 343.04c-1.9307 0.39502-3.6187 2.1025-3.6187 4.1504 0 2.3418 1.8955 4.2378 4.2363 4.2378 1.1108 0 2.1226-0.42823 2.8794-1.1279 0.063 0.062-3.4971-7.2603-3.4971-7.2603z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m302.27 349.69c-0.6206 0.51172-1.4155 0.81787-2.2827 0.81787-1.9898 0-3.602-1.6128-3.602-3.602 0-1.7026 1.1812-3.1284 2.7686-3.5059l3.1162 6.29z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m301.99 349.09c-0.47314 0.31982-1.0425 0.50586-1.6567 0.50586-1.6382 0-2.9648-1.3276-2.9648-2.9658 0-1.3042 0.84131-2.4121 2.0107-2.8091l2.6108 5.269z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m301.7 348.45c-0.30567 0.14795-0.6504 0.23047-1.0127 0.23047-1.2871 0-2.3291-1.042-2.3291-2.3306 0-0.87745 0.48437-1.6416 1.2002-2.0391l2.1416 4.1392z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m301.32 347.74c-0.0937 0.0156-0.19092 0.0249-0.28906 0.0249-0.93604 0-1.6948-0.75879-1.6948-1.6958 0-0.46777 0.18995-0.89209 0.49707-1.1982l1.4868 2.8691z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m307.06 359.45c-0.6919 0.49414-1.54 0.78467-2.4556 0.78467-2.3408 0-4.2373-1.897-4.2373-4.2378 0-1.7915 1.2939-3.3228 2.9106-3.9438l3.7822 7.397z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m306.74 358.85c-0.52636 0.30175-1.1357 0.47314-1.7861 0.47314-1.9898 0-3.602-1.6108-3.602-3.6006 0-1.522 0.94385-2.8228 2.2773-3.3511l3.1108 6.4785z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m306.43 358.19c-0.34668 0.14307-0.72802 0.22217-1.1279 0.22217-1.6382 0-2.9648-1.3276-2.9648-2.9658 0-1.083 0.5791-2.0303 1.4453-2.5474l2.6475 5.291z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m306.09 357.45c-0.14257 0.0273-0.28808 0.041-0.43945 0.041-1.2871 0-2.3306-1.0425-2.3306-2.3306 0-0.69238 0.30274-1.313 0.78125-1.7412l1.9888 4.0308z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m305.67 356.54c-0.7754-0.15625-1.3604-0.84033-1.3604-1.6621 0-0.27441 0.0654-0.53418 0.18164-0.76465l1.1787 2.4268z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m266.62 300.15c7.311 0.20459 15.318-4.7192 16.719-4.3579 0.78662 0.20069 1.0874 2.7026 0.54199 3.647-1.5933 2.7695-12.409 6.7529-18.834 6.3476-4.1133-0.28711-8.2183-1.4136-8.8677-4.0918-0.1333-0.55127-0.20118-3.1987 1.1797-2.5879 0.70459 0.27442 7.1846 1.0542 9.2608 1.043z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m268.23 300.13c6.3706 0 13.012-4.1142 14.276-3.7959 0.76757 0.18701 1.1099 2.335 0.59375 3.2144-1.4395 2.4692-10.294 5.7969-16.126 5.5913-3.6089-0.17627-7.3462-0.88965-8.0142-3.2915-0.13769-0.49561-0.23975-2.772 1.0317-2.2944 0.72949 0.20703 6.2046 0.70362 8.2388 0.57617z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m269.85 300.11c5.4302-0.20801 10.708-3.5127 11.833-3.2358 0.74951 0.17578 1.1338 1.9678 0.64599 2.7817-1.2852 2.1689-8.1768 4.8403-13.42 4.8335-3.104-0.062-6.4722-0.36328-7.1587-2.4907-0.14209-0.43799-0.27881-2.3413 0.88184-1.9995 0.75439 0.14013 5.2256 0.35254 7.2183 0.11084z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m271.47 300.09c4.4893-0.41309 8.3989-2.9072 9.3882-2.6748 0.73291 0.16504 1.1562 1.6021 0.69678 2.3521-1.1279 1.8672-6.0601 3.8818-10.713 4.0757-2.5991 0.0488-5.5982 0.16064-6.3037-1.689-0.14551-0.38281-0.31738-1.915 0.73388-1.707 0.77784 0.0713 4.2466 0.002 6.1978-0.35693z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m273.08 300.07c3.5474-0.61768 6.0938-2.3013 6.9448-2.1138 0.71582 0.15332 1.1802 1.2349 0.75 1.9204-0.97461 1.5674-3.9453 2.9268-8.0054 3.3193-2.0967 0.15918-4.7251 0.6831-5.4502-0.88965-0.15137-0.32617-0.35693-1.4858 0.58496-1.4121 0.80176 0.004 3.2666-0.34912 5.1758-0.82422z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m279.2 298.5c0.69775 0.14209 1.2026 0.86817 0.80078 1.4878-0.81738 1.2671-1.8257 1.9692-5.2978 2.562-1.5908 0.27197-3.8501 1.208-4.5942-0.0879-0.15576-0.27002-0.39502-1.0571 0.43604-1.1191 0.82617-0.063 2.2861-0.69971 4.1538-1.2905 2.6069-0.82422 3.7866-1.6982 4.5015-1.5522z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ae11",
    d: "m283.76 307c0.78906 0.18652 1.102 2.6782 0.57031 3.6279-1.5684 2.7842-12.371 6.7866-18.779 6.4482-4.104-0.25635-8.2456-1.2217-8.9184-3.8867-0.13868-0.54736-0.35889-2.9434 1.1123-2.7109 3.0215 0.68115 5.8936 0.59179 9.3315 0.61425 7.292 0.15625 15.28-4.4404 16.684-4.0928z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccba22",
    d: "m283.35 307.29c0.77246 0.16015 1.1406 2.2876 0.65039 3.1807-1.3887 2.4976-10.214 5.8633-16.017 5.7886-3.5928-0.1128-7.3989-0.50782-8.1147-2.8779-0.14795-0.48877-0.43799-2.5742 0.89306-2.5415 2.544 0.41748 5.2749 0.27979 8.3823 0.1377 6.333-0.10059 12.938-3.978 14.206-3.6875z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6c734",
    d: "m282.94 307.57c0.75781 0.13526 1.1812 1.8955 0.72949 2.731-1.207 2.2119-8.0562 4.939-13.253 5.1318-3.082 0.0283-6.5518 0.20654-7.312-1.8721-0.15673-0.42872-0.51464-2.2036 0.67627-2.3711 2.0654 0.15576 4.6553-0.0303 7.4341-0.33838 5.3721-0.35595 10.594-3.5151 11.726-3.2812z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#dfd248",
    d: "m282.53 307.86c0.74072 0.10938 1.2183 1.5049 0.80957 2.2827-1.0274 1.9253-5.9004 4.0151-10.491 4.4746-2.5713 0.16943-5.7056 0.91894-6.5093-0.86622-0.16602-0.36914-0.59277-1.8345 0.45947-2.2017 1.5864-0.10351 4.0366-0.33984 6.4834-0.81396 4.4136-0.61084 8.2524-3.0518 9.248-2.8755z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#e9df5f",
    d: "m282.12 308.14c0.72461 0.0859 1.2554 1.1148 0.88965 1.835-0.84815 1.6392-3.7441 3.0913-7.73 3.8164-2.0606 0.3125-4.8594 1.6338-5.7051 0.13965-0.17627-0.30811-0.6709-1.4619 0.24023-2.0298 1.1089-0.36719 3.419-0.65137 5.5352-1.292 3.4526-0.86475 5.9082-2.5879 6.77-2.4692z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2ea77",
    d: "m281.72 308.43c0.70898 0.06 1.2949 0.72265 0.96728 1.3843-0.66602 1.354-1.5859 2.169-4.9644 3.1592-1.5493 0.4541-4.0127 2.3486-4.9023 1.1484-0.18555-0.24951-0.74853-1.0942 0.0234-1.8618 0.63037-0.62793 2.7993-0.96338 4.5854-1.7661 2.4932-1.1221 3.5644-2.126 4.2905-2.064z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m307.06 359.45c-0.6919 0.49414-1.54 0.78467-2.4556 0.78467-2.3408 0-4.2373-1.897-4.2373-4.2378 0-1.7915 1.2939-3.3228 2.9106-3.9438 4.813-0.2832 5.5122 5.7305 3.7822 7.397z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m303.63 352.37c-1.3335 0.52832-2.2773 1.8291-2.2773 3.3511 0 1.9898 1.6123 3.6006 3.602 3.6006 0.65039 0 1.2598-0.17139 1.7861-0.47314 2.0493-2.1802-0.67773-6.7256-3.1108-6.4785z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m303.78 352.89c-0.86621 0.51709-1.4453 1.4644-1.4453 2.5474 0 1.6382 1.3267 2.9658 2.9648 2.9658 0.39991 0 0.78125-0.0791 1.1279-0.22217 1.52-1.5864-1.0679-5.5034-2.6475-5.291z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m304.1 353.42c-0.47851 0.42822-0.78125 1.0488-0.78125 1.7412 0 1.2881 1.0435 2.3306 2.3306 2.3306 0.15137 0 0.29688-0.0137 0.43945-0.041 0.59912-1.1314-0.72949-3.7178-1.9888-4.0308z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m305.67 356.54c-0.7754-0.15625-1.3604-0.84033-1.3604-1.6621 0-0.27441 0.0654-0.53418 0.18164-0.76465 0.38282-0.0361 1.4839 1.6025 1.1787 2.4268z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "m302.52 350.3c-0.75684 0.6997-1.7686 1.1279-2.8794 1.1279-2.3408 0-4.2363-1.896-4.2363-4.2378 0-2.0478 1.688-3.7554 3.6187-4.1504 4.4546-0.0767 5.2934 4.3989 3.4971 7.2603z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m302.27 349.69c-0.6206 0.51172-1.4155 0.81787-2.2827 0.81787-1.9898 0-3.602-1.6128-3.602-3.602 0-1.7026 1.1812-3.1284 2.7686-3.5059 3.2002 0.0474 4.459 3.4741 3.1162 6.29z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m301.99 349.09c-0.47314 0.31982-1.0425 0.50586-1.6567 0.50586-1.6382 0-2.9648-1.3276-2.9648-2.9658 0-1.3042 0.84131-2.4121 2.0107-2.8091 1.9228-0.0195 3.812 3.0571 2.6108 5.269z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m301.7 348.45c-0.22901 0.24951-0.6504 0.23047-1.0127 0.23047-1.2871 0-2.3291-1.042-2.3291-2.3306 0-0.87745 0.48437-1.6416 1.2002-2.0391 1.5391-0.0903 3.0068 3.1978 2.1416 4.1392z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m301.32 347.74c-0.0937 0.0156-0.19092 0.0249-0.28906 0.0249-0.93604 0-1.6948-0.75879-1.6948-1.6958 0-0.46777 0.18995-0.89209 0.49707-1.1982 0.83741-0.1626 1.8164 1.9365 1.4868 2.8691z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m200.92 362.83c0.69239 0.49316 1.54 0.78467 2.4561 0.78467 2.3403 0 4.2373-1.897 4.2373-4.2373 0-1.792-1.2939-3.3242-2.9106-3.9443-4.8135-0.28418-5.5122 5.7314-3.7827 7.397z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m204.35 355.75c1.3335 0.52734 2.2773 1.8281 2.2773 3.3501 0 1.9897-1.6108 3.602-3.6006 3.602-0.65039 0-1.2612-0.17285-1.7871-0.47315-2.0493-2.1807 0.67822-6.727 3.1104-6.479z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m204.2 356.27c0.86572 0.51807 1.4453 1.4653 1.4453 2.5483 0 1.6372-1.3267 2.9648-2.9653 2.9648-0.39844 0-0.78027-0.0776-1.1279-0.22216-1.5186-1.5864 1.0684-5.5024 2.648-5.291z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m203.88 356.8c0.47852 0.42724 0.78125 1.0503 0.78125 1.7422 0 1.2876-1.043 2.3306-2.3301 2.3306-0.15039 0-0.29736-0.0146-0.43945-0.0415-0.59961-1.1314 0.72949-3.7192 1.9883-4.0312z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m202.31 359.92c0.77588-0.15576 1.3599-0.84033 1.3599-1.6621 0-0.27441-0.0659-0.53418-0.18067-0.76318-0.38427-0.0371-1.4849 1.6011-1.1792 2.4253z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "m204.39 353.71c0.75537 0.69922 1.7671 1.1279 2.8794 1.1279 2.3394 0 4.2363-1.8965 4.2363-4.2373 0-2.0478-1.6895-3.7554-3.6201-4.1514-4.4531-0.0757-5.293 4.3999-3.4956 7.2607z",
    stroke: "#7f7100",
    strokeWidth: 0.55959,
    fill: "#b9a400"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9a70e",
    d: "m204.63 353.11c0.62207 0.51025 1.417 0.81787 2.2842 0.81787 1.9883 0 3.6006-1.6128 3.6006-3.603 0-1.7017-1.1797-3.1289-2.7671-3.5039-3.2012 0.0454-4.46 3.4722-3.1177 6.2891z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9aa17",
    d: "m204.91 352.51c0.47314 0.31836 1.0425 0.50342 1.6553 0.50342 1.6382 0 2.9663-1.3267 2.9663-2.9663 0-1.3027-0.84131-2.4106-2.0112-2.8081-1.9238-0.02-3.8125 3.0566-2.6104 5.271z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9ad22",
    d: "m205.21 351.86c0.22949 0.25049 0.64941 0.23145 1.0132 0.23145 1.2856 0 2.3291-1.0435 2.3291-2.3306 0-0.87744-0.48437-1.6416-1.2012-2.0391-1.5391-0.0903-3.0068 3.1978-2.1411 4.1382z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9af2e",
    d: "m205.58 351.16c0.0937 0.0156 0.19092 0.0249 0.28906 0.0249 0.93604 0 1.6948-0.75977 1.6948-1.6958 0-0.46778-0.18994-0.89209-0.49707-1.1982-0.83887-0.16114-1.8179 1.9365-1.4868 2.8691z"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    strokeWidth: 1.6785,
    stroke: "#7f7100",
    cy: 249.56,
    cx: 249.97,
    r: 184.14,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmblemOfTheUsDepartmentOfTheArmy);
export default __webpack_public_path__ + "static/media/Emblem_of_the_U.S._Department_of_the_Army.56e3ebebb8058facca7f5c1ccac8f0e1.svg";
export { ForwardRef as ReactComponent };